{
  "app": {
    "language": "Langue",
    "openMenu": "Ouvrir le menu",
    "closeMenu": "Fermer le menu",
    "brandLogoAlt": "BCS HR Software",
    "footerAdmin": "BCS Learning — Admin",
    "footerTenant": "BCS Learning — {tenant}",
    "footerTenantFallback": "BCS Learning",
    "superadmin": {
      "title": "Superadmin"
    },
    "tenant": {
      "title": "Votre espace de travail"
    }
  },
  "nav": {
    "catalog": "Catalogue",
    "myEnrollments": "Mes inscriptions",
    "myQuestionnaires": "Mes questionnaires",
    "myQualifications": "Mes qualifications",
    "dashboard": "Tableau de bord",
    "tenants": "Tenants",
    "platformAssets": "Médiathèque",
    "platformLocales": "Langues",
    "superadmins": "Superadmins",
    "settings": "Paramètres",
    "users": "Utilisateurs",
    "orgUnits": "Unités organisationnelles",
    "localeOverrides": "Textes",
    "mailOutbox": "Boîte d'envoi",
    "sendMessage": "Envoyer un message",
    "mailTemplates": "Textes d'e-mail",
    "workflows": "Workflows",
    "platformWorkflows": "Workflows plateforme",
    "approvals": "Approbations",
    "approvalsOverview": "Toutes les approbations",
    "badgePending": "{count} en attente",
    "mainNavigation": "Navigation principale",
    "logout": "Se déconnecter",
    "changeLanguage": "Changer de langue",
    "themeDark": "Mode sombre",
    "themeLight": "Mode clair",
    "openAdminConsole": "Ouvrir la console d'administration",
    "openApp": "Vers l'application",
    "cancellationReasons": "Motifs d'annulation",
    "questionnaires": "Questionnaires",
    "locations": "Lieux de formation",
    "externalPeople": "Personnes externes",
    "externalCompanies": "Entreprises externes",
    "approvalFlows": "Flux d'approbation",
    "roles": "Rôles et droits",
    "attendance": "Présence",
    "auditLog": "Journal",
    "accessGroups": "Groupes d’accès",
    "ltiProviders": "Connexions LTI",
    "groupUsersOrg": "Utilisateurs et organisation",
    "groupCatalogs": "Catalogues",
    "groupLearning": "Offre de formation",
    "groupMessaging": "E-mails et messages",
    "tests": "Tests",
    "grading": "Correction",
    "results": "Résultats",
    "qualifications": "Qualifications",
    "externalRequestTypes": "Formation externe (configuration)",
    "themes": "Catégories",
    "media": "Médiathèque",
    "groupResources": "Ressources",
    "documentTemplates": "Modèles de documents"
  },
  "myEnrollments": {
    "title": "Mes inscriptions",
    "description": "Un aperçu des activités auxquelles vous êtes inscrit et de leur statut.",
    "empty": "Vous n'avez encore aucune inscription.",
    "emptyCta": "Parcourir le catalogue",
    "error": "Nous n'avons pas pu charger vos inscriptions.",
    "retry": "Réessayer",
    "untitled": "Activité sans titre",
    "controlsLabel": "Trier et filtrer",
    "sortLabel": "Trier",
    "sort": {
      "dateAsc": "Date de début (croissant)",
      "dateDesc": "Date de début (décroissant)"
    },
    "filter": {
      "showHistory": "Afficher l'historique"
    },
    "groupActive": "Actives",
    "groupHistory": "Historique",
    "noActive": "Vous n'avez aucune inscription active.",
    "noHistory": "Vous n'avez encore aucune inscription terminée ou annulée.",
    "partOf": "Partie de {title}",
    "certificate": {
      "filename": "certificat",
      "download": "Télécharger le certificat",
      "inProgress": "Certificat en cours de création",
      "downloadFailed": "Le certificat n'a pas pu être téléchargé. Veuillez réessayer plus tard.",
      "revoked": "Révoqué"
    }
  },
  "myLearningPath": {
    "notFound": "Nous n'avons pas trouvé ce parcours.",
    "error": "Nous n'avons pas pu charger votre parcours.",
    "retry": "Réessayer",
    "progressTitle": "Progression",
    "progress": "{done} parties obligatoires terminées sur {total}",
    "noRequired": "Ce parcours n'a pas de parties obligatoires.",
    "sequentialHint": "Vous suivez les parties dans l'ordre. Une partie s'ouvre dès que la précédente est terminée.",
    "partsTitle": "Parties",
    "noParts": "Ce parcours n'a pas encore de parties.",
    "reference": "Référence",
    "completedOn": "Terminé le {date}",
    "state": {
      "to_schedule": "À planifier",
      "locked": "Verrouillée",
      "not_started": "Pas commencée",
      "in_progress": "En cours",
      "completed": "Terminée",
      "previously_completed": "Déjà obtenue",
      "exempted": "Dispensée",
      "not_passed": "Non réussie",
      "expired": "Expirée",
      "cancelled": "Annulée"
    },
    "detail": {
      "completedOn": "Terminée le {date}",
      "previouslyCompletedOn": "Terminée le {date}, déjà obtenue auparavant",
      "lockedBy": "S'ouvre dès que vous avez terminé {title}.",
      "toSchedule": "Pour cette partie, vous choisissez une session avec une date. Ce sera bientôt possible ici.",
      "notPassed": "Vous avez terminé cette partie, mais vous ne l'avez pas réussie.",
      "expired": "Vous aviez obtenu cette partie, mais elle n'est plus valable."
    }
  },
  "catalog": {
    "structural": {
      "locked": {
        "enrollments": "Modification impossible : cette formation compte déjà des inscriptions.",
        "attempts": "Modification impossible : ce module e-learning a déjà été commencé.",
        "completions": "Modification impossible : cette formation compte déjà des achèvements."
      },
      "warnTitle": "Cette formation est déjà publiée",
      "warnBody": "Vous modifiez un élément qui détermine le sens d’une inscription ou d’un achèvement. Il n’y a pas encore d’inscriptions, c’est donc encore possible. Dès qu’une personne s’inscrit, cet élément est figé.",
      "warnConfirm": "Enregistrer quand même",
      "field": {
        "composition": "La composition",
        "type": "Le type",
        "source_kind": "La source",
        "source_url": "Le lien",
        "source_package_id": "Le module e-learning",
        "source_lti_provider_id": "Le fournisseur LTI",
        "tracking_mode": "Activité ou ressource de consultation",
        "completion_rule": "La règle d’achèvement",
        "completion_threshold": "Le pourcentage de la règle d’achèvement",
        "sources": "Le contenu dans une autre langue",
        "items": "Les éléments, ou lesquels sont obligatoires"
      }
    },
    "detail": {
      "back": "Retour au catalogue",
      "backToMyEnrollments": "Retour à mes inscriptions",
      "duration": "Durée",
      "durationMinutes": "{count} min",
      "category": "Catégorie",
      "contentManagers": "Gestionnaires",
      "occurrences": "Séances planifiées",
      "noOccurrences": "Aucune séance n'est encore planifiée.",
      "items": "Composants",
      "noItems": "Il n'y a pas encore de composants.",
      "notFound": "Activité introuvable",
      "ctaSoon": "Bientôt disponible",
      "studyLoad": "Charge d'étude",
      "description": "Description",
      "details": "Détails",
      "language": "Langue",
      "themes": "Catégories",
      "tags": "Mots-clés",
      "tracking": "Suivi",
      "trackingYes": "Oui — compte comme à faire et fait",
      "trackingNo": "Non — documentation de référence",
      "planned_one": "{count} session planifiée",
      "planned_other": "{count} sessions planifiées",
      "spotsTotal_one": "{count} place disponible",
      "spotsTotal_other": "{count} places disponibles",
      "chooseBelow": "choisissez une session ci-dessous pour vous inscrire",
      "approvalHint": "Après votre inscription, le système demande l’approbation de votre responsable ; vous recevrez une confirmation par e-mail.",
      "directHint": "Vous recevrez immédiatement une confirmation par e-mail.",
      "approval": "Approbation",
      "approvalRequired": "Requise",
      "approvalNotRequired": "Non requise",
      "spotsOf": "{left} places disponibles sur {total}",
      "fullWaitlist": "Complet — liste d’attente",
      "days_one": "{count} jour",
      "days_other": "{count} jours",
      "dayN": "Jour {n}",
      "enrollUntil": "Inscription jusqu’au {date}",
      "itemsOrdered": "Parties (dans l’ordre)",
      "itemsOrderedHint": "Chaque partie s’ouvre dès que la précédente est terminée.",
      "itemsFreeHint": "Pas d’ordre imposé — parcourez les parties comme vous le souhaitez.",
      "openInLanguage": "Ouvrir dans une autre langue",
      "ownLanguage": "Ma propre langue"
    },
    "error": {
      "title": "Une erreur est survenue",
      "retry": "Réessayer"
    },
    "launch": {
      "start": "Commencer",
      "resume": "Reprendre",
      "review": "Revoir",
      "open": "Ouvrir",
      "error": "L’ouverture a échoué.",
      "restart": "Recommencer",
      "restartTitle": "Recommencer ?",
      "restartBody": "Vous reprenez cette formation depuis le début. Votre progression dans la formation est effacée ; votre résultat est conservé."
    },
    "enroll": {
      "action": "S'inscrire",
      "full": "Complet",
      "closed": "Inscriptions closes",
      "success": "Vous êtes inscrit.",
      "requested": "Votre demande a été envoyée. Vous serez informé dès qu'une décision aura été prise.",
      "waitlisted": "Vous êtes sur la liste d'attente. Vous n'êtes pas encore inscrit — vous serez informé dès qu'une place se libère.",
      "error": "L'inscription a échoué.",
      "elsewhere": "Vous êtes déjà inscrit le {date}",
      "waitlistedElsewhere": "Vous êtes déjà sur la liste d’attente du {date}",
      "spotsLeft": "{count} places restantes",
      "awaitingApproval": "En attente d’approbation",
      "joinWaitlist": "S’inscrire sur la liste d’attente",
      "onWaitlist": "Sur la liste d’attente",
      "offerPending": "Une place est disponible — acceptez votre offre",
      "offerAcceptBy": "Une place est disponible — acceptez avant le {date}",
      "acceptOffer": "Accepter",
      "declineOffer": "Refuser"
    },
    "cancel": {
      "button": "Annuler",
      "requestButton": "Demander l'annulation",
      "pending": "Annulation en cours de traitement",
      "confirmTitle": "Annuler l’inscription ?",
      "confirmBody": "Êtes-vous sûr de vouloir annuler votre inscription ? Cette action est irréversible.",
      "reasonLabel": "Motif (facultatif)",
      "confirm": "Oui, annuler",
      "keep": "Conserver",
      "cancelled": "Annulée — motif : {reason}",
      "reasonSelectLabel": "Motif",
      "reasonSelectPlaceholder": "— Choisissez un motif —",
      "cancelledReason": "Motif : {reason}",
      "cancelledNote": "Annulée — motif :"
    },
    "cancellationMode": {
      "self": "Annulation libre",
      "needs_approval": "Avec approbation",
      "not_allowed": "Non autorisée"
    },
    "waitlistPromotionMode": {
      "auto_enter": "Passage automatique",
      "invite": "Proposer la place"
    },
    "enrollmentLimit": {
      "one": "1 (par défaut)",
      "multiple": "Plusieurs"
    },
    "deliveryMode": {
      "klassikaal": "En présentiel",
      "virtual_classroom": "Classe virtuelle",
      "blended": "Mixte (blended)"
    },
    "enrollmentStatus": {
      "enrolled": "Inscrit",
      "pending": "En attente",
      "offered": "Place proposée",
      "waitlisted": "Sur liste d'attente",
      "rejected": "Refusé",
      "cancelled": "Annulé",
      "expired": "Expiré",
      "finalized": "Traité"
    },
    "heading": "Gestion du catalogue",
    "intro": "Gérez toutes les activités d’apprentissage.",
    "new": "Nouvelle activité",
    "settingsLink": "Paramètres",
    "empty": "Aucune activité d’apprentissage — créez-en une.",
    "backToList": "Retour au catalogue",
    "filter": {
      "search": "Rechercher par titre ou résumé…",
      "status": "Statut",
      "all": "Tous",
      "searchPlaceholder": "Rechercher dans le catalogue",
      "themes": "Catégorie",
      "type": "Type",
      "composition": "Format",
      "tracking": "Nature",
      "category": "Catégorie",
      "sort": "Trier",
      "reset": "Effacer les filtres",
      "activeLabel": "Filtres actifs",
      "removeFilter": "Retirer le filtre : {filter}",
      "completionRule": "Règle de validation",
      "completionRuleMissing": "Aucune règle définie",
      "heading": "Filtres",
      "language": "Langue",
      "clear": "Effacer",
      "onlyWith": "Uniquement avec {name}"
    },
    "presentation": {
      "activiteit": "Activité",
      "naslag": "Référence"
    },
    "type": {
      "e_learning": "E-learning",
      "assessment": "Évaluation",
      "meeting": "Réunion",
      "content": "Contenu/médias",
      "social": "Social",
      "workplace": "Sur le terrain",
      "external": "Formation externe"
    },
    "composition": {
      "single": "Activité",
      "learning_path": "Parcours",
      "bundle": "Lot"
    },
    "source": {
      "manual": "Manuel",
      "file": "Fichier",
      "link": "Lien",
      "scorm_xapi": "Paquet e-learning (SCORM)",
      "lti": "LTI",
      "session": "Session / présence"
    },
    "status": {
      "concept": "Brouillon",
      "published": "Publié",
      "hidden": "Masqué",
      "archived": "Archivé"
    },
    "unavailable": {
      "ltiProviderInactive": "Hors catalogue : connexion désactivée"
    },
    "columns": {
      "title": "Titre",
      "composition": "Composition",
      "type": "Type",
      "soort": "Genre",
      "status": "Statut",
      "actions": "Actions",
      "completionRule": "Achèvement",
      "themes": "Catégories"
    },
    "actions": {
      "edit": "Modifier",
      "changeStatus": "Changer le statut…",
      "duplicate": "Dupliquer",
      "delete": "Supprimer",
      "planning": "Planification",
      "export": "Exporter ({count})"
    },
    "bulk": {
      "label": "Actions groupées",
      "selected": "{count} sélectionné(s)",
      "selectAllMatching": "Sélectionner les {count} éléments correspondant à ce filtre",
      "allMatchingSelected": "Les {count} éléments correspondant à ce filtre",
      "limitToSelection": "Limiter aux lignes cochées"
    },
    "confirm": {
      "archiveTitle": "Archiver l’activité (les activités) ?",
      "archiveBody": "Ceci archive {count} activité(s) ; elles quittent le catalogue mais restent dans les enregistrements.",
      "deleteTitle": "Supprimer le brouillon ?",
      "deleteBody": "« {title} » sera définitivement supprimé. Cette action est irréversible.",
      "bulkTitle": "Modifier le statut ?",
      "allMatchingBody": "Cette action fait passer {count} activité(s) à « {status} » — y compris celles qui ne sont pas affichées actuellement."
    },
    "feedback": {
      "statusChanged": "{count} activité(s) → {status}.",
      "duplicated": "« {title} » dupliqué en brouillon.",
      "deleted": "« {title} » supprimé.",
      "bulkDuplicated": "{count} copie(s) créée(s).",
      "archivedPartlyHidden": "{count} activité(s) traitée(s) ; {hidden} d’entre elles sont Masquées car des sessions étaient encore en cours."
    },
    "fields": {
      "title": "Titre",
      "summary": "Résumé",
      "description": "Description",
      "category": "Catégorie",
      "durationMinutes": "Durée (minutes)",
      "image": "Image",
      "imagePreviewAlt": "Aperçu de l’image choisie",
      "imageHelp": "Choisissez une image dans la médiathèque, récupérez-en une via une adresse ou Pexels, ou téléversez-en une depuis votre ordinateur. Sans image propre, l’élément affiche l’image par défaut de l’environnement.",
      "removeImage": "Supprimer l’image",
      "sourceUrl": "Adresse web",
      "sourceUrlHelp": "Où le participant arrive.",
      "neededToPublish": "Nécessaire pour publier ; un brouillon peut s’en passer.",
      "sourceFile": "Le fichier",
      "sourceFileHelp": "Le document que le participant ouvre. Seules les personnes autorisées à voir la formation peuvent le télécharger.",
      "sourceFileSaveFirst": "Enregistrez d'abord cette formation comme brouillon ; vous pourrez ensuite ajouter le fichier. La publication exige un fichier.",
      "ltiProvider": "Fournisseur LTI",
      "ltiProviderHelp": "Chez quel fournisseur cette formation se déroule.",
      "ltiProviderNew": "Ajouter un nouveau fournisseur",
      "ltiLaunchUrl": "Adresse du cours",
      "ltiLaunchUrlHelp": "L'adresse de ce cours précis chez le fournisseur. Si vous laissez ce champ vide, nous utilisons l'adresse par défaut du fournisseur — ce qui n'est correct que s'il ne propose qu'un seul cours. La publication exige l'un des deux.",
      "ltiPickCourse": "Choisir un cours chez le fournisseur",
      "ltiPickCourseSaveFirst": "Vous pourrez choisir le cours chez le fournisseur dès que cette formation sera enregistrée. Le choix vous fait quitter cet écran : enregistrez-la d'abord comme brouillon, sinon vous perdrez ce que vous êtes en train de saisir.",
      "ltiPickCourseConfirmTitle": "Cette formation comporte déjà des résultats",
      "ltiPickCourseConfirmBody_one": "{count} résultat est déjà enregistré pour le cours actuellement associé. Il est conservé : les personnes ayant terminé la formation le gardent. Désormais, les nouveaux participants suivront le cours que vous allez choisir.",
      "ltiPickCourseConfirmBody_other": "{count} résultats sont déjà enregistrés pour le cours actuellement associé. Ils sont conservés : les personnes ayant terminé la formation les gardent. Désormais, les nouveaux participants suivront le cours que vous allez choisir.",
      "ltiPickCourseConfirmAction": "Choisir le cours",
      "sourceFileReplaceConfirmTitle": "Des personnes ont déjà terminé avec le fichier actuel",
      "sourceFileReplaceConfirmBody_one": "{count} personne a déjà terminé cette activité avec le fichier précédent ; cet achèvement est conservé. Toute personne qui ouvre l’activité à partir de maintenant reçoit le nouveau fichier.",
      "sourceFileReplaceConfirmBody_other": "{count} personnes ont déjà terminé cette activité avec le fichier précédent ; leurs achèvements sont conservés. Toute personne qui ouvre l’activité à partir de maintenant reçoit le nouveau fichier.",
      "sourceFileReplaceConfirmAction": "Remplacer le fichier",
      "ltiProviderNoAccess": "Vous n'êtes pas autorisé à consulter les intégrations de cet environnement. Demandez à un administrateur de choisir le fournisseur.",
      "ltiProviderInactive": "{name} (désactivé)",
      "package": "Le fichier e-learning",
      "packageHint": "Un fichier zip, tel que vous le recevez du fournisseur. Nécessaire pour publier.",
      "packageHintWithMax": "Un fichier zip, tel que vous le recevez du fournisseur, jusqu’à {max} Mo. Nécessaire pour publier.",
      "packageChoose": "Choisir un fichier",
      "packageReplace": "Téléverser un autre fichier",
      "packageTry": "Essayer",
      "packageTryHint": "Ouvre la formation dans un nouvel onglet, exactement comme la voit un participant. Rien n'est enregistré : ni progression, ni résultat, ni achèvement.",
      "packageTryBlocked": "Votre navigateur a bloqué le nouvel onglet. Autorisez les fenêtres pop-up pour cette page, puis réessayez.",
      "packageTryFailed": "La formation n'a pas pu être ouverte. Veuillez réessayer.",
      "packagePresent": "Un fichier est associé",
      "packageUploading": "Téléversement",
      "packageProgress": "Téléversement — {percent} %",
      "packageInspecting": "Le fichier est en cours de vérification…",
      "packageAccepted": "Une formation trouvée : {title}",
      "packageAcceptedUntitled": "Une formation trouvée. Le fichier ne porte pas de titre propre.",
      "packageNotes": "Ce qui a été adapté ou omis dans ce fichier :",
      "packageRejected": "Ce fichier ne peut pas être utilisé tel quel :",
      "packageNeedsChoice": "Ce fichier contient plus d’un e-learning :",
      "completionRule": "Quand est-ce terminé ?",
      "completionRuleHint": "Il n'y a délibérément aucune valeur par défaut : indiquez vous-même quand cette formation est terminée. Tant que ce champ est vide, personne ne la termine.",
      "completionRuleProgressUnavailable": "L'achèvement sur le pourcentage parcouru n'est pas possible ici : ce fichier n'enregistre pas où en est la personne.",
      "completionRuleNone": "Pas encore choisi",
      "completionRuleFixed": "Cette source ne laisse rien à choisir : ici, terminé signifie {rule}.",
      "completionThreshold": "Pourcentage",
      "completionThresholdHint": "Un nombre entre 1 et 100.",
      "progressResetDays": "Validité de l'achèvement",
      "progressResetDaysHint": "Vide = n’expire jamais.",
      "progressResetDaysHelp": "Après combien de jours une réussite expire et l’apprenant doit refaire la formation. Le décompte démarre à l’achèvement.",
      "choose": "Choisir…",
      "summaryHint": "Trois lignes au maximum, 200 caractères au plus.",
      "summaryHelp": "Un texte court pour la carte et le haut de l’article.",
      "contentManagers": "Gestionnaires de contenu",
      "contentManagersPlaceholder": "Rechercher une personne",
      "contentManagersHint": "Peuvent gérer cette activité : les informations de base et la source/le matériel. Le rôle de gestionnaire de contenu accorde les droits.",
      "contentManagerNoRole": "{name} n’a pas le rôle de gestionnaire de contenu et ne peut donc pas modifier cette activité.",
      "educators": "Organisme(s) de formation",
      "educatorsPlaceholder": "Choisir un organisme",
      "educatorsHint": "Détermine quels formateurs vous pouvez choisir lors de la planification. Vide signifie aucune restriction.",
      "educatorInternal": "Interne",
      "translationHint": "Si vous laissez un texte vide dans cette langue, le lecteur le voit dans la langue de l’environnement.",
      "languageInUse_one": "La langue {language} est encore utilisée par 1 session ({dates}). Sans titre, cette langue disparaît, ce qui n’est possible qu’après avoir d’abord choisi une autre langue pour celle-ci.",
      "languageInUse_other": "La langue {language} est encore utilisée par {count} sessions ({dates}). Sans titre, cette langue disparaît, ce qui n’est possible qu’après avoir d’abord choisi une autre langue pour celles-ci."
    },
    "version": {
      "breaking": "Le cours a été modifié en profondeur",
      "breakingHint": "Les participations en cours sont clôturées et recommencent. Nécessaire lorsque des parties ont été supprimées ou réorganisées — sinon quelqu'un revient à un endroit qui n'existe plus.",
      "closedAttempts": "Version changée. {count} participation(s) en cours clôturée(s) ; ces personnes recommencent.",
      "compatibilityLegend": "Que signifie cette version pour les participations en cours ?",
      "compatible": "Le cours est globalement identique",
      "compatibleHint": "Les personnes en cours de parcours reprennent là où elles s'étaient arrêtées. Ne choisissez ceci que si la structure du cours n'a pas changé.",
      "heading": "Nouvelle version",
      "intro": "Cet e-learning est déjà publié avec un paquet. Un nouveau fichier remplace la version pour tout le monde : indiquez donc d'abord ce que le changement signifie pour les personnes en cours de parcours.",
      "noAttemptsClosed": "Version changée. Il n'y avait aucune participation en cours.",
      "restartConfirm": "Faire recommencer",
      "restartOpen": "Faire recommencer les participations",
      "restartReason": "Motif",
      "restartWarning": "Ceci clôture toutes les participations en cours sur la version actuelle. La progression et les signets sont perdus ; les résultats terminés sont conservés.",
      "switch": "Changer de version",
      "viewResults": "Voir les résultats"
    },
    "elearningResults": {
      "actions": "Actions",
      "back": "Retour à l'activité",
      "correctError": "La correction n'a pas pu être enregistrée.",
      "correctFor": "Corriger le résultat de {name}",
      "correctedNote": "Corrigé le {date}",
      "effective": "S'applique",
      "empty": "Personne n'a commencé cet e-learning.",
      "failed": "Non réussi",
      "heading": "Résultats",
      "intro": "Qui a commencé cet e-learning, où en est la personne et quel résultat s'applique. Une correction manuelle se place à côté de ce que le cours a rapporté — les deux restent visibles.",
      "lastActivity": "Dernière activité",
      "loadError": "Les résultats n'ont pas pu être chargés.",
      "next": "Suivant",
      "pageOf": "Page {page} sur {total}",
      "pagination": "Pagination",
      "passed": "Réussi",
      "person": "Personne",
      "prev": "Précédent",
      "reason": "Motif",
      "reasonHint": "Figure dans le journal et répond à « pourquoi cette note ? ».",
      "reported": "Rapporté",
      "resetConfirm": "Réinitialiser la progression",
      "resetError": "La progression n'a pas pu être réinitialisée.",
      "resetFor": "Réinitialiser la progression de {name}",
      "resetKeepsCompletion": "La validation de {name} est conservée : elle a été obtenue dans une autre langue.",
      "resetLanguage": "Langue",
      "resetLanguageHint": "Seule la progression dans cette langue est réinitialisée. Présélectionnée : la langue dans laquelle {name} a travaillé en dernier.",
      "resetPreviewError": "Impossible de charger l'effet de la réinitialisation. Veuillez réessayer.",
      "resetReason": "Motif",
      "resetReasonHint": "Figure dans le journal de {name} et constitue la réponse qui pourra lui être donnée plus tard.",
      "resetWarn": "La progression de {name} dans cet e-learning sera clôturée. L'accès est conservé ; {name} pourra ensuite recommencer.",
      "resetWarnLanguage": "La progression de {name} dans la langue {language} sera clôturée ; les autres langues restent inchangées. L'accès est conservé ; {name} pourra ensuite recommencer.",
      "resetWarnLanguageWithCompletion": "{name} a terminé cet e-learning dans la langue {language}. Cette validation sera retirée — elle reste consultable comme retirée, mais ne compte plus à partir de maintenant. Les autres langues restent inchangées ; l'accès est conservé.",
      "resetWarnWithCompletion": "{name} a terminé cet e-learning. Cette validation sera retirée — elle reste consultable comme retirée, mais ne compte plus à partir de maintenant. L'accès est conservé ; {name} pourra ensuite recommencer.",
      "save": "Enregistrer la correction",
      "scoreHint": "Laissez vide si vous ne modifiez que le verdict.",
      "scorePercent": "Score (%)",
      "scoreRange": "Saisissez un nombre de 0 à 100.",
      "status": "Statut",
      "statuses": {
        "closed": "Clôturé",
        "completed": "Terminé",
        "in_progress": "En cours"
      },
      "superseded": {
        "admin_reset": "Réinitialisé par un administrateur",
        "breaking_version": "Clôturé par une nouvelle version profondément modifiée",
        "forced_restart": "Clôturé par un redémarrage forcé",
        "learner_restart": "Recommencé par le participant",
        "progress_reset": "Expiré — l'achèvement n'était plus valable"
      },
      "unknownUser": "Utilisateur inconnu",
      "verdict": "Verdict",
      "verdictNone": "Aucun verdict"
    },
    "wizard": {
      "newTitle": "Nouvelle activité d’apprentissage",
      "editTitle": "Modifier l’activité",
      "needType": "Choisissez un type.",
      "needTitle": "Le titre est obligatoire.",
      "needSummary": "Saisissez un résumé.",
      "needDescription": "Saisissez une description.",
      "occurrencesFollowTitle": "Renommer aussi les sessions portant l’ancien titre ({n})",
      "occurrencesFollowTitleHelp": "Les sessions intitulées actuellement « {title} » prennent le nouveau titre. Les sessions ayant leur propre sujet restent inchangées.",
      "source": "Source / matériel",
      "sourceNone": "— aucune —",
      "tracking": "Suivi",
      "ready": "Prêt à publier.",
      "publish": "Publier",
      "saveConcept": "Enregistrer comme brouillon",
      "save": "Enregistrer",
      "next": "Suivant",
      "published": "« {title} » publié.",
      "savedConcept": "« {title} » enregistré comme brouillon.",
      "publishAt": "Publier le (facultatif)",
      "publishAtHint": "Vide : vous publiez vous-même.",
      "publishAtHelp": "Avec une date, l’activité reste un brouillon et est publiée automatiquement à ce moment, avec les mêmes contrôles que pour une publication immédiate.",
      "publishAtPast": "Choisissez un moment dans le futur.",
      "schedule": "Programmer",
      "scheduled": "« {title} » est programmée : publication le {date}.",
      "grantsFailed": "« {title} » a été créée, mais une ou plusieurs qualifications n’ont pas pu être liées. Liez-les à nouveau ci-dessous.",
      "saved": "« {title} » enregistré.",
      "saveInvalid": "L’enregistrement a échoué : un ou plusieurs champs ne sont pas corrects. Les étapes marquées d’un point d’exclamation indiquent ce qui ne va pas.",
      "statusInListHint": "La publication, le masquage et l’archivage se font dans la liste via « Changer le statut ».",
      "step": {
        "type": "Type",
        "bron": "Source / matériel",
        "resultaten": "Résultats",
        "basis": "Informations de base",
        "details": "Détails",
        "controle": "Vérifier et publier",
        "compositie": "Composition",
        "zichtbaarheid": "Visibilité",
        "inschrijven": "Inscription",
        "onderdelen": "Composants"
      },
      "section": {
        "classificatie": "Classement",
        "people": "Personnes impliquées",
        "fields": "Caractéristiques",
        "what": "Ce que c’est",
        "texts": "Textes",
        "time": "Temps",
        "material": "Matériel",
        "completion": "Achèvement",
        "anonymous": "Sans connexion",
        "enrolling": "Inscription",
        "waitlist": "Liste d’attente",
        "deadlines": "Dates limites et annulation",
        "certificate": "Certificat"
      },
      "finished": {
        "question": "Voulez-vous planifier maintenant ou retourner à la liste ?",
        "planNow": "Continuer vers la planification",
        "backToList": "Retour à la liste"
      },
      "sourceHint": "La source détermine ce qui peut être suivi ; seules les sources compatibles avec le type sont sélectionnables.",
      "trackingHint": "Activité = à faire/fait (peut compter pour la PE) ; Référence = consultation seule.",
      "compositionHint": "Activité = une activité d’apprentissage · Parcours = ordonné (peut débloquer un certificat) · Ensemble = groupe non ordonné.",
      "needOnderdeel": "Un parcours/ensemble nécessite au moins un composant.",
      "basicsOnlyNotice": "Vous êtes gestionnaire de contenu de cette activité : vous modifiez les informations de base et la source/le matériel. La visibilité, l’inscription, les résultats et la planification sont gérés par une personne disposant de droits d’administration pour tout l’environnement.",
      "required": {
        "heading": "Minimum requis pour publier",
        "legend": "Les champs marqués d'un * sont obligatoires.",
        "done": "(rempli)",
        "missing": "(manque encore)",
        "onePart": "Au moins un élément"
      },
      "fieldShowToLearner": "Afficher {name} au participant"
    },
    "plannen": {
      "problem": {
        "needsDay": "Il n’y a encore aucun jour. Ajoutez au moins un jour.",
        "needsDate_one": "Le jour {days} n’a pas encore de date. Saisissez une date pour chaque jour.",
        "needsDate_other": "Les jours {days} n’ont pas encore de date. Saisissez une date pour chaque jour.",
        "needsStartTime": "Le jour 1 n’a pas encore d’heure de début. Saisissez une heure de début pour le premier jour."
      },
      "problemFor": "Session {n} : {problem}",
      "uitvoering": "Session {n}",
      "removeUitvoering": "Supprimer la session",
      "minParticipants": "Participants min.",
      "maxParticipants": "Participants max.",
      "minParticipantsHelp": "En dessous de ce nombre, la session n’a en principe pas lieu. La planification vous avertit si le minimum n’est pas atteint ; c’est vous qui confirmez ou annulez.",
      "maxParticipantsHelp": "Nombre de places disponibles. Quand la session est complète, les nouvelles demandes passent en liste d’attente, si elle est activée. Vide = pas de maximum.",
      "deadline": "Date limite d’inscription",
      "deadlineHelp": "Les participants peuvent s’inscrire jusqu’à ce jour inclus. Elle est calculée à partir du premier jour ; si vous saisissez vous-même une date, celle-ci est conservée.",
      "description": "Description complémentaire",
      "descriptionHint": "5000 caractères au maximum.",
      "descriptionHelp": "Informations complémentaires sur cette session pour les participants, par exemple ce qu’il faut apporter ou comment trouver la salle. Elles figurent avec la session dans le catalogue ; dans une invitation d’agenda, elles apparaissent sans mise en forme.",
      "occurrenceTitle": "Titre de la session",
      "occurrenceTitleHint": "Laissez vide ou identique à l’activité s’il n’y a pas de sujet propre.",
      "occurrenceTitleHelp": "Le sujet de cette session, lorsque l’activité porte un nom générique. Les participants le voient sous le titre de l’activité.",
      "day": "Jour {n}",
      "removeDay": "Supprimer le jour",
      "date": "Date",
      "dateMissing": "Saisissez une date.",
      "startTimeMissing": "Saisissez une heure de début.",
      "from": "De",
      "to": "À",
      "location": "Lieu de formation",
      "locationPlaceholder": "Choisissez ou saisissez…",
      "locationEntity": "Lieu de formation (dans la liste)",
      "locationNone": "Aucun lieu de formation",
      "locationCapacityWarning": "Le nombre max. de participants ({max}) dépasse la capacité de ce lieu ({capacity}). Choisissez un lieu plus grand ou réduisez le maximum.",
      "deliveryMode": "Mode de diffusion",
      "deliveryModeNone": "Aucun choix",
      "trainer": "Formateur",
      "trainerNone": "Aucun formateur",
      "trainerExternalGroup": "Personnes externes",
      "trainerInternalGroup": "Personnel interne",
      "lunch": "Déjeuner",
      "diner": "Dîner",
      "overnight": "Nuitée",
      "addDay": "+ Ajouter un jour",
      "maxEnrollments": "Nombre d’inscriptions",
      "maxEnrollmentsHint": "Combien de fois une personne peut être inscrite activement en même temps à cette activité (toutes sessions confondues).",
      "maxWaitlistRegistrations": "Nombre d’inscriptions sur liste d’attente",
      "maxWaitlistRegistrationsHint": "Combien de places sur liste d’attente une personne peut occuper en même temps pour cette activité. Dès qu’une place est traitée, la place sur liste d’attente se libère.",
      "waitlistEnabled": "Liste d’attente",
      "waitlistEnabledHint": "Lorsqu’une session est complète, les apprenants peuvent s’inscrire sur la liste d’attente. Quand une place se libère, elle est attribuée selon la méthode que vous choisissez. Suivre l’environnement : la valeur par défaut des paramètres du catalogue s’applique, même si elle change plus tard.",
      "waitlistFollowDefaultOn": "Suivre l’environnement (actuellement activée)",
      "waitlistFollowDefaultOff": "Suivre l’environnement (actuellement désactivée)",
      "promotionMode": "Quand une place se libère",
      "offerWindowHours": "Délai d’acceptation (heures)",
      "offerWindowHoursHint": "Nombre d’heures pendant lesquelles une place proposée reste réservée avant expiration de l’offre. Laissez vide pour la valeur par défaut du système (48 heures).",
      "offerWindowHoursPlaceholder": "48",
      "waitlistCap": "Plafond de la liste d’attente",
      "waitlistCapHint": "Nombre maximal de personnes sur la liste d’attente par session. Laissez vide = illimité.",
      "waitlistCapPlaceholder": "Illimité",
      "waitlistCapUnlimited": "Illimité",
      "occurrenceWaitlist": "Liste d’attente (cette session)",
      "occurrenceWaitlistHelp": "Suivre l’activité : le réglage de liste d’attente de l’activité s’applique. Activée ou Désactivée ne vaut que pour cette session.",
      "occurrenceWaitlistInherit": "Suivre l’activité",
      "occurrenceWaitlistOn": "Activée",
      "occurrenceWaitlistOff": "Désactivée",
      "manageWaitlist": "Gérer la liste d’attente",
      "cancellationDeadline": "Date limite d’annulation",
      "cancellationDeadlineHelp": "Les participants peuvent annuler eux-mêmes jusqu’à ce jour inclus. Elle est calculée à partir du premier jour ; si vous saisissez vous-même une date, celle-ci est conservée.",
      "enrollmentDeadlineDays": "Inscription possible jusqu’à (jours avant le premier jour)",
      "deadlineDaysHint": "Vide = valeur par défaut de l’environnement. 0 = jusqu’au premier jour même.",
      "deadlineDaysHelp": "Le nombre de jours calendaires avant le premier jour. Le serveur en déduit la date par session ; vous pouvez la remplacer par session.",
      "deadlineCalculated": "Calculé à partir du premier jour",
      "deadlineOverridden": "Défini manuellement",
      "deadlineNone": "Pas de date limite",
      "deadlineBackToCalculated": "Revenir au calculé",
      "noDate": "Aucune date",
      "expandDay": "Modifier",
      "collapseDay": "Replier",
      "deadlineDaysBefore_one": "{count} jour avant le premier jour",
      "deadlineDaysBefore_other": "{count} jours avant le premier jour",
      "deadlineSameDay": "Jusqu’au premier jour lui-même",
      "deadlineInherited": "{days} (valeur par défaut de l’environnement)",
      "cancellationApprovalFlow": "Circuit d’approbation pour l’annulation",
      "cancellationApprovalFlowHelp": "Qui décide d'une demande d'annulation, lorsque les conditions d'annulation demandent une validation. Validée signifie annulée ; refusée, le participant reste inscrit.",
      "opleider": "Organisme de formation",
      "opleiderHelp": "Un organisme de formation limite la liste des formateurs à ceux de cette entreprise. C’est seulement un filtre ; il n’est pas enregistré.",
      "opleiderNone": "— Aucun / formateur interne —",
      "capacity": "Capacité",
      "enrolledBadge": "A des inscriptions",
      "enrolledReadOnly": "Cette session comporte des inscriptions et est en lecture seule ici. Modifiez la date, le formateur, le lieu de formation ou les participants sur la page de planification.",
      "managePlanningLink": "Gérer sur la page de planification",
      "approvalFlow": "Approbation",
      "approvalFlowNone": "Aucune approbation — inscription directe",
      "approvalFlowHint": "Choisissez un flux d'approbation, ou laissez sans approbation. Liste d'attente, capacité et fenêtre d'inscription restent applicables.",
      "cancellationPolicy": "Conditions d'annulation",
      "cancellationPolicyHelp": "Jusqu'à quand et à quelles conditions un participant annule. Vous choisissez un ensemble dans les paramètres ; une session peut en choisir un autre.",
      "cancellationPolicyDefault": "{name} (par défaut)",
      "cancellationApprovalFlowNone": "Aucun circuit",
      "occurrenceCancellationPolicy": "Conditions d'annulation",
      "occurrenceCancellationPolicyHelp": "Un autre ensemble que celui de l'activité, pour cette session uniquement. Le délai d'annulation suit alors le délai de cet ensemble.",
      "occurrenceCancellationPolicyInherit": "Comme l'activité ({name})",
      "occurrenceCancellationPolicyInheritPlain": "Comme l'activité"
    },
    "inschrijven": {
      "intro": "Ce sont les paramètres d'inscription par défaut de cette activité. Vous planifiez les sessions ensuite sur la page de planification ; chaque session peut y déroger."
    },
    "waitlist": {
      "heading": "Liste d’attente",
      "intro": "L’ordre détermine qui obtient une place libérée en premier. Réorganisez les personnes en attente à l’aide des boutons.",
      "back": "Retour aux sessions",
      "empty": "Personne n’est sur la liste d’attente pour cette session.",
      "loadError": "La liste d’attente n’a pas pu être chargée. Veuillez réessayer.",
      "moveError": "L’ordre n’a pas pu être modifié. Veuillez réessayer.",
      "unknownUser": "Utilisateur inconnu",
      "joinedAt": "Inscrit le {date}",
      "toTop": "Vers le haut",
      "moveUp": "Déplacer {name} d’une place vers le haut",
      "moveDown": "Déplacer {name} d’une place vers le bas",
      "moveTop": "Déplacer {name} tout en haut"
    },
    "panel": {
      "title": "Ce que vous créez"
    },
    "classificatie": {
      "themes": "Catégories",
      "noThemes": "Aucune catégorie gérée pour l’instant — ajoutez-les plus tard dans la gestion des catégories.",
      "themesPlaceholder": "Rechercher et choisir des catégories",
      "tags": "Mots-clés",
      "tagPlaceholder": "Saisissez un mot-clé…",
      "addTag": "Nouveau mot-clé : « {tag} »",
      "duration": "Durée",
      "language": "Langue",
      "choose": "— choisir —",
      "formCategory": "Forme d'apprentissage",
      "formCategoryHelp": "Une étiquette pour l'apprenant, choisie dans la liste de cet environnement. Préremplie d'après le type.",
      "formCategoryOption": {
        "formal_digital": "Formel – numérique",
        "formal_classroom": "Formel – présentiel",
        "formal_supporting": "Formel – accompagnement",
        "social_learning": "Apprentissage social",
        "workplace_experience": "Travail & expérience",
        "self_directed": "Apprentissage autodirigé"
      },
      "languagePerOccurrence": "Vous choisissez la langue par session, dans la planification. L’activité est alors proposée dans les langues de ses sessions."
    },
    "duration": {
      "kort": "Court (< 30 min)",
      "uur": "Environ une heure",
      "dagdeel": "Une demi-journée",
      "meerdaags": "Sur plusieurs jours"
    },
    "language": {
      "nl": "Néerlandais",
      "en": "Anglais",
      "de": "Allemand",
      "fr": "Français"
    },
    "visibility": {
      "everyone": "Tout le monde",
      "lead": "Qui peut voir cette activité d’apprentissage ?",
      "ruleset": "Un groupe d’accès enregistré",
      "closedUntilGroup": "Attention : tant qu’aucun groupe d’accès n’est associé ici, personne ne voit cette activité d’apprentissage — sauf les personnes autorisées à la modifier. Choisissez « Tout le monde » si vous souhaitez au contraire l’ouvrir.",
      "chooseGroup": "Groupe d’accès",
      "noGroupChosen": "Aucun groupe choisi pour l’instant",
      "groupOption": "{name} ({count} personnes)",
      "noGroupsYet": "Il n’y a pas encore de groupes d’accès. Créez-en un dans Groupes d’accès — c’est là que vous définissez qui en fait partie, et vous pourrez ensuite choisir ce groupe ici et ailleurs."
    },
    "onderdelen": {
      "pathLead": "Composez les composants ordonnés (l’ordre détermine le déverrouillage).",
      "bundleLead": "Regroupez les composants (sans ordre).",
      "sequentieel": "Ordre imposé (strictement séquentiel)",
      "required": "Requis (compte pour le déverrouillage)",
      "remove": "supprimer",
      "empty": "Aucun composant pour l’instant.",
      "addExisting": "+ Ajouter une activité existante…",
      "searchLabel": "Recherchez une activité à ajouter comme composant",
      "moveUp": "Monter",
      "moveDown": "Descendre"
    },
    "title": "Catalogue",
    "description": "Recherchez et filtrez toutes les activités, puis ouvrez-en une pour vous inscrire.",
    "results_one": "{count} activité",
    "results_other": "{count} activités",
    "loadMore": "Charger plus",
    "sort": {
      "newest": "Plus récent d’abord",
      "title_asc": "Titre A–Z",
      "title_desc": "Titre Z–A"
    },
    "emptyState": {
      "title": "Aucun résultat",
      "body": "Ajustez vos filtres ou votre recherche.",
      "reset": "Effacer les filtres"
    },
    "occurrenceStatus": {
      "concept": "Brouillon",
      "planned": "Planifiée",
      "confirmed": "Confirmée",
      "completed": "Terminée",
      "cancelled": "Annulée"
    },
    "planning": {
      "heading": "Planification",
      "intro": "Gérez les sessions de cette activité d'apprentissage.",
      "backToWizard": "Retour à l'activité",
      "openLink": "Ouvrir la planification",
      "loadError": "La planification n'a pas pu être chargée. Veuillez réessayer.",
      "drift": {
        "title": "Les délais diffèrent du nombre de jours",
        "body": "Pour {n} session(s), le délai calculé ne correspond plus au nombre de jours de l’activité ou de l’environnement.",
        "withEnrolments": "Pour {n} d’entre elles, des personnes sont déjà inscrites ; elles restent inchangées sauf si vous les incluez expressément.",
        "recalculate": "Recalculer (sans inscriptions)",
        "recalculateAll": "Recalculer aussi avec les inscriptions"
      },
      "statusError": "Le statut n'a pas pu être modifié. Veuillez réessayer.",
      "empty": "Cette activité n'a pas encore de sessions.",
      "filterStatus": "Statut",
      "statsLabel": "Statistiques",
      "stats": {
        "completed": "Sessions passées",
        "totalEnrolled": "Inscrits au total",
        "concept": "Brouillons",
        "planned": "Planifiées",
        "confirmed": "Confirmées",
        "cancelled": "Annulées"
      },
      "columns": {
        "title": "Sujet",
        "datetime": "Date et heure",
        "trainer": "Formateur",
        "location": "Lieu de formation",
        "bezetting": "Occupation",
        "status": "Statut",
        "deadline": "Date limite d'inscription",
        "actions": "Actions"
      },
      "transition": {
        "planned": "Ouvrir",
        "confirmed": "Confirmer",
        "completed": "Terminer",
        "cancelled": "Annuler"
      },
      "detailLink": "Participants",
      "confirmCancelTitle": "Annuler la session",
      "confirmCancelBody": "Êtes-vous sûr de vouloir annuler cette session ? Tous les participants ainsi que toutes les personnes en liste d'attente seront annulés et notifiés automatiquement. Cette action est irréversible.",
      "confirmCancelConfirm": "Annuler la session",
      "confirmCancelKeep": "Conserver la session",
      "cancelReasonLabel": "Motif (facultatif)",
      "addOccurrence": "Ajouter une session",
      "editRow": "Modifier",
      "belowMinimum": "Minimum non atteint",
      "belowMinimumHint": "Il y a moins d’inscriptions que le minimum de {min}. Vous pouvez confirmer la session (la maintenir malgré tout), l’annuler ou déplacer la date.",
      "editor": {
        "addTitle": "Ajouter une session",
        "editTitle": "Reprogrammer la session",
        "intro": "Renseignez les détails de la session. Les inscriptions existantes sont conservées.",
        "loadError": "Les sessions n'ont pas pu être chargées. Veuillez réessayer.",
        "saveError": "La session n'a pas pu être enregistrée. Veuillez réessayer.",
        "backToPlanning": "← Retour à la planification",
        "sectionBasis": "Informations de base",
        "sectionCapacity": "Capacité et inscription",
        "sectionDays": "Jours",
        "summary": "Résumé",
        "summaryFirstDay": "Premier jour",
        "summaryDays": "Nombre de jours",
        "summaryCapacity": "Participants",
        "notFound": "Cette session n'existe plus.",
        "conceptNotice": "Cette session est encore un brouillon : les participants ne la voient pas et ne peuvent pas s’inscrire. Vérifiez les jours, puis ouvrez-la.",
        "saveAndOpen": "Enregistrer et ouvrir",
        "openError": "La session a été enregistrée, mais n’a pas pu être ouverte. Ouvrez-la depuis la planification.",
        "sectionLanguage": "Langue",
        "language": "Langue de cette session",
        "languageHint": "Choisissez parmi les langues dans lesquelles l’activité a ses textes.",
        "languageHelp": "L’activité apparaît dans le catalogue dans les langues de ses sessions.",
        "sectionFields": "Caractéristiques",
        "fieldsHint": "Ne remplissez que ce qui diffère pour cette session. Vide signifie : comme pour l'activité.",
        "fieldFromActivity": "Pour l'activité : {value}",
        "fieldInherit": "Comme pour l'activité",
        "sectionCertificate": "Certificat"
      },
      "duplicateRow": "Dupliquer",
      "bulkEdit": "Tout modifier",
      "duplicate": {
        "title": "Dupliquer la session",
        "intro": "La copie reprend les jours, horaires, lieux, formateurs et paramètres, et se décale avec la nouvelle date de début. Les participants ne sont jamais copiés.",
        "opensNow": "La copie est immédiatement ouverte aux inscriptions.",
        "startsAsConcept": "L’original compte {days} jours. La copie démarre donc comme brouillon : les participants ne la voient pas encore. Vérifiez les autres jours, puis ouvrez-la depuis la planification.",
        "currentStart": "Premier jour de l'original : {date}",
        "startDate": "Nouvelle date de début",
        "startDateHelp": "Tous les jours conservent le même écart entre eux.",
        "confirm": "Dupliquer",
        "error": "La session n'a pas pu être dupliquée. Veuillez réessayer."
      },
      "bulk": {
        "title": "Modifier les sessions en masse",
        "intro": "Toutes les sessions de cette activité dans un seul tableau. Modifiez ce qu'il faut et enregistrez le tout en une fois.",
        "backToPlanning": "← Retour à la planification",
        "loadError": "Les sessions n'ont pas pu être chargées. Veuillez réessayer.",
        "empty": "Cette activité n'a pas encore de sessions à modifier.",
        "saveError": "Les modifications n'ont pas pu être enregistrées. Rien n'a été modifié.",
        "saved": "Les modifications ont été enregistrées.",
        "dirty": "Des modifications n'ont pas encore été enregistrées.",
        "tableLabel": "Sessions et leurs jours",
        "col": {
          "select": "Sélectionner",
          "day": "Jour"
        },
        "field": "{field} ({row})",
        "rowLabel": "{occurrence}, jour {day}",
        "selectRow": "Sélectionner {row}",
        "selectOccurrence": "Sélectionner {occurrence} avec tous ses jours",
        "collapse": "Réduire {occurrence}",
        "expand": "Développer {occurrence}",
        "lockedEnrollments": "A des inscriptions : les jours, horaires et lieux sont figés. La replanification se fait sur la page de la session.",
        "lockedFinished": "Clôturée ou annulée : ne peut plus être modifiée.",
        "trainers": "Formateur(s) : {names}",
        "collision": "Même date et même heure de début qu'une autre session de cette activité.",
        "collisionSummary": "Pour {count} jours, la date et l'heure de début sont identiques à celles d'une autre session de cette activité. C'est permis, mais vérifiez que c'est voulu.",
        "saveCollisionTitle": "Même date et même heure de début",
        "saveCollisionBody": "Il y a des jours ({count}) avec la même date et la même heure de début qu'une autre session de cette activité. Voulez-vous enregistrer quand même ?",
        "saveCollisionConfirm": "Enregistrer quand même",
        "saveCollisionBack": "Retour au tableau",
        "apply": {
          "title": "Appliquer aux lignes sélectionnées",
          "selected": "Sélectionné : {days} jours, {occurrences} sessions",
          "location": "Lieu de formation pour les jours sélectionnés",
          "locationPlaceholder": "Choisir un lieu",
          "locationButton": "Appliquer le lieu",
          "trainers": "Formateur(s) pour les sessions sélectionnées",
          "trainersHelp": "Remplace les formateurs des sessions sélectionnées.",
          "trainersButton": "Appliquer les formateurs",
          "nothingSelected": "Sélectionnez d'abord des lignes dans le tableau.",
          "done": "Appliqué à {count} lignes. Pas encore enregistré."
        }
      },
      "cancelReasonHint": "Les participants lisent ce motif dans leur inscription et dans l'e-mail d'annulation. Gras, italique, listes et liens sont possibles ; 1000 caractères au maximum.",
      "cancelledOn": "Annulée le {date}",
      "conceptHint": "Non visible pour les participants"
    },
    "occurrenceDetail": {
      "heading": "Détail de la session",
      "intro": "Gérez les participants et la liste d'attente de cette session.",
      "backToPlanning": "← Retour à la planification",
      "metaLabel": "Informations sur la session",
      "meta": {
        "title": "Sujet",
        "datetime": "Date et heure",
        "trainer": "Formateur",
        "location": "Lieu de formation",
        "capacity": "Capacité (min–max)",
        "deadline": "Date limite d'inscription",
        "status": "Statut",
        "bezetting": "Occupation"
      },
      "participantsHeading": "Participants",
      "participantsEmpty": "Aucun participant n'est encore inscrit à cette session.",
      "columns": {
        "name": "Nom",
        "department": "Service",
        "status": "Statut",
        "actions": "Actions",
        "enrolledBy": "Inscrit par"
      },
      "unknownUser": "Utilisateur inconnu",
      "cancelAction": "Annuler",
      "transfer": {
        "action": "Déplacer",
        "title": "Déplacer le participant",
        "body": "Déplacer {name} vers une autre session de cette activité d'apprentissage.",
        "targetLabel": "Nouvelle session",
        "targetPlaceholder": "Choisissez une session",
        "hint": "La place sur la session actuelle se libère et revient à la première personne en attente. Si la nouvelle session est complète, le participant rejoint sa liste d'attente.",
        "willWaitlist": "complet, passe en liste d'attente",
        "noDate": "sans date",
        "noTargets": "Cette activité d'apprentissage n'a pas d'autre session planifiée ou confirmée vers laquelle déplacer.",
        "confirm": "Déplacer",
        "error": "Le participant n'a pas pu être déplacé. Veuillez réessayer."
      },
      "cancelError": "L'inscription n'a pas pu être annulée. Veuillez réessayer.",
      "confirmCancelTitle": "Annuler l'inscription",
      "confirmCancelBody": "Voulez-vous vraiment annuler l'inscription de {name} ? La place est libérée et la liste d'attente avance automatiquement.",
      "confirmCancelConfirm": "Annuler l'inscription",
      "completion": {
        "heading": "Certificat et évaluation",
        "soon": "La délivrance d'un certificat et l'évaluation de la session arrivent prochainement."
      },
      "loadError": "La session n'a pas pu être chargée. Veuillez réessayer.",
      "onBehalf": {
        "action": "Inscrire des participants",
        "title": "Inscrire des participants",
        "body": "Choisissez les personnes à inscrire. Vous voyez d'abord ce qui se passera pour chacune ; vous inscrivez ensuite.",
        "peopleLabel": "Personnes",
        "peoplePlaceholder": "Rechercher par nom ou e-mail",
        "check": "Vérifier",
        "back": "Retour",
        "confirm": "Inscrire",
        "close": "Fermer",
        "previewHeading": "Ce qui va se passer",
        "doneHeading": "Ce qui s'est passé",
        "nothingToDo": "Aucune de ces personnes ne peut être inscrite pour le moment.",
        "error": "L'inscription a échoué. Veuillez réessayer.",
        "overridesHeading": "Continuer malgré tout ?",
        "overridesIntro": "Une règle fait obstacle pour une ou plusieurs personnes. Vous pouvez la mettre de côté ; cela est enregistré sur l'inscription, avec votre nom.",
        "adminOnly": "Seul un administrateur peut mettre cette règle de côté.",
        "applied": "Mis de côté : {gates}",
        "unknownPerson": "Personne inconnue",
        "override": {
          "capacity": "Inscrire au-delà du nombre maximal de participants",
          "deadline": "Inscrire après la date limite d'inscription",
          "approval": "Inscrire sans approbation"
        },
        "gate": {
          "capacity": "maximum",
          "deadline": "date limite d'inscription",
          "approval": "approbation"
        },
        "preview": {
          "enrolled": "Sera inscrit",
          "pending": "Attendra ensuite l'approbation",
          "waitlisted": "Sera placé sur la liste d'attente",
          "blocked": "Ne peut pas être inscrit",
          "not_found": "Introuvable ou hors de votre périmètre"
        },
        "done": {
          "enrolled": "Inscrit",
          "pending": "En attente d'approbation",
          "waitlisted": "Sur la liste d'attente",
          "blocked": "Non inscrit",
          "not_found": "Introuvable ou hors de votre périmètre"
        },
        "reason": {
          "deadline_passed": "La date limite d'inscription est dépassée.",
          "full": "La session est complète et n'a pas de liste d'attente.",
          "waitlist_full": "La session et sa liste d'attente sont complètes.",
          "already_enrolled_here": "Est déjà inscrit à cette session.",
          "already_enrolled_elsewhere": "Est déjà inscrit à une autre session de cette activité d'apprentissage.",
          "not_visible": "Cette activité d'apprentissage n'est pas destinée à cette personne.",
          "suspended": "Le compte de cette personne est bloqué."
        }
      },
      "cancelCosts": {
        "before": "Avant le délai d'annulation, l'annulation coûte {amount}.",
        "after": "Après le délai d'annulation, l'annulation coûte {amount}.",
        "charge": "Facturer les frais",
        "waiverReason": "Motif de la renonciation",
        "waiverReasonRequired": "Indiquez pourquoi vous renoncez aux frais.",
        "managerHint": "Seul un administrateur disposant de droits sur l'ensemble de l'environnement peut renoncer aux frais."
      }
    },
    "archiveLive": {
      "title": "Archivage : des sessions sont encore programmées",
      "body": "{activities} activité(s) de cette sélection ont {occurrences} session(s) encore à venir, avec {enrollments} inscription(s) active(s). La première est le {date}. Veuillez choisir ce qu’il faut en faire.",
      "choose": "Que se passe-t-il pour les sessions en cours ?",
      "keep_running": "Ne plus proposer, mais terminer ce qui est en cours",
      "keep_runningHint": "Ces activités passent en Masqué au lieu d’Archivé : elles disparaissent du catalogue, mais les personnes inscrites terminent la session. Les inscriptions ne changent pas.",
      "cancel_enrollments": "Désinscrire tout le monde et archiver",
      "cancel_enrollmentsHint": "Les sessions sont annulées et tous les participants ainsi que les inscriptions en liste d’attente sont retirés. Toutes les personnes concernées en sont informées. Cette action est irréversible.",
      "confirmKeep": "Masquer",
      "confirmCancel": "Désinscrire et archiver"
    },
    "anonymous": {
      "label": "Ouvrir sans connexion",
      "help": "Toute personne disposant du lien peut suivre le cours, même sans compte. Destiné à montrer ce qu’est un cours — pas à permettre de le valider.",
      "warning": "Attention : pour un cours lancé sans connexion, nous n’enregistrons ni progression ni résultat — il n’y a aucun participant auquel les rattacher. Et le public défini ci-dessus ne s’applique pas à ce lien : quiconque le possède entre.",
      "linkLabel": "Lien à partager"
    },
    "completionRule": {
      "completed": "Le cours signale lui-même qu'il est terminé",
      "progress_percentage": "Avoir parcouru une partie du contenu",
      "minimum_score": "Atteindre un score minimum",
      "opened": "L'ouvrir vaut pour l'avoir terminé",
      "attendance": "Présent selon la liste de présence",
      "declaration": "Quelqu'un déclare que c'est fait"
    },
    "completionRuleBulk": {
      "action": "Définir la règle de validation",
      "title": "Définir la règle de validation",
      "scopeSelection": "Pour les {count} formations sélectionnées.",
      "scopeAll": "Pour les {count} formations correspondant au filtre.",
      "choose": "Que souhaitez-vous définir ?",
      "determined": "Compléter ce qui est déterminé",
      "determinedHint": "Une session, un lien, un fichier ou un enregistrement manuel n’admet qu’une seule règle. Le système la renseigne. Les formations offrant un vrai choix restent inchangées.",
      "explicit": "Définir cette règle",
      "explicitHint": "Pour l’e-learning et LTI, où trois règles sont possibles. Les formations avec une autre source sont écartées.",
      "preview": "Quel sera l’effet ?",
      "previewResult": "{count} formations recevront une règle de validation",
      "skipLine": "{count} × {reason}",
      "confirm": "Définir",
      "done": "{updated} mises à jour, {skipped} ignorées.",
      "skip": {
        "already_set": "en avait déjà une",
        "needs_choice": "un choix vous revient ici",
        "source_forbids": "ne correspond pas à la source",
        "package_cannot_measure": "le fichier ne le mesure pas"
      }
    },
    "rules": {
      "evaluationsTitle": "Évaluations",
      "testsTitle": "Tests",
      "evaluationsIntro": "Questionnaires que les participants remplissent à propos de cette activité. Une règle s’applique à toutes les sessions.",
      "testsIntro": "Tests corrigés par un formateur. Une règle s’applique à toutes les sessions. Si un test compte pour la réussite, l’achèvement — et donc la qualification — n’intervient qu’une fois le test corrigé et réussi.",
      "add": "Ajouter une règle",
      "empty": "Aucune règle pour l’instant.",
      "emptyNew": "Aucune règle pour l’instant. Ce que vous ajoutez ici est enregistré dès que vous créez l’activité.",
      "draftBadge": "Brouillon",
      "external": "Externe",
      "pendingNote": "Enregistré dès que vous créez l’activité.",
      "needsSource": "Choisissez d’abord un type, vous pourrez ensuite ajouter des règles ici.",
      "failedAfterCreate": "« {title} » a été créée, mais une ou plusieurs règles n’ont pas pu être enregistrées. Ajoutez-les à nouveau ci-dessous.",
      "mandatory": "Compte pour la réussite",
      "removed": "La règle a été supprimée.",
      "archivedInstead": "La règle a été arrêtée : quelque chose a déjà été envoyé, elle ne peut donc pas être supprimée.",
      "removeTitle": "Supprimer la règle ?",
      "removeBody": "La règle et ce qui était encore prêt pour les participants disparaissent. Si quelque chose a déjà été envoyé, la règle est arrêtée à la place.",
      "saveFirstNeeds": "Pour ajouter une règle, l’activité est d’abord enregistrée comme brouillon. Veuillez d’abord compléter :",
      "referenceNote": "Une référence n’est jamais terminée. On ne peut y rattacher ni qualification ni test ; une évaluation, si. Si des qualifications ou des tests y sont déjà rattachés, ils sont retirés à l’enregistrement.",
      "testsNeedSessions": "Un test ne peut être ajouté qu’à une activité en présentiel, avec des sessions.",
      "createTest": "Créer un nouveau test",
      "createEvaluation": "Créer une nouvelle évaluation"
    },
    "links": {
      "qualifications": "Qualifications",
      "evaluations": "Évaluations",
      "tests": "Tests"
    },
    "list": {
      "publishPlanned": "Programmée : {date}",
      "publishFailed": "Échec de la publication"
    },
    "earlyClose": {
      "title": "Cette session n'est pas encore terminée",
      "notStarted": "Cette session commence le {date}. Aucun jour n'a encore eu lieu.",
      "partial": "Il reste des jours à venir : {remaining} jours sur {total} ne sont pas encore passés. Toute personne qui n'a pas assisté à tous les jours reste sans résultat.",
      "confirm": "Clôturer quand même",
      "keep": "Ne pas clôturer"
    },
    "view": {
      "label": "Affichage",
      "cards": "Cartes",
      "list": "Liste"
    },
    "card": {
      "parts_one": "{count} partie",
      "parts_other": "{count} parties"
    },
    "sources": {
      "heading": "Matériel par langue",
      "help": "Pour une autre langue, vous pouvez ajouter son propre paquet, lien ou adresse de cours. L’apprenant reçoit par défaut sa propre langue et peut en choisir une autre.",
      "primaryLanguages": "Langues de ce matériel",
      "languages": "Langues",
      "other": "Matériel pour une autre langue ({n})",
      "add": "Ajouter du matériel pour une autre langue",
      "notForThisKind": "Un fichier par langue n’est pas encore possible ; choisissez ci-dessus les langues couvertes par ce fichier."
    },
    "help": {
      "completionRule": "Quand un participant a terminé cette formation : lorsque le contenu la signale comme terminée, à partir d'un score minimum, d'un pourcentage parcouru, ou dès qu'il l'a ouverte. Les règles disponibles dépendent de la source.",
      "accessGroup": "Un groupe d'accès décrit une fois qui peut voir quelque chose, et s'utilise à plusieurs endroits. Vous le créez sous Accès › Groupes d'accès ; ici, vous en choisissez un.",
      "promotionMode": "Ce qui se passe quand une place se libère : la première personne de la liste d'attente est inscrite immédiatement, ou se voit proposer la place et décide elle-même dans le délai de réponse.",
      "studyLoad": "La durée correspond à la formation elle-même. La charge d'études est le temps total qu'un participant y consacre, préparation, devoirs et tests compris."
    },
    "occurrences": {
      "results_one": "{count} session",
      "results_other": "{count} sessions",
      "notPlanned": "Pas encore de date",
      "moreDays_one": "+ {count} jour",
      "moreDays_other": "+ {count} jours"
    },
    "notFound": {
      "title": "Ce catalogue n'existe pas",
      "body": "Le lien n'est plus valide, ou ce catalogue ne vous est pas destiné. Demandez à votre administrateur si vous pensez devoir le voir.",
      "back": "Vers le catalogue"
    },
    "certificate": {
      "label": "Certificat",
      "loading": "Chargement des modèles de certificat…",
      "loadError": "Les modèles de certificat n'ont pas pu être chargés.",
      "asActivity": "Comme l'activité",
      "unavailableTemplate": "Modèle qui n'est plus disponible",
      "none": "Aucun certificat",
      "help": {
        "activity": "Choisissez le modèle du certificat. Le certificat est créé automatiquement lorsqu'une personne termine cette activité. Par défaut, l'activité suit le choix de l'environnement (Paramètres → Certificats).",
        "occurrence": "Par défaut, un participant reçoit le certificat choisi par l'activité. Ne choisissez autre chose ici que si cette session doit être différente."
      },
      "archivedWarning": "Ce modèle est archivé ou n'est plus disponible. Des certificats sont encore créés avec ce modèle ; choisissez-en un autre si ce n'est pas voulu."
    }
  },
  "catalogSettings": {
    "heading": "Paramètres du catalogue",
    "intro": "Définissez ici les valeurs par défaut du catalogue et des inscriptions. Les nouvelles activités et sessions utilisent ces valeurs par défaut.",
    "saved": "Paramètres enregistrés.",
    "waitlist": {
      "legend": "Liste d'attente",
      "enabledByDefault": "Liste d'attente activée par défaut",
      "enabledByDefaultHint": "Les nouvelles sessions activent la liste d'attente par défaut lorsqu'une session est complète.",
      "promotionMode": "Mode de promotion",
      "offerWindowHours": "Fenêtre d'offre (heures)",
      "offerWindowHoursHint": "Le nombre d'heures dont dispose une personne promue pour accepter une place proposée.",
      "cap": "Plafond de la liste d'attente",
      "capHint": "Laissez vide pour une liste d'attente illimitée.",
      "capPlaceholder": "Illimité"
    },
    "deadlines": {
      "legend": "Délais",
      "hint": "Le nombre par défaut de jours calendaires avant le premier jour d'une session. Une activité peut choisir son propre nombre ; vide signifie aucune valeur par défaut.",
      "enrollmentDays": "Inscription possible jusqu'à (jours avant le premier jour)"
    },
    "enrollment": {
      "legend": "Inscription",
      "hint": "Combien de fois une personne peut participer ou s’inscrire sur liste d’attente en même temps pour une activité. Les nouvelles activités démarrent avec ces valeurs.",
      "maxEnrollments": "Nombre d’inscriptions",
      "maxWaitlistRegistrations": "Nombre d’inscriptions sur liste d’attente",
      "cancellationFlow": "Circuit de validation pour les annulations",
      "cancellationFlowHint": "Qui décide d'une demande d'annulation pour une nouvelle activité, lorsque les conditions d'annulation demandent une validation. Distinct du circuit d'inscription : il peut être le même, mais ne l'est pas d'office.",
      "cancellationFlowNone": "Aucun"
    },
    "visibility": {
      "legend": "Visibilité",
      "mode": "Mode de visibilité"
    },
    "durationPresets": {
      "legend": "Durées préférées",
      "hint": "La liste de choix pour la durée d'une formation. Chaque choix correspond à un nombre de minutes (une demi-journée fait 240). Une formation peut toujours s'en écarter.",
      "empty": "Sans choix propres, la liste standard s'applique.",
      "add": "Ajouter une durée préférée",
      "restore": "Rétablir la liste standard",
      "rowTitle": "Durée préférée {n}",
      "minutes": "Minutes"
    },
    "learningForms": {
      "legend": "Formes d'apprentissage",
      "hint": "Une étiquette pour l'apprenant sur chaque formation, avec une couleur. Pour une formation, vous choisissez dans cette liste.",
      "add": "Ajouter une forme d'apprentissage",
      "rowTitle": "Forme d'apprentissage {n}",
      "color": "Couleur",
      "preview": "Ce que voit l'apprenant",
      "inUse": "Utilisée par une activité : ne peut pas être supprimée.",
      "colorOption": {
        "primary": "Primaire",
        "accent": "Accent",
        "success": "Vert",
        "warning": "Orange",
        "error": "Rouge",
        "info": "Bleu",
        "neutral": "Gris"
      }
    },
    "lists": {
      "nameIn": "Nom en {language}",
      "up": "Monter",
      "down": "Descendre",
      "remove": "Supprimer",
      "upFor": "Monter : {name}",
      "downFor": "Descendre : {name}",
      "removeFor": "Supprimer : {name}"
    },
    "activityFields": {
      "legend": "Caractéristiques",
      "hint": "Vos propres champs sur chaque activité : texte libre, liste de choix ou oui/non. Une liste de choix ou un oui/non peut servir de filtre dans le catalogue ; c'est désactivé par défaut.",
      "rowTitle": "Caractéristique {n}",
      "kindLabel": "Type",
      "kind": {
        "text": "Texte libre",
        "choice": "Liste de choix",
        "boolean": "Oui/non"
      },
      "active": "Actif",
      "filterable": "Afficher comme filtre dans le catalogue",
      "options": "Options",
      "optionTitle": "Option {n}",
      "addOption": "Ajouter une option",
      "add": "Ajouter une caractéristique",
      "inUse_one": "Utilisée sur {count} activité.",
      "inUse_other": "Utilisée sur {count} activités.",
      "kindLocked": "Le type est fixé dès que des valeurs existent.",
      "removeTitle": "Supprimer la caractéristique ?",
      "removeBody_one": "« {name} » est utilisée sur {count} activité. La supprimer retire cette valeur à l'enregistrement. Pour seulement la masquer, désactivez-la.",
      "removeBody_other": "« {name} » est utilisée sur {count} activités. La supprimer retire ces valeurs à l'enregistrement. Pour seulement la masquer, désactivez-la.",
      "saved": "Les caractéristiques ont été enregistrées.",
      "empty": "Aucune caractéristique pour l'instant."
    },
    "summary": {
      "waitlistOff": "désactivée",
      "waitlistOnOffer": "activée, offre {hours} h",
      "waitlistOnAuto": "activée, promotion automatique",
      "waitlistCap": "max. {cap}",
      "daysBefore_one": "{count} jour avant",
      "daysBefore_other": "{count} jours avant",
      "noDeadline": "pas de valeur par défaut",
      "enrollment": "inscriptions : {enrollments}, liste d'attente : {waitlist}",
      "durationPresets_one": "{count} durée",
      "durationPresets_other": "{count} durées",
      "learningForms_one": "{count} forme d'apprentissage",
      "learningForms_other": "{count} formes d'apprentissage",
      "activityFields_one": "{count} caractéristique active",
      "activityFields_other": "{count} caractéristiques actives",
      "activityFieldsNone": "aucune pour l'instant",
      "deadlinesEnrollment": "inscription : {enrollment}"
    },
    "unsaved": {
      "title": "Enregistrer les modifications ?",
      "body": "Vous avez modifié quelque chose dans {section} qui n'est pas encore enregistré.",
      "discard": "Ne pas enregistrer"
    }
  },
  "settingsHub": {
    "heading": "Paramètres",
    "intro": "Configurez ici votre environnement. Choisissez une rubrique.",
    "readOnly": "Vous pouvez consulter ces paramètres mais pas les modifier.",
    "tabs": {
      "catalog": "Catalogue",
      "approvals": "Approbations",
      "messages": "Messages",
      "questionnaires": "Questionnaires",
      "retention": "Conservation",
      "catalogs": "Catalogues",
      "cancellation": "Conditions d'annulation",
      "languages": "Langues de contenu",
      "documents": "Certificats"
    },
    "empty": "Il n'y a rien ici que vous êtes autorisé à configurer.",
    "breadcrumb": "Fil d'Ariane",
    "pages": {
      "catalog": "Paramètres du catalogue"
    },
    "themes": {
      "catalog": "Catalogue",
      "processes": "Processus",
      "textsMessages": "Textes et messages",
      "evaluationData": "Évaluation et données",
      "integrations": "Intégrations"
    },
    "descriptions": {
      "catalog": "Valeurs par défaut d'une nouvelle formation : liste d'attente, inscription, échéances, formats d'apprentissage et caractéristiques.",
      "catalogs": "Les catalogues, leur contenu et qui peut les ouvrir.",
      "themes": "Les catégories dans lesquelles vous classez les formations.",
      "cancellationReasons": "Les motifs parmi lesquels vous choisissez lors d'une annulation.",
      "approvals": "Le flux d'approbation qui s'applique par défaut.",
      "approvalFlows": "Qui approuve quoi, et dans quel ordre.",
      "workflows": "Ce qui se passe automatiquement après un événement.",
      "texts": "Vos propres formulations pour les textes de la plateforme.",
      "messages": "La fréquence d'envoi de l'e-mail récapitulatif.",
      "questionnaires": "Délai de réponse, rappels et échelle.",
      "retention": "Combien de temps l'historique d'apprentissage et les autres données sont conservés.",
      "lti": "Environnements d'apprentissage externes via LTI.",
      "cancellation": "Jusqu'à quand l'annulation est possible, qui décide et ce que cela coûte.",
      "languages": "Les langues dans lesquelles vos formations et leur matériel sont proposés.",
      "documentTemplates": "Les modèles de certificats, avec leurs versions.",
      "documents": "Comment commence le numéro de certificat, et si les modèles BCS peuvent être choisis."
    }
  },
  "questionBank": {
    "heading": "Questionnaires",
    "heading_test": "Tests",
    "intro": "Les questions, les catégories et les formulaires sont les éléments de base d’un questionnaire. Une question peut figurer dans plusieurs catégories, une catégorie dans plusieurs formulaires, et un formulaire dans plusieurs règles.",
    "intro_test": "Les questions, les catégories et les tests vont ensemble. Une question peut figurer dans plusieurs catégories, une catégorie dans plusieurs tests, et un test dans plusieurs règles d’une formation.",
    "tabs": {
      "questions": "Questions",
      "categories": "Catégories",
      "forms": "Formulaires",
      "forms_test": "Tests",
      "surveys": "Questionnaires autonomes",
      "assignments": "Règles d’évaluation",
      "assignments_test": "Règles de test"
    },
    "status": {
      "filter": "Afficher",
      "active": "Actives",
      "archived": "Archivées",
      "all": "Toutes"
    },
    "type": {
      "open": "Question ouverte",
      "scale": "Échelle",
      "multiple_choice": "Choix multiple",
      "yes_no": "Oui/non"
    },
    "typeHint": {
      "scale": "Échelle {min}–{max}",
      "multiple_choice_one": "Choix multiple, {count} option",
      "multiple_choice_other": "Choix multiple, {count} options"
    },
    "archivedBadge": "Archivée",
    "changeHint": "Une modification s’applique aux invitations créées à partir de maintenant. Ce qui a déjà été envoyé reste inchangé.",
    "fixErrors": "L’enregistrement a échoué. Veuillez vérifier les champs signalés.",
    "saveFailed": "L’enregistrement a échoué. Veuillez réessayer.",
    "actionFailed": "Cela n’a pas fonctionné. Veuillez réessayer.",
    "actions": {
      "edit": "Modifier",
      "view": "Consulter",
      "copy": "Copier",
      "archive": "Archiver",
      "restore": "Restaurer",
      "delete": "Supprimer",
      "editNamed": "Modifier {name}",
      "viewNamed": "Consulter {name}",
      "copyNamed": "Copier {name}"
    },
    "text": {
      "tabsLabel": "Langue des textes",
      "tabsHint": "Rédigez les textes par langue. {language} est la langue par défaut et obligatoire ; une langue sans texte revient à la langue par défaut.",
      "tabIncomplete": "{language} (incomplète)",
      "tabError": "{language} (erreur)",
      "hiddenLocale": "{language} (désactivée) :",
      "hiddenNotice": "Certains textes sont dans une langue désactivée pour cet environnement : {languages}. Ils sont conservés mais ne sont pas affichés, et ils reviennent dès que la langue est réactivée. Vous pouvez les supprimer champ par champ.",
      "removeHidden": "Supprimer le texte en {language} de {field}"
    },
    "questions": {
      "count_one": "{count} question",
      "count_other": "{count} questions",
      "new": "Nouvelle question",
      "empty": "La banque ne contient encore aucune question.",
      "emptyFiltered": "Aucune question avec ce statut.",
      "loadError": "Les questions n’ont pas pu être chargées.",
      "column": {
        "prompt": "Question",
        "type": "Type",
        "categories": "Dans des catégories",
        "forms": "Dans des formulaires",
        "forms_test": "Dans des tests",
        "actions": "Actions"
      }
    },
    "question": {
      "newTitle": "Nouvelle question",
      "texts": "Textes",
      "editTitle": "Modifier la question",
      "viewTitle": "Consulter la question",
      "backToList": "Retour aux questions",
      "loadError": "Cette question n’a pas pu être chargée.",
      "saved": "La question a été enregistrée.",
      "copied": "Voici la copie. Adaptez-la comme vous le souhaitez : la forme d’une copie est de nouveau libre.",
      "readOnly": "Vous pouvez consulter cette question, mais pas la modifier.",
      "archivedNotice": "Cette question est archivée. Elle ne peut plus être ajoutée à une catégorie ; là où elle figure déjà, elle reste.",
      "locked": {
        "title": "La forme de cette question est figée",
        "body": "Des réponses y ont déjà été données, ou elle figure dans une invitation qui peut encore être remplie. Le type, la plage, une ou plusieurs réponses et les options existantes restent donc inchangés. Vous pouvez toujours modifier le texte, le texte d’aide, le caractère obligatoire et ajouter une option. Besoin d’une autre forme ? Copiez la question."
      },
      "fields": {
        "type": "Type de question",
        "prompt": "Question",
        "helpText": "Texte d’aide",
        "helpTextHint": "Affiché sous la question.",
        "required": "Réponse obligatoire",
        "placeholder": "Texte d’exemple dans le champ",
        "minChars": "Nombre minimal de caractères",
        "maxChars": "Nombre maximal de caractères",
        "testimonial": "Les réponses peuvent être utilisées comme citations",
        "testimonialHint": "À afficher plus tard sur la page de la formation.",
        "requiredQuoteReason": "Une question dont les réponses peuvent être utilisées comme citation ne peut pas être obligatoire.",
        "minValue": "Valeur la plus basse",
        "maxValue": "Valeur la plus haute",
        "scaleDisplay": "Affichage",
        "scaleLabels": "Texte par point",
        "scaleLabelsHint": "Facultatif. Sans texte, le participant voit par exemple « 3 sur 5 ».",
        "scaleLabelsTooMany": "Vous pouvez donner un texte par point sur une échelle de {max} points au maximum.",
        "scalePoint": "Point {point}",
        "options": "Options de réponse",
        "noOptions": "Il n’y a pas encore d’options.",
        "option": "Option {n}",
        "addOption": "Ajouter une option",
        "moveOptionUp": "Monter l’option {n}",
        "moveOptionDown": "Descendre l’option {n}",
        "removeOption": "Supprimer l’option {n}",
        "allowsMultiple": "Plusieurs réponses possibles",
        "allowsOther": "Proposer « Autre, à savoir »",
        "allowsOtherHint": "À côté des autres choix, pas à leur place."
      },
      "choiceLimits": {
        "hint": "Laissez une limite vide s'il n'y en a pas. Le minimum est inférieur d'au moins un au nombre d'options ({count}, « Autre, à savoir » compris), et le maximum y tient. Une question obligatoire demande toujours au moins une réponse.",
        "min": "Nombre minimal à choisir",
        "max": "Nombre maximal à choisir",
        "minTooHigh": "Le minimum doit être inférieur d'au moins un au nombre d'options ({count}).",
        "maxTooHigh": "Le maximum ne peut pas dépasser le nombre d'options ({count}).",
        "backwards": "Le maximum est inférieur au minimum.",
        "notAWholeNumber": "Saisissez un nombre entier supérieur ou égal à 1."
      },
      "scaleDisplay": {
        "numbers": "Chiffres",
        "stars": "Étoiles"
      },
      "usage": {
        "title": "Où figure cette question",
        "categories": "Catégories",
        "forms": "Formulaires",
        "forms_test": "Tests",
        "assignments": "Affectations en cours",
        "unused": "Cette question ne figure encore nulle part."
      },
      "delete": {
        "title": "Supprimer la question",
        "body": "La question disparaît de la banque. Cette action est irréversible.",
        "confirm": "Supprimer"
      }
    },
    "categories": {
      "count_one": "{count} catégorie",
      "count_other": "{count} catégories",
      "new": "Nouvelle catégorie",
      "empty": "Il n’y a pas encore de catégories.",
      "emptyFiltered": "Aucune catégorie avec ce statut.",
      "loadError": "Les catégories n’ont pas pu être chargées.",
      "column": {
        "title": "Titre",
        "questions": "Questions",
        "forms": "Dans des formulaires",
        "forms_test": "Dans des tests",
        "actions": "Actions"
      }
    },
    "category": {
      "newTitle": "Nouvelle catégorie",
      "editTitle": "Modifier la catégorie",
      "viewTitle": "Consulter la catégorie",
      "backToList": "Retour aux catégories",
      "loadError": "Cette catégorie n’a pas pu être chargée.",
      "saved": "La catégorie a été enregistrée.",
      "copied": "Voici la copie, avec les mêmes questions. Si une question doit aussi être différente, copiez-la séparément.",
      "readOnly": "Vous pouvez consulter cette catégorie, mais pas la modifier.",
      "archivedNotice": "Cette catégorie est archivée. Elle ne peut plus être ajoutée à un formulaire ; là où elle figure déjà, elle reste.",
      "archivedNotice_test": "Cette catégorie est archivée. Elle ne figurera plus dans aucun nouveau test ; là où elle figure déjà, elle reste.",
      "fields": {
        "title": "Titre",
        "description": "Description"
      },
      "questions": {
        "title": "Questions de cette catégorie",
        "hint": "Elles figurent dans le formulaire dans cet ordre.",
        "hint_test": "Elles figurent dans le test dans cet ordre.",
        "empty": "Cette catégorie ne contient encore aucune question.",
        "add": "Ajouter une question",
        "search": "Rechercher une question dans la banque",
        "noResults": "Aucune question trouvée.",
        "moveUp": "Monter « {question} »",
        "moveDown": "Descendre « {question} »",
        "remove": "Retirer « {question} » de la catégorie"
      },
      "usage": {
        "title": "Où figure cette catégorie",
        "forms": "Formulaires",
        "forms_test": "Tests",
        "assignments": "Affectations en cours",
        "unused": "Cette catégorie ne figure encore dans aucun formulaire.",
        "unused_test": "Cette catégorie ne figure encore dans aucun test."
      },
      "delete": {
        "title": "Supprimer la catégorie",
        "body": "La catégorie disparaît. Les questions qu’elle contient restent dans la banque. Cette action est irréversible.",
        "confirm": "Supprimer"
      },
      "actions": {
        "saveAndNewQuestion": "Enregistrer et créer une nouvelle question"
      }
    },
    "forms": {
      "count_one": "{count} formulaire",
      "count_test_one": "{count} test",
      "count_other": "{count} formulaires",
      "count_test_other": "{count} tests",
      "new": "Nouveau formulaire",
      "new_test": "Nouveau test",
      "empty": "Il n’y a encore aucun formulaire.",
      "empty_test": "Il n’y a pas encore de test.",
      "emptyFiltered": "Aucun formulaire avec ce statut.",
      "emptyFiltered_test": "Aucun test avec ce statut.",
      "loadError": "Les formulaires n’ont pas pu être chargés.",
      "loadError_test": "Les tests n’ont pas pu être chargés.",
      "filter": {
        "current": "Brouillons et publiés",
        "draft": "Brouillon",
        "published": "Publié",
        "archived": "Archivé",
        "all": "Tous"
      },
      "column": {
        "title": "Titre",
        "status": "Statut",
        "assignments": "Affectations",
        "actions": "Actions"
      }
    },
    "form": {
      "newTitle": "Nouveau formulaire",
      "newTitle_test": "Nouveau test",
      "editTitle": "Modifier le formulaire",
      "editTitle_test": "Modifier le test",
      "viewTitle": "Consulter le formulaire",
      "viewTitle_test": "Consulter le test",
      "backToList": "Retour aux formulaires",
      "backToList_test": "Retour aux tests",
      "loadError": "Ce formulaire n’a pas pu être chargé.",
      "loadError_test": "Ce test n’a pas pu être chargé.",
      "saved": "Le formulaire a été enregistré.",
      "saved_test": "Le test a été enregistré.",
      "copied": "Voici la copie : un nouveau brouillon avec les mêmes catégories. Si une catégorie doit être différente, copiez-la séparément.",
      "published": "Le formulaire a été publié et peut maintenant être associé à une formation.",
      "published_test": "Le test a été publié et peut maintenant être associé à une formation.",
      "publishFailed": "La publication a échoué. Veuillez vérifier les champs signalés.",
      "readOnly": "Vous pouvez consulter ce formulaire, mais pas le modifier.",
      "readOnly_test": "Vous pouvez consulter ce test, mais pas le modifier.",
      "archivedNotice": "Ce formulaire est archivé et ne peut plus être associé à une formation. Restaurez-le pour en refaire un brouillon.",
      "archivedNotice_test": "Ce test est archivé et ne peut plus être associé à une formation. Restaurez-le pour en refaire un brouillon.",
      "status": {
        "draft": "Brouillon",
        "published": "Publié",
        "archived": "Archivé"
      },
      "statusPanel": {
        "title": "Statut",
        "new": "Un nouveau formulaire est enregistré comme brouillon.",
        "new_test": "Un nouveau test est enregistré comme brouillon.",
        "draft": "Un brouillon ne peut pas encore être associé à une formation. Publiez-le lorsqu’il est terminé ; tout est alors vérifié.",
        "published": "Le formulaire peut être associé à des formations. Il reste modifiable tant qu’il reste publiable.",
        "published_test": "Le test peut être associé à des formations. Il reste modifiable tant qu’il reste publiable.",
        "archived": "Le formulaire se trouve dans les archives. Le restaurer en refait un brouillon.",
        "archived_test": "Le test est dans les archives. La restauration en refait un brouillon."
      },
      "fields": {
        "title": "Titre",
        "description": "Description",
        "descriptionHint": "Affichée sous le titre.",
        "headerText": "Texte d’en-tête",
        "headerTextHint": "Affiché au-dessus des questions, par exemple un mot d’accueil.",
        "footerText": "Texte de pied de page",
        "footerTextHint": "Affiché sous les questions, par exemple un remerciement.",
        "allowRemarks": "Espace pour une remarque à la fin",
        "allowRemarksHint": "Le participant peut laisser une remarque libre, indépendamment des questions."
      },
      "categories": {
        "title": "Catégories de ce formulaire",
        "title_test": "Catégories de ce test",
        "hint": "Elles figurent dans le questionnaire dans cet ordre. Une question ne figure qu’une seule fois dans un formulaire.",
        "hint_test": "Elles figurent dans le test dans cet ordre. Une question ne figure qu’une seule fois dans un test.",
        "empty": "Ce formulaire ne contient encore aucune catégorie.",
        "empty_test": "Ce test ne contient pas encore de catégorie.",
        "add": "Ajouter une catégorie",
        "search": "Rechercher une catégorie",
        "noResults": "Aucune catégorie trouvée.",
        "questionCount_one": "{count} question",
        "questionCount_other": "{count} questions",
        "moveUp": "Monter « {category} »",
        "moveDown": "Descendre « {category} »",
        "remove": "Retirer « {category} » du formulaire",
        "remove_test": "Retirer « {category} » du test"
      },
      "actions": {
        "publish": "Publier",
        "saveAndNewCategory": "Enregistrer et créer une nouvelle catégorie"
      },
      "delete": {
        "title": "Supprimer le formulaire",
        "title_test": "Supprimer le test",
        "body": "Le formulaire disparaît. Les catégories et les questions qu’il contient restent dans la banque. Cette action est irréversible.",
        "body_test": "Le test est supprimé. Les catégories et les questions qu’il contient restent dans la banque. Cette action est irréversible.",
        "confirm": "Supprimer"
      },
      "assignments": {
        "title": "Affectations",
        "unused": "Ce formulaire n’est encore associé à aucune formation.",
        "unused_test": "Ce test n’est encore associé à aucune formation.",
        "total": "Utilisé dans",
        "pausable": "Pouvant être mises en pause",
        "pausedViaForm": "En pause via ce formulaire",
        "pausedSeparately": "En pause séparément, le restent à la réactivation",
        "held_one": "{count} affectation est en pause via ce formulaire. Rien n’est envoyé tant que vous ne la réactivez pas.",
        "held_other": "{count} affectations sont en pause via ce formulaire. Rien n’est envoyé tant que vous ne les réactivez pas.",
        "hint": "Vous voulez améliorer le formulaire pendant qu’il est utilisé ? Mettez d’abord toutes les affectations en pause, modifiez-le, puis réactivez-les. Les liens déjà envoyés restent valables.",
        "listTitle": "Par affectation",
        "unknownTraining": "Formation sans nom",
        "openNamed": "Invitations pour {training}",
        "invitations_one": "{count} invitation",
        "invitations_other": "{count} invitations"
      },
      "pause": {
        "open": "Mettre toutes les affectations en pause",
        "title": "Mettre toutes les affectations en pause",
        "body_one": "L’affectation en cours de ce formulaire sera mise en pause. Tant que vous ne la réactivez pas, rien n’est envoyé : les personnes qui terminent entre-temps ne reçoivent l’invitation qu’à la réactivation, si vous choisissez alors de reprendre les invitations. Les liens déjà envoyés restent valables.",
        "body_other": "Les {count} affectations en cours de ce formulaire seront mises en pause. Tant que vous ne les réactivez pas, rien n’est envoyé : les personnes qui terminent entre-temps ne reçoivent l’invitation qu’à la réactivation, si vous choisissez alors de reprendre les invitations. Les liens déjà envoyés restent valables.",
        "confirm": "Mettre en pause",
        "done_one": "{count} affectation est maintenant en pause.",
        "done_other": "{count} affectations sont maintenant en pause."
      },
      "resume": {
        "open": "Réactiver…",
        "title": "Réactiver les affectations",
        "loadError": "Les invitations en attente n’ont pas pu être chargées.",
        "intro": "Rien n’a été envoyé pendant la pause. Voici ce qui est en attente par formation : les invitations d’avant la pause, et celles des personnes qui ont terminé pendant la pause.",
        "nothingHeld": "Rien n’est en attente. La réactivation remet les affectations en marche ; les personnes qui terminent ensuite reçoivent le formulaire tel qu’il sera alors.",
        "table": {
          "caption": "Invitations en attente par formation",
          "training": "Formation",
          "before": "D’avant la pause",
          "during": "Pendant la pause",
          "oldest": "La plus ancienne",
          "beyond": "Annulées par la limite",
          "total": "Total",
          "days_one": "{count} jour",
          "days_other": "{count} jours",
          "none": "aucune",
          "unknownTraining": "Formation sans nom"
        },
        "choice": {
          "legend": "Que deviennent les invitations en attente ?",
          "pickUp": "Reprendre les invitations",
          "pickUpHint": "Elles sont tout de même envoyées, toutes avec le formulaire tel qu’il est maintenant. Si leur moment est déjà passé, elles partent maintenant ; le délai de réponse commence à l’envoi.",
          "decline": "Ne pas les reprendre",
          "declineHint": "Elles sont annulées, et les personnes qui ont terminé pendant la pause n’en reçoivent pas.",
          "required": "Veuillez choisir si vous reprenez les invitations en attente."
        },
        "limit": {
          "label": "Limite d’âge en jours",
          "hint": "Facultatif : seules les invitations de moins de ce nombre de jours sont reprises ; les plus anciennes sont annulées. Laissez vide pour tout reprendre.",
          "beyond_one": "Avec cette limite, {count} des {total} invitations en attente est annulée ; les autres sont reprises.",
          "beyond_other": "Avec cette limite, {count} des {total} invitations en attente sont annulées ; les autres sont reprises.",
          "checkFailed": "La limite n’a pas pu être vérifiée."
        },
        "confirm": "Réactiver",
        "done_one": "{count} affectation est de nouveau active. Reprises : {refrozen}, annulées : {withdrawn}.",
        "done_other": "{count} affectations sont de nouveau actives. Reprises : {refrozen}, annulées : {withdrawn}."
      },
      "backToWizard": "Retour à la formation",
      "fromWizardHint": "Vous venez de la formation que vous êtes en train de créer. Publiez ce formulaire pour le choisir là-bas ; vous y retournerez alors automatiquement. Vos saisies dans la formation sont conservées."
    },
    "gradingLink": "Aller à la correction"
  },
  "questionnaireSettings": {
    "intro": "Les valeurs par défaut avec lesquelles commencent les nouvelles invitations et questions à échelle. Si vous laissez un champ vide, la valeur par défaut de la plateforme s’applique.",
    "followsPlatform": "Vous n’avez encore rien défini ici : les valeurs par défaut de la plateforme s’appliquent partout.",
    "window": {
      "legend": "Délai de réponse",
      "hint": "Combien de temps une invitation peut être remplie après son envoi, sauf si l’affectation en décide autrement. Une modification s’applique aux invitations envoyées à partir de maintenant.",
      "label": "Nombre de jours",
      "platform_one": "Vide : {count} jour, la valeur par défaut de la plateforme.",
      "platform_other": "Vide : {count} jours, la valeur par défaut de la plateforme."
    },
    "reminder": {
      "legend": "Relances",
      "hint": "Nombre de jours pendant lesquels une invitation doit rester ouverte avant que « Relancer tout le monde » et la relance automatique la prennent en compte. Ainsi, personne ne reçoit de relance juste après l’invitation. Une relance envoyée à la main à une seule personne n’en tient pas compte.",
      "zero": "0 : aucun minimum.",
      "label": "Nombre minimal de jours après l’envoi",
      "platform_one": "Vide : {count} jour, la valeur par défaut de la plateforme.",
      "platform_other": "Vide : {count} jours, la valeur par défaut de la plateforme."
    },
    "scale": {
      "legend": "Plage de l’échelle",
      "hint": "La plage avec laquelle commence une nouvelle question à échelle. Vous pouvez l’ajuster pour chaque question ; les questions existantes gardent leur propre plage.",
      "pairRule": "Renseignez les deux valeurs, ou laissez-les toutes deux vides.",
      "min": "Valeur la plus basse",
      "max": "Valeur la plus haute",
      "platform": "Vide : {value}, la valeur par défaut de la plateforme."
    },
    "saved": "Les paramètres ont été enregistrés.",
    "saveFailed": "L’enregistrement a échoué."
  },
  "retentionSettings": {
    "intro": "Combien de temps l'historique de formation de votre environnement est conservé, par type d'enregistrement et à compter de la date de l'enregistrement. Une fois la durée écoulée, le traitement de conservation nocturne supprime l'enregistrement — l'enregistrement, pas la personne. Laissez un champ vide pour conserver l'enregistrement.",
    "keepHint": "Vide : conserver. C'est la valeur par défaut.",
    "defaultHint_one": "Par défaut : {count} mois. Vide : conserver.",
    "defaultHint_other": "Par défaut : {count} mois. Vide : conserver.",
    "keepPlaceholder": "Conserver",
    "types": {
      "enrollment": "Inscriptions (mois)",
      "attendance": "Présences (mois)",
      "attempt": "Tentatives e-learning (mois)",
      "completion": "Achèvements (mois)",
      "qualification": "Qualifications (mois après la fin ou l’expiration)",
      "certificate": "Certificats (mois)",
      "evaluation_response": "Évaluations (mois après l’envoi)",
      "import_raw_data": "Données d'import brutes (mois)"
    },
    "history": {
      "legend": "Historique de formation",
      "hint": "Les achèvements, qualifications et certificats sont conservés par défaut : ils prouvent ce qu'une personne a obtenu. Une inscription ou un achèvement auquel est encore lié un élément conservé est ignoré jusqu'à ce que celui-ci ait aussi expiré. Une qualification encore valable n'est jamais supprimée."
    },
    "evaluation": {
      "legend": "Évaluations",
      "hint": "Les évaluations remplies et les autres avis. Un test de connaissances n'a pas de durée propre : il disparaît avec l'achèvement auquel il appartient.",
      "action": "Après la durée",
      "actions": {
        "anonymise": "Anonymiser : les réponses restent pour les rapports, sans nom",
        "delete": "Supprimer : la réponse et ses réponses détaillées sont supprimées"
      }
    },
    "imports": {
      "legend": "Données d'import brutes",
      "hint": "Les lignes lues depuis un fichier RH, avec par exemple des noms et des dates de naissance. Après la durée, elles sont vidées ; le récapitulatif de l'import est conservé."
    },
    "fixed": {
      "legend": "Durées fixes",
      "personalData_one": "Les données personnelles d'un utilisateur supprimé sont rendues méconnaissables {count} jour après la suppression. BCS fixe cette durée pour votre environnement.",
      "personalData_other": "Les données personnelles d'un utilisateur supprimé sont rendues méconnaissables {count} jours après la suppression. BCS fixe cette durée pour votre environnement.",
      "mailOutbox_one": "Les e-mails envoyés sont supprimés après {count} jour (une durée de la plateforme).",
      "mailOutbox_other": "Les e-mails envoyés sont supprimés après {count} jours (une durée de la plateforme)."
    },
    "lastRun": {
      "legend": "Dernière application",
      "none": "Les durées de conservation n'ont pas encore été appliquées. Cela se fait chaque nuit.",
      "summary": "Le {date} : {erased} utilisateurs rendus méconnaissables, {records} enregistrements traités et {shells} comptes vides supprimés."
    },
    "saved": "Les durées de conservation ont été enregistrées.",
    "saveFailed": "L'enregistrement n'a pas abouti."
  },
  "questionnaireStatus": {
    "heading": "État de la règle",
    "heading_test": "État de la règle de test",
    "backToForm": "Vers le formulaire",
    "backToForm_test": "Aller au test",
    "backToSurveys": "Vers les questionnaires autonomes",
    "backToTraining": "Vers la formation",
    "subject": "{form} pour {training}",
    "subjectWithoutTraining": "Questionnaire « {form} »",
    "subjectWithoutTraining_test": "Test {form}",
    "anonymous": "Anonyme",
    "anonymousNote": "Cette règle est anonyme : vous voyez combien d’invitations se trouvent dans chaque état, mais pas à qui elles appartiennent. Il n’est donc pas possible de relancer ou de renvoyer par personne ; relancer toutes les personnes qui n’ont pas encore répondu l’est.",
    "anonymousBelowFloor": "Le résultat reste masqué tant que {floor} réponses ne sont pas arrivées, toutes sessions confondues. Jusqu’à présent : {counted} sur {floor}.",
    "loadError": "Cette règle n’a pas pu être chargée.",
    "loadError_test": "Cette règle de test n’a pas pu être chargée.",
    "notFound": "Cette règle n’existe pas (ou plus).",
    "notFound_test": "Cette règle de test n’existe pas (ou plus).",
    "actionFailed": "Cela n’a pas fonctionné. Veuillez réessayer.",
    "backToRule": "Vers la règle",
    "backToRule_test": "Aller à la règle de test",
    "occurrence": {
      "heading": "Affectation : {date}, {location}",
      "headingNoLocation": "Affectation : {date}",
      "headingLoading": "Affectation",
      "notFound": "Cette affectation n’existe pas (ou plus).",
      "loadError": "Cette affectation n’a pas pu être chargée."
    },
    "occurrences": {
      "title": "Affectations",
      "hint": "Par session de la formation : qui a été invité et où en sont les personnes. Ouvrez une affectation pour voir les personnes.",
      "empty": "Rien n’a encore été envoyé pour cette règle.",
      "empty_test": "Personne n’a encore été invité pour cette règle de test.",
      "loadError": "Les affectations n’ont pas pu être chargées.",
      "future_one": "{count} session à venir, rien d’envoyé pour l’instant.",
      "future_other": "{count} sessions à venir, rien d’envoyé pour l’instant.",
      "column": {
        "date": "Session",
        "location": "Lieu",
        "trainers": "Formateurs",
        "sent": "Envoyées",
        "submitted": "Remplies",
        "open": "Ouvertes",
        "expired": "Expirées",
        "actions": "Actions"
      },
      "sentOf": "{sent} sur {invited}",
      "submittedOf": "{count} ({percent} %)",
      "view": "Voir",
      "viewNamed": "Voir l’affectation de {name}",
      "noDate": "Pas de date",
      "none": "–"
    },
    "assignment": {
      "active": "En cours",
      "paused": "En pause",
      "archived": "Archivée"
    },
    "notRunning": {
      "paused": "Cette règle est en pause. Vous pourrez de nouveau relancer et renvoyer dès qu’elle sera réactivée ; les liens déjà envoyés restent valables.",
      "paused_test": "Cette règle de test est en pause. Rien ne part tant qu’elle n’est pas reprise.",
      "archived": "Cette règle est archivée. Il n’est plus possible de relancer ni de renvoyer ; les liens déjà envoyés restent valables jusqu’à leur expiration.",
      "archived_test": "Cette règle de test est archivée et n’envoie plus rien."
    },
    "counts": {
      "title": "Décomptes",
      "loadError": "Les décomptes n’ont pas pu être chargés.",
      "empty": "Aucune invitation n’a encore été créée à partir de cette règle.",
      "mailFailed": "Échec de l’e-mail",
      "mailFailedHint": "En cas d’échec de l’e-mail, l’invitation figure comme envoyée, mais l’e-mail n’est pas arrivé. Renvoyer l’envoie une nouvelle fois : avec un nouveau lien, ou avec l’adresse dans Mes questionnaires si le questionnaire ne s’ouvre que dans l’application.",
      "submittedOf": "sur {total} ({percent} %)",
      "submittedHint": "Invitations pour lesquelles le questionnaire a été rempli.",
      "submittedHint_test": "Invitations pour lesquelles le test a été rempli.",
      "open": "Ouvertes",
      "openHint": "Envoyées et pas encore remplies.",
      "expiredHint": "Le délai de réponse est écoulé sans réponse. Renvoyer rouvre l’invitation.",
      "moreDetail": "Plus : ce qui doit encore partir et ce qui n’aura pas lieu",
      "lessDetail": "Afficher moins",
      "toSend": "À envoyer",
      "toSendHint": "Pas encore envoyées : planifiées, en attente de présence, en attente d’une clôture définitive, ou retenues pendant une pause.",
      "notGoingAhead": "N’aura pas lieu",
      "notGoingAheadHint": "Annulées ou plus à envoyer, avec le motif."
    },
    "state": {
      "waiting": "En attente d’envoi",
      "held": "En attente (pause)",
      "waiting_for_attendance": "En attente de la présence",
      "waiting_for_completion": "En attente que la clôture soit définitive",
      "sent": "Envoyée",
      "submitted": "Remplie",
      "expired": "Expirée",
      "cancelled": "Annulée",
      "recipient_inactive": "Destinataire inactif",
      "waitingReady": "Prête à être envoyée"
    },
    "reason": {
      "completion_withdrawn": "Achèvement retiré",
      "condition_not_met": "Condition non remplie",
      "pause_declined": "Non reprise après la pause",
      "archived": "Affectation archivée",
      "recipient_inactive": "Destinataire inactif",
      "session_removed": "Séance supprimée",
      "occurrence_cancelled": "Session annulée",
      "enrollment_cancelled": "Inscription annulée",
      "unknown": "Motif inconnu"
    },
    "list": {
      "title": "Invitations",
      "loadError": "Les invitations n’ont pas pu être chargées.",
      "empty": "Il n’y a pas encore d’invitations.",
      "column": {
        "respondent": "Destinataire",
        "state": "État",
        "sent": "Envoyée",
        "expires": "Expire",
        "reminded": "Dernière relance",
        "actions": "Actions"
      },
      "erased": "Utilisateur supprimé",
      "anonymousRespondent": "Anonyme",
      "scheduled": "Prévue le {date}",
      "submittedOn": "Remplie le {date}",
      "withdrawnOn": "{reason}, le {date}",
      "cycle": "Cycle {cycle}",
      "notYet": "Pas encore",
      "waitingUntil": "Part le {date}",
      "waitingNextRound": "Part lors du prochain cycle d’envoi",
      "sendingOff": "L’envoi est désactivé pour cet environnement ; l’invitation part dès qu’il est réactivé",
      "emptyFiltered": "Aucune invitation dans le groupe « {name} »."
    },
    "actions": {
      "remind": "Relancer maintenant",
      "remindNamed": "Relancer {name} maintenant",
      "resend": "Renvoyer",
      "resendNamed": "Renvoyer à {name}",
      "reminded": "Une relance est prête à partir pour {name}.",
      "resent": "Un nouveau lien est prêt à partir pour {name}.",
      "reopened": "Un nouveau lien est prêt à partir pour {name}. L’invitation avait expiré et est rouverte jusqu’au {date} ; les liens précédents restent fermés.",
      "resentInApp": "Un e-mail vers Mes questionnaires est prêt à partir pour {name}.",
      "reopenedInApp": "Un e-mail vers Mes questionnaires est prêt à partir pour {name}. L’invitation avait expiré et est rouverte jusqu’au {date}."
    },
    "filter": {
      "active": "Filtre : {name}",
      "clear": "Supprimer le filtre : {name}"
    },
    "remindOpen": {
      "open": "Relancer toutes les personnes en attente",
      "title": "Relancer toutes les personnes qui n’ont pas encore répondu",
      "body_one": "{count} invitation est ouverte. Les personnes qui n’ont pas encore répondu reçoivent une relance : avec un nouveau lien, ou avec l’adresse de Mes questionnaires si le questionnaire ne s’ouvre que dans l’application ; un lien envoyé auparavant reste valable. Les personnes relancées récemment sont ignorées.",
      "body_other": "{count} invitations sont ouvertes. Les personnes qui n’ont pas encore répondu reçoivent une relance : avec un nouveau lien, ou avec l’adresse de Mes questionnaires si le questionnaire ne s’ouvre que dans l’application ; un lien envoyé auparavant reste valable. Les personnes relancées récemment sont ignorées.",
      "confirm": "Envoyer les relances",
      "nothingOpen": "Aucune invitation n’est ouverte pour une relance pour le moment.",
      "done_one": "{count} relance prête à partir.",
      "done_other": "{count} relances prêtes à partir.",
      "previewWill_one": "{count} relance va partir.",
      "previewWill_other": "{count} relances vont partir.",
      "previewSkipped_one": "{count} ignorée ({reason}).",
      "previewSkipped_other": "{count} ignorées ({reason}).",
      "daysAgo_one": "invité il y a moins de {count} jour",
      "daysAgo_other": "invité il y a moins de {count} jours",
      "skip": {
        "reminded_recently": "Déjà relancées récemment : {count}",
        "too_soon_after_send": "Invitées trop récemment : {count}",
        "mail_on_its_way": "Un e-mail était déjà en route : {count}",
        "recipient_inactive": "Destinataire inactif : {count}",
        "no_address": "Pas d’adresse e-mail : {count}",
        "not_queued": "L’e-mail n’a pas pu être préparé : {count}",
        "closed": "Remplies, annulées ou expirées entre-temps : {count}"
      }
    },
    "openResults": "Voir les résultats"
  },
  "auditLog": {
    "heading": "Journal",
    "intro": "Qui a modifié quoi et quand. Filtrez par colonne ; aucun filtre n'est appliqué par défaut, vous voyez donc tout, du plus récent au plus ancien.",
    "export": "Exporter (CSV)",
    "empty": "Le journal est encore vide.",
    "emptyFiltered": "Aucune entrée ne correspond à ces filtres.",
    "filterError": "Ce filtre ne peut pas être appliqué. Modifiez-le puis réessayez.",
    "pagination": "Pagination du journal",
    "prev": "Précédent",
    "next": "Suivant",
    "pageOf": "Page {page} sur {pages}",
    "diffShow": "Détails",
    "diffHide": "Masquer",
    "diffBefore": "Ancienne valeur",
    "diffAfter": "Nouvelle valeur",
    "diffContext": "Données",
    "badge": {
      "bcs": "pour le compte de BCS Learning"
    },
    "cols": {
      "when": "Quand",
      "category": "Catégorie",
      "action": "Action",
      "actor": "Qui",
      "target": "Sur quoi",
      "detail": "Détail"
    },
    "filters": {
      "from": "À partir du",
      "to": "Jusqu'au (inclus)",
      "category": "Catégorie",
      "categoryAll": "Toutes les catégories",
      "action": "Action",
      "actionPlaceholder": "Rechercher une action",
      "actor": "Personne",
      "actorAll": "Toutes les personnes",
      "bcsOnly": "Uniquement les actions pour le compte de BCS Learning",
      "clearAll": "Effacer tous les filtres",
      "none": "Cette colonne n'a pas de filtre",
      "targetActive": "Vous consultez l'historique d'un seul élément. Effacez les filtres pour voir tout le journal."
    },
    "categories": {
      "inschrijvingen": "Inscriptions",
      "catalogus": "Catalogue",
      "rechten": "Autorisations",
      "berichten": "Messages",
      "inloggen": "Connexion",
      "instellingen": "Paramètres",
      "organisatie": "Organisation",
      "beveiliging": "Sécurité",
      "overig": "Autre"
    },
    "diffField": "Champ",
    "redacted": "masqué",
    "reference": {
      "erasedUser": "Utilisateur supprimé",
      "erasedExternalPerson": "Personne externe supprimée",
      "removed": "supprimé"
    },
    "actorSystem": "Système",
    "actorSystemNamed": "Système ({name})",
    "history": {
      "heading": "Historique",
      "openFullLog": "Voir dans le journal",
      "empty": "Rien n'a encore été enregistré à ce sujet.",
      "notFound": "Cet élément n'existe pas (ou plus) ici ; il n'y a donc aucun historique à afficher.",
      "pagination": "Pagination de l'historique",
      "show": "Historique",
      "enrollmentTitle": "Historique de l'inscription de {name}"
    },
    "archive": {
      "periodArchived": "Cette période a été archivée.",
      "periodArchivedHint": "Ces entrées ne figurent plus dans le journal lui-même mais dans l'archive. Exportez le mois, ou récupérez-le temporairement pour le consulter ici.",
      "olderArchived": "Le journal jusqu'à {month} inclus a été archivé. Choisissez une période dans la colonne Quand pour la consulter ou la récupérer.",
      "monthLabel": "{month} ({rows} entrées)",
      "export": "Exporter",
      "restore": "Récupérer cette période",
      "restoring": "{month} est en cours de récupération…",
      "restored": "{month} a été récupéré jusqu'au {date}.",
      "failed": "La récupération de {month} a échoué : le fichier d'archive ne correspondait pas ou était illisible.",
      "restoreError": "La récupération n'a pas pu être lancée. Veuillez réessayer.",
      "noRight": "Seule une personne autorisée à exporter le journal peut récupérer ou exporter une période.",
      "historyArchived": "L'historique plus ancien a été archivé.",
      "historyRestored": "L'historique plus ancien a été récupéré jusqu'au {date}."
    },
    "fields": {
      "title": "Titre",
      "summary": "Résumé",
      "description": "Description",
      "status": "Statut",
      "type": "Type",
      "name": "Nom",
      "category": "Catégorie",
      "first_name": "Prénom",
      "last_name": "Nom de famille",
      "email": "Adresse e-mail",
      "phone": "Numéro de téléphone",
      "locale": "Langue",
      "external_id": "Clé externe",
      "attributes": "Informations complémentaires",
      "manager_user_id": "Responsable",
      "hire_date": "Date d'entrée",
      "end_date": "Date de sortie",
      "account_valid_from": "Compte valide à partir du",
      "account_valid_until": "Compte valide jusqu'au",
      "last_login_at": "Dernière connexion",
      "profile_picture_url": "Photo de profil",
      "password": "Mot de passe",
      "user_id": "Participant",
      "learning_activity_id": "Activité d'apprentissage",
      "occurrence_id": "Session",
      "waitlist_position": "Place sur la liste d'attente",
      "cancelled_at": "Annulé le",
      "cancel_reason": "Précision sur l'annulation",
      "cancel_reason_id": "Motif d'annulation",
      "cancel_requested_at": "Annulation demandée le",
      "transferred_from_enrollment_id": "Déplacée depuis l'inscription",
      "offer_expires_at": "L'offre expire le",
      "composition": "Composition",
      "tracking_mode": "Suivi de la progression",
      "source_kind": "Source",
      "source_file": "Fichier source",
      "completion_rule": "Règle d'achèvement",
      "completion_threshold": "Pourcentage d'achèvement",
      "duration": "Durée",
      "duration_minutes": "Durée (minutes)",
      "language": "Langue",
      "labels": "Mots-clés",
      "tags": "Mots-clés",
      "visibility_mode": "Visibilité",
      "access_group_id": "Groupe d'accès",
      "allow_anonymous": "Accès anonyme",
      "max_enrollments": "Nombre d'inscriptions",
      "max_waitlist_registrations": "Nombre d'inscriptions en liste d'attente",
      "approval_flow_id": "Circuit d'approbation",
      "waitlist_enabled": "Liste d'attente",
      "waitlist_promotion_mode": "Attribution d'une place libérée",
      "offer_window_hours": "Délai de l'offre (heures)",
      "waitlist_cap": "Plafond de la liste d'attente",
      "cancellation_deadline": "Date limite d'annulation",
      "cancel_before": "Annulation avant la date limite",
      "cancel_after": "Annulation après la date limite",
      "min_participants": "Participants min.",
      "max_participants": "Participants max.",
      "enrollment_deadline": "Date limite d'inscription",
      "delivery_mode": "Mode de dispense",
      "timezone": "Fuseau horaire",
      "waitlist_enabled_by_default": "Liste d'attente activée par défaut",
      "waitlist_offer_window_hours": "Délai de l'offre (heures)",
      "cancel_before_default": "Par défaut : annulation avant la date limite",
      "cancel_after_default": "Par défaut : annulation après la date limite",
      "visibility_mode_default": "Visibilité par défaut",
      "approval_flow_id_default": "Circuit d'approbation par défaut",
      "max_enrollments_default": "Nombre d'inscriptions par défaut",
      "max_waitlist_registrations_default": "Nombre d'inscriptions en liste d'attente par défaut",
      "enabled": "Activé",
      "frequency": "Fréquence",
      "send_time": "Heure d'envoi",
      "send_weekday": "Jour d'envoi",
      "response_window_days": "Délai de réponse (jours)",
      "scale_min": "Valeur la plus basse de l'échelle",
      "scale_max": "Valeur la plus haute de l'échelle",
      "anonymity_floor": "Seuil d'anonymat",
      "reminder_min_days_after_send": "Rappel après (jours)",
      "enrollment_months": "Conservation des inscriptions (mois)",
      "attendance_months": "Conservation des présences (mois)",
      "attempt_months": "Conservation des tentatives (mois)",
      "completion_months": "Conservation des achèvements (mois)",
      "qualification_months": "Conservation des qualifications (mois)",
      "certificate_months": "Conservation des certificats (mois)",
      "evaluation_response_months": "Conservation des réponses d'évaluation (mois)",
      "evaluation_response_action": "Après le délai, les réponses d'évaluation sont",
      "import_raw_data_months": "Conservation des données d'import (mois)"
    }
  },
  "approvalsOverview": {
    "heading": "Toutes les approbations",
    "intro": "Toutes les approbations encore en attente dans cet environnement, avec la personne chargée du dossier et le temps d'attente. Si une demande reste bloquée, vous pouvez la transférer ou la traiter vous-même.",
    "empty": "Rien n'est en attente pour le moment.",
    "cols": {
      "applicant": "Demandeur",
      "course": "Activité",
      "assignee": "Responsable",
      "waiting": "En attente depuis"
    },
    "kind": {
      "enrollment": "Inscription",
      "cancellation": "Annulation",
      "external_request": "Formation externe",
      "other": "Autre"
    },
    "unknownApplicant": "Inconnu",
    "noAssignee": "Chez personne",
    "waitingDays_one": "{count} jour",
    "waitingDays_other": "{count} jours",
    "remind": "Relancer",
    "reminded": "Relancé",
    "remindFailed": "La relance n'a pas été envoyée. La demande a peut-être déjà été traitée ou retirée.",
    "move": "Transférer",
    "approve": "Approuver",
    "reject": "Refuser",
    "moveTitle": "Transférer l'approbation",
    "moveBody": "La demande de {applicant} est actuellement chez {assignee}. Choisissez qui la reprend.",
    "moveConfirm": "Transférer",
    "movePickerLabel": "Nouveau responsable",
    "movePickerPlaceholder": "Rechercher par nom ou adresse e-mail",
    "moveFailed": "Le transfert a échoué.",
    "rejectTitle": "Refuser la demande",
    "rejectComment": "Message pour le demandeur",
    "decideFailed": "La décision n'a pas abouti. La demande a peut-être déjà été traitée ou retirée."
  },
  "approvalFlows": {
    "heading": "Flux d'approbation",
    "intro": "Un flux d'approbation est une chaîne d'approbateurs. Vous choisissez le flux applicable par activité d'apprentissage.",
    "new": "Nouveau flux",
    "empty": "Il n'y a pas encore de flux d'approbation.",
    "noSteps": "aucune étape",
    "stepCount": "{n} étape(s)",
    "platformBadge": "Par défaut",
    "ownBadge": "Propre",
    "platformReadOnly": "Ceci est un flux par défaut de la plateforme. Vous pouvez le sélectionner et le consulter, mais pas le modifier.",
    "filterOwner": "Propriétaire",
    "stepsHeading": "Étapes (dans l'ordre)",
    "stepN": "Étape {n}",
    "addStep": "Ajouter une étape",
    "choose": "Choisir...",
    "singlePerson": "Cette route donne toujours une seule personne.",
    "deadlineEscalates": "Si le délai expire, une étape supplémentaire pour les RH est ajoutée.",
    "dependsOnApplicant": "Qui est-ce dépend du demandeur.",
    "nobodyFallsBackToHr": "Personne trouvée — repli sur les RH.",
    "deleteTitle": "Supprimer le flux",
    "deleteBody": "Voulez-vous vraiment supprimer {name} ?",
    "deleteFailed": "Suppression impossible. Ce flux est-il encore utilisé ?",
    "saveFailed": "Enregistrement impossible. Veuillez vérifier les étapes.",
    "cols": {
      "name": "Nom",
      "chain": "Chaîne"
    },
    "owner": {
      "all": "Tous",
      "platform": "Par défaut (plateforme)",
      "own": "Flux propres"
    },
    "mode": {
      "any": "Une approbation suffit",
      "all": "Tous doivent approuver"
    },
    "fields": {
      "name": "Nom",
      "description": "Description",
      "expiresAfterDays": "Délai de décision (jours)",
      "expiresAfterDaysHint": "Laissez vide pour qu'une demande n'expire jamais. Avec un délai, une demande que personne ne traite expire et la place est libérée pour quelqu'un d'autre.",
      "warnDaysBefore": "Avertir (jours avant)",
      "warnDaysBeforeHint": "Le demandeur est averti ce nombre de jours avant l'expiration, afin qu'il puisse encore relancer la personne chargée de l'approbation.",
      "route": "Qui décide",
      "role": "Rôle",
      "orgLevel": "Niveau",
      "orgField": "Champ de rôle",
      "decisionMode": "Avec plusieurs personnes",
      "deadline": "Délai de décision",
      "deadlineHours": "Heures",
      "person": "Personne"
    },
    "route": {
      "own_manager": "Responsable direct",
      "org_role": "Rôle sur une unité d'organisation",
      "tenant_role": "Rôle dans cet environnement",
      "fixed_person": "Personne déterminée"
    },
    "settingsHeading": "Approbations",
    "settingsIntro": "Choisissez le flux d'approbation prérempli pour une nouvelle activité d'apprentissage.",
    "settingsNone": "Aucune approbation — inscription directe",
    "defaultLabel": "Valeur par défaut pour les nouvelles activités",
    "defaultHint": "Uniquement un préremplissage : les activités existantes ne changent pas, et une activité sans approbation n'est jamais remplacée.",
    "manageLink": "Gérer les flux d'approbation",
    "editor": {
      "inspector": "Inspecteur",
      "selectHint": "Sélectionnez une étape de la chaîne pour la modifier, ou ajoutez une étape.",
      "removeStep": "Supprimer l'étape",
      "moveUp": "Déplacer l'étape plus tôt dans la chaîne",
      "moveDown": "Déplacer l'étape plus tard dans la chaîne"
    },
    "node": {
      "request": "Demande",
      "requestTitle": "Quelqu'un demande une approbation",
      "outcome": "Résultat",
      "outcomeTitle": "Approuvée",
      "allOf": "tous doivent approuver",
      "deadline": "{n} heures"
    }
  },
  "workflows": {
    "heading": "Workflows",
    "intro": "Automatisez des actions sur des événements : déclencheur → condition → étapes.",
    "new": "Nouveau workflow",
    "empty": "Aucun workflow pour l'instant.",
    "on": "Activé",
    "off": "Désactivé",
    "system": "Standard",
    "custom": "Personnalisé",
    "locked": "Verrouillé",
    "lockedHint": "Verrouillé par la plateforme — vous pouvez uniquement le consulter, pas le désactiver, le modifier ni le supprimer.",
    "unavailable": "Ignoré",
    "unavailableHint": "Ce workflow utilise un élément qui n'est pas disponible dans cet environnement ; il est donc ignoré. Il est conservé.",
    "unavailableNotice": "Un ou plusieurs workflows sont ignorés : ils utilisent un élément qui n'est pas disponible dans cet environnement. Ils sont conservés.",
    "systemHint": "Workflow standard fourni par la plateforme. Vous pouvez le désactiver ; vous ne pouvez pas le supprimer (le modifier en crée une copie personnalisée).",
    "confirmDelete": "Supprimer le workflow ?",
    "confirmDeleteBody": "Ceci supprime définitivement « {name} ».",
    "cols": {
      "name": "Nom",
      "trigger": "Déclencheur",
      "enabled": "Actif",
      "origin": "Type"
    },
    "fields": {
      "name": "Nom",
      "key": "Clé",
      "keyHint": "Clé stable et unique au sein de votre tenant (minuscules, tirets).",
      "trigger": "Déclencheur",
      "description": "Description",
      "enabled": "Activer immédiatement"
    },
    "schedule": {
      "heading": "Moment du déclenchement",
      "offsetDays": "Décalage en jours",
      "offsetHint": "Négatif = avant la date (p. ex. -7 pour le pré-boarding), 0 = le jour même, positif = après.",
      "offsetHintAfter": "Nombre de jours après l'inscription. 0 = le jour même, 7 = une semaine plus tard.",
      "time": "Heure (fuseau du locataire)"
    },
    "editor": {
      "inspector": "Inspecteur",
      "selectHint": "Sélectionnez un bloc pour le modifier, ou ajoutez une étape.",
      "actionTitle": "Action",
      "actionKind": "Type d'action",
      "actionNoSettings": "Cette action n'a pas de paramètres.",
      "approvalTitle": "Approbation",
      "addAction": "Action",
      "addApproval": "Approbation",
      "removeStep": "Supprimer le bloc",
      "addMail": "+ E-mail",
      "subject": "Objet",
      "body": "Contenu",
      "dueHours": "Échéance après (heures)",
      "saved": "Enregistré.",
      "lockedNotice": "Ce workflow est verrouillé par la plateforme. Vous pouvez le consulter, mais pas le modifier.",
      "systemNotice": "Ceci est un workflow standard. Modifier et enregistrer la définition le transforme en copie personnalisée (détachée de l'ensemble global).",
      "recipient": {
        "label": "Destinataire",
        "subjectUser": "L'utilisateur concerné",
        "fixed": "Adresse fixe",
        "orgUnitRole": "Rôle d'unité organisationnelle",
        "address": "Adresse e-mail",
        "orgUnitManager": "Responsable de l'unité organisationnelle",
        "contentOwner": "Gestionnaire de la formation",
        "occurrenceTrainers": "Formateur(s) de la session"
      },
      "unit": {
        "label": "Unité organisationnelle",
        "subjectUnit": "L'unité de l'utilisateur",
        "orgRoot": "Organisation (racine)",
        "fieldKey": "Clé de champ (p. ex. ceo, teamlead)"
      },
      "branch": {
        "on_approve": "En cas d'approbation",
        "on_reject": "En cas de refus",
        "on_timeout": "En cas d'expiration"
      },
      "node": {
        "trigger": "Déclencheur",
        "action": "Action",
        "approval": "Approbation",
        "email": "E-mail",
        "digestLine": "Ligne dans l’e-mail récapitulatif",
        "confirmEnrollment": "Confirmer l’inscription",
        "rejectEnrollment": "Refuser l’inscription",
        "confirmCancellation": "Confirmer l’annulation",
        "rejectCancellation": "Refuser l’annulation",
        "materializeExternalRequest": "Enregistrer la formation externe",
        "rejectExternalRequest": "Refuser la demande de formation externe",
        "approvalTitle": "Examen"
      }
    },
    "help": {
      "link": "Aide",
      "backToList": "Retour aux workflows",
      "inEditor": "Aperçu dans l'éditeur",
      "title": "Comment fonctionnent les workflows",
      "intro": "Les workflows automatisent des actions sur des événements dans la plateforme. Chaque workflow suit le même schéma : un déclencheur le lance, des conditions facultatives filtrent quand il s'exécute réellement, et des étapes réalisent des actions — par exemple envoyer un e-mail ou demander une approbation.",
      "conceptsHeading": "Les briques de base",
      "concepts": {
        "trigger": {
          "title": "Déclencheur",
          "body": "L'événement qui lance le workflow, p. ex. « Utilisateur créé » ou « Inscription demandée ». Chaque workflow a exactement un déclencheur."
        },
        "scheduling": {
          "title": "Horaire des déclencheurs par date",
          "body": "Les déclencheurs par date (date d'entrée, date de sortie, validité du compte) se déclenchent un jour que vous choisissez : indiquez combien de jours avant ou après la date (p. ex. 7 jours avant la date d'entrée pour le pré-embarquement, ou 0 le jour même) et à quelle heure (par pas de 15 minutes, dans le fuseau horaire du locataire). Vous pouvez ainsi envoyer un e-mail de bienvenue le matin et un rappel l'après-midi. Un nouveau workflow ne se déclenche jamais rétroactivement : il ne se déclenche que pour les dates au moment ou après sa création, de sorte que les personnes déjà en poste ne le reçoivent pas après coup."
        },
        "condition": {
          "title": "Condition (facultative)",
          "body": "Un filtre qui détermine si le workflow s'exécute réellement, p. ex. uniquement lorsqu'une inscription est en libre-service. Sans condition : toujours exécuter."
        },
        "steps": {
          "title": "Étapes",
          "body": "Ce qui se passe, dans l'ordre. Une étape est soit une action (faire quelque chose), soit une approbation (attendre la décision de quelqu'un)."
        },
        "actionEmail": {
          "title": "Action : e-mail",
          "body": "Envoie automatiquement un e-mail. Vous choisissez le destinataire, l'objet et le contenu. Le texte peut utiliser des variables comme {tpl}, remplies pour chaque destinataire."
        },
        "approval": {
          "title": "Approbation",
          "body": "Met le workflow en pause jusqu'à ce que quelqu'un approuve ou refuse. Vous définissez qui décide, sous combien d'heures, et ce qui se passe en cas d'approbation, de refus ou d'expiration."
        },
        "recipient": {
          "title": "Destinataire via un rôle organisationnel",
          "body": "Le destinataire d'un e-mail ou d'une approbation n'est pas une personne fixe, mais une référence à un champ de rôle sur une unité organisationnelle (p. ex. teamlead ou ceo), relative à l'utilisateur concerné. Prérequis : ce champ est renseigné au bon niveau de la structure organisationnelle."
        },
        "enabling": {
          "title": "Activation et désactivation",
          "body": "Un workflow ne s'exécute que lorsqu'il est activé. Les workflows standard fournis par la plateforme peuvent être activés ou désactivés ; dès que vous modifiez et enregistrez les étapes, il devient une copie personnalisée détachée de l'ensemble global."
        },
        "locked": {
          "title": "Workflows verrouillés",
          "body": "Certains workflows sont verrouillés par la plateforme (icône de cadenas) : en tant qu'administrateur, vous pouvez les consulter, mais pas les désactiver, les modifier ni les supprimer. Les superadmins les gèrent de manière centralisée et déploient les modifications via « Synchroniser vers les tenants »."
        }
      },
      "examplesHeading": "Exemples",
      "resultLabel": "Résultat",
      "examples": {
        "welcome": {
          "title": "E-mail de bienvenue pour un nouvel utilisateur",
          "scenario": "Déclencheur « Utilisateur créé » → action e-mail vers l'utilisateur concerné, avec l'objet « Bienvenue, {tpl} ». Vous préférez informer les RH ? Choisissez alors une adresse fixe comme destinataire, p. ex. rh@entreprise.com.",
          "result": "Chaque nouvel utilisateur reçoit automatiquement un e-mail de bienvenue, sans aucune intervention d'un administrateur.",
          "flow": {
            "trigger": "Utilisateur créé",
            "action": "Envoyer un e-mail",
            "actionSub": "à l'utilisateur"
          }
        },
        "approval": {
          "title": "Approbation du manager lors d'une auto-inscription",
          "scenario": "Déclencheur « Inscription demandée » → condition « libre-service » → approbation par le teamlead de l'unité de l'utilisateur (échéance après 72 heures). En cas d'approbation : e-mail de confirmation à l'utilisateur. En cas de refus : e-mail de refus. En cas d'expiration : un rappel.",
          "result": "Les auto-inscriptions passent d'abord par le teamlead avant de devenir définitives, avec un suivi automatique.",
          "flow": {
            "trigger": "Inscription demandée",
            "condition": "Uniquement pour l'auto-inscription",
            "approval": "Approbation du teamlead",
            "approvalSub": "échéance après 72 heures",
            "onApprove": "E-mail de confirmation",
            "onReject": "E-mail de refus",
            "onTimeout": "Rappel"
          }
        }
      }
    }
  },
  "platformWorkflows": {
    "heading": "Workflows de plateforme",
    "intro": "Workflows globaux clonés vers chaque tenant. Les workflows verrouillés ne peuvent pas être modifiés par les administrateurs de tenant.",
    "new": "Nouveau workflow de plateforme",
    "empty": "Aucun workflow de plateforme pour l'instant.",
    "sync": "Synchroniser vers les tenants",
    "syncStarted": "Synchronisation lancée — les modifications sont déployées vers tous les tenants en arrière-plan.",
    "keyHint": "Clé stable et unique à l'échelle de la plateforme (minuscules, tirets).",
    "lockedField": "Verrouiller (les administrateurs ne peuvent pas le modifier)",
    "lockedHint": "Un workflow verrouillé est en lecture seule pour les tenants ; la plateforme contrôle aussi l'état activé/désactivé.",
    "lockedYes": "Verrouillé",
    "lockedNo": "Ouvert",
    "cols": {
      "locked": "Accès"
    },
    "confirmDelete": "Supprimer le workflow de plateforme ?",
    "confirmDeleteBody": "Ceci retire « {name} » de l'ensemble de la plateforme. Les copies déjà clonées chez les tenants sont conservées.",
    "editorNotice": "Les modifications effectuées ici n'atteignent les tenants existants qu'après une synchronisation ; les nouveaux tenants reçoivent l'état actuel à leur création.",
    "sync_status": {
      "col": "Déploiement",
      "none": "Aucun tenant",
      "notRolledOut": "Non déployé",
      "coverage": "{synced}/{total} tenants",
      "inSync": "À jour",
      "outdated": "{count} obsolète(s)",
      "outdatedHint": "Ces tenants exécutent encore une version antérieure — synchronisez pour les mettre à jour.",
      "overridden": "{count} personnalisé(s)",
      "overriddenHint": "Ces tenants ont eux-mêmes personnalisé le workflow ; une synchronisation les laisse intacts.",
      "syncOne": "Synchroniser",
      "syncOneHint": "Synchroniser uniquement ce workflow vers tous les tenants"
    }
  },
  "approvals": {
    "heading": "Approbations",
    "intro": "Approbations ouvertes en attente de votre décision.",
    "empty": "Aucune approbation en attente.",
    "due": "Échéance",
    "approve": "Approuver",
    "reject": "Refuser",
    "unknownWorkflow": "Workflow",
    "rejectTitle": "Refuser ?",
    "rejectBody": "Vous refusez « {name} ».",
    "reason": "Motif (facultatif)",
    "count": "{count} à traiter",
    "nothingToDo": "Rien à traiter.",
    "applicant": "Demandeur",
    "noIndependentTitle": "Aucun évaluateur indépendant : {name} a fait cette demande lui-même",
    "noIndependentBody": "Ajoutez un évaluateur à la chaîne, ou confiez-la à un administrateur disposant du droit de gérer les demandes.",
    "cannotDecideOwn": "Vous ne décidez pas de votre propre demande.",
    "course": "Formation",
    "bulk": {
      "selectAll": "Tout sélectionner",
      "selectRow": "Sélectionner « {name} »",
      "selectedCount": "{count} sélectionné(s)",
      "approveSelected": "Approuver la sélection",
      "rejectSelected": "Refuser la sélection",
      "confirmApproveTitle": "Approuver la sélection ?",
      "confirmApproveBody": "Vous approuvez {count} demandes en une fois. Les demandeurs en seront informés.",
      "confirmRejectTitle": "Refuser la sélection ?",
      "confirmRejectBody": "Vous refusez {count} demandes en une fois. Le motif que vous indiquez s’applique à toutes les demandes refusées.",
      "resultSummary": "{decided} sur {requested} traitées.",
      "outcome": {
        "already_handled": "{count} étaient déjà traitées.",
        "forbidden": "{count} ne vous étaient pas attribuées.",
        "not_found": "{count} n’existaient plus."
      }
    },
    "kind": {
      "enrollment": "Inscriptions",
      "cancellation": "Annulations",
      "external_request": "Formation externe",
      "other": "Autres"
    }
  },
  "mailOutbox": {
    "title": "Boîte d’envoi",
    "empty": "Aucun e-mail envoyé pour l’instant.",
    "forwardTo": "Transférer à des utilisateurs",
    "forwardPlaceholder": "Choisissez un ou plusieurs utilisateurs…",
    "filterStatus": "Filtrer par statut",
    "filterAll": "Tous les statuts",
    "retentionNotice": "Vous voyez ici les e-mails des {days} derniers jours.",
    "recipients_one": "{count} destinataire",
    "recipients_other": "{count} destinataires",
    "openedOf": "{opened} / {total}",
    "expand": "Afficher les destinataires",
    "collapse": "Masquer les destinataires",
    "batchMore": "Les {shown} premiers destinataires sur {total} — affinez avec la recherche ou le filtre de statut.",
    "cols": {
      "status": "Statut",
      "to": "Destinataire",
      "subject": "Objet",
      "scheduled": "Planifié / envoyé",
      "opens": "Ouvertures"
    },
    "status": {
      "scheduled": "Planifié",
      "sending": "Envoi en cours",
      "sent": "Envoyé",
      "failed": "Échec",
      "cancelled": "Annulé",
      "suppressed": "Non envoyé"
    },
    "actions": {
      "view": "Afficher",
      "cancel": "Annuler",
      "resend": "Renvoyer",
      "forward": "Transférer"
    },
    "detail": {
      "title": "Afficher l’e-mail",
      "recipient": "Destinataire",
      "body": "Contenu",
      "attachments": "Pièces jointes",
      "noBody": "Aucun contenu n’a été conservé pour cet e-mail.",
      "error": "Message d'erreur :",
      "attachmentNotAllowed": "Vous ne pouvez pas ouvrir cette pièce jointe. Seuls l'expéditeur ou un destinataire du message peuvent le faire."
    }
  },
  "mailTemplates": {
    "title": "Textes d’e-mail",
    "intro": "Personnalisez les textes des e-mails système pour votre organisation. Les textes par défaut sont gérés par la plateforme ; vous n’enregistrez, par langue, que vos propres adaptations.",
    "searchPlaceholder": "Rechercher par nom ou contexte…",
    "empty": "Aucun modèle d’e-mail trouvé.",
    "edit": "Modifier",
    "notTranslated": "Cette langue n’a pas encore été traduite. Les destinataires reçoivent le texte de la langue de repli — affiché ci-dessous.",
    "badge": {
      "locked": "Verrouillé",
      "customized": "Personnalisé",
      "global": "Par défaut"
    },
    "preview": {
      "title": "Aperçu",
      "subject": "Objet",
      "error": "L’aperçu n’a pas pu être généré."
    },
    "tags": {
      "intro": "Cliquez sur un tag pour l’insérer à la position du curseur.",
      "scope": {
        "context": "Contexte",
        "global": "Général",
        "link": "Liens"
      }
    },
    "editor": {
      "back": "Retour à la vue d’ensemble",
      "lockedNote": "Ce modèle est verrouillé par la plateforme et ne peut pas être personnalisé.",
      "footerHint": "Ce texte apparaît comme pied de page au bas de chaque e-mail. Laissez vide pour ne pas afficher de pied de page.",
      "lockedBody": "Le contenu est affiché dans l’aperçu ci-contre.",
      "subject": "Objet",
      "preheader": "Préheader",
      "preheaderHint": "Bref résumé que certains clients de messagerie affichent à côté de l’objet.",
      "body": "Contenu",
      "save": "Enregistrer",
      "saved": "Enregistré.",
      "saveErrorTitle": "Le texte contient des erreurs",
      "reset": "Rétablir le texte par défaut",
      "resetLoaded": "Texte par défaut chargé — cliquez sur Enregistrer pour confirmer.",
      "customized": "Personnalisé pour votre organisation.",
      "testTitle": "Envoyer un e-mail de test",
      "testTo": "Adresse e-mail du destinataire",
      "testSend": "Envoyer le test",
      "testOk": "E-mail de test envoyé."
    }
  },
  "centralMailTemplates": {
    "title": "Textes d’e-mail globaux",
    "intro": "Gérez les textes par défaut des e-mails système par langue. Ce sont les textes dont hérite chaque tenant ; verrouillez un modèle pour bloquer la personnalisation par tenant.",
    "searchPlaceholder": "Rechercher par nom ou contexte…",
    "empty": "Aucun modèle d’e-mail trouvé.",
    "badge": {
      "locked": "Verrouillé",
      "missing": "Incomplet",
      "customized": "{count} personnalisé(s)"
    },
    "customizedTooltip": "Tenants avec un texte personnalisé :",
    "notTranslated": "Cette langue n’a pas encore été traduite. Les destinataires reçoivent le texte de la langue de repli — cliquez sur Modifier pour ajouter la traduction.",
    "edit": "Modifier",
    "editor": {
      "back": "Retour à la vue d’ensemble"
    },
    "locked": "Verrouillé pour les tenants",
    "footerHint": "Ce texte apparaît en pied de page de chaque e-mail. Laissez vide pour ne pas afficher de pied de page.",
    "subject": "Objet",
    "preheader": "Préheader",
    "body": "Contenu",
    "save": "Enregistrer",
    "saved": "Enregistré.",
    "reset": "Rétablir le texte par défaut",
    "resetLoaded": "Texte par défaut chargé — cliquez sur Enregistrer pour confirmer.",
    "saveErrorTitle": "Le texte contient des erreurs"
  },
  "centralMailOutbox": {
    "title": "Boîte d’envoi (tous les tenants)",
    "intro": "Vue d’ensemble en lecture seule des e-mails envoyés pour l’ensemble des tenants. Le contenu et les actions se gèrent par tenant.",
    "empty": "Aucun e-mail trouvé.",
    "filterStatus": "Statut",
    "allStatuses": "Tous les statuts",
    "filterTenant": "Tenant",
    "allTenants": "Tous les tenants",
    "cols": {
      "tenant": "Tenant"
    }
  },
  "elearning": {
    "backToCatalog": "Retour au catalogue",
    "completion": {
      "completed": "terminé",
      "incomplete": "pas encore terminé",
      "unknown": "rien de transmis pour l’instant"
    },
    "contentHostMissing": "Ce cours ne peut pas encore être ouvert : l’environnement n’a pas l’hôte qui diffuse le contenu des cours. Merci de le signaler à l’administrateur.",
    "loadError": "Nous n’avons pas pu charger ce cours.",
    "outdatedVersion": "Ce cours a été mis à jour après votre début. Vous continuez dans la version dans laquelle vous travailliez, afin de ne rien perdre. Préférez-vous repartir de zéro dans la version la plus récente ?",
    "registered": "Enregistré : {status}",
    "saveProgress": "Enregistrer la progression",
    "score": "score {score} %",
    "start": "Démarrer le cours",
    "startHint": "Le cours s’ouvre ci-dessous. Votre progression est enregistrée en cours de route ; vous pourrez donc reprendre là où vous vous êtes arrêté.",
    "startNewestVersion": "Recommencer dans la version la plus récente",
    "starting": "Le cours s’ouvre…",
    "anonymous": {
      "fallbackTitle": "E-learning",
      "startHint": "Ce cours est librement accessible : vous n’avez pas besoin de vous connecter pour le suivre.",
      "notRecorded": "Votre progression et votre résultat ne sont pas enregistrés. Si vous souhaitez que votre achèvement compte, connectez-vous et lancez le cours depuis le catalogue.",
      "unavailable": "Ce cours n’est plus librement accessible. Demandez un nouveau lien à l’administrateur, ou connectez-vous."
    },
    "restartHint": "Vous reprenez cette formation depuis le début.",
    "backToLearningPath": "Retour à votre parcours",
    "superseded": {
      "title": "Vous recommencez"
    }
  },
  "myQuestionnaires": {
    "title": "Mes questionnaires",
    "description": "Les questionnaires qui vous attendent. Vous pouvez les remplir ici ou via le lien dans votre e-mail : c’est le même questionnaire.",
    "loading": "Chargement des questionnaires…",
    "loadError": "Vos questionnaires n’ont pas pu être chargés.",
    "retry": "Réessayer",
    "emptyTitle": "Rien ne vous attend",
    "emptyBody": "Lorsqu’un questionnaire vous attend, vous le verrez ici.",
    "untitled": "Questionnaire sans titre",
    "openUntil": "Ouvert jusqu’au {date}",
    "back": "Retour à mes questionnaires",
    "closedTitle": "Ce questionnaire n’est plus ouvert",
    "closedBody": "Si vous l’avez déjà rempli, par exemple via le lien dans votre e-mail, vos réponses ont été enregistrées.",
    "submittedBody": "Vos réponses ont été envoyées.",
    "testBadge": "Test",
    "state": {
      "awaiting_grading": "En attente de correction",
      "graded": "Corrigé"
    },
    "submittedOn": "Envoyé le {date}",
    "viewResult": "Voir votre résultat",
    "viewResultNamed": "Voir votre résultat pour {title}",
    "resultHidden": "Le résultat de ce test n’est pas affiché."
  },
  "myQualifications": {
    "title": "Mes qualifications",
    "description": "Les qualifications que vous détenez, jusqu'à quand elles sont valables et sur quoi elles reposent. Ce qui a expiré ou ne s'applique plus figure dans l'historique.",
    "loading": "Chargement des qualifications…",
    "loadError": "Vos qualifications n'ont pas pu être chargées.",
    "retry": "Réessayer",
    "emptyTitle": "Vous n'avez pas encore de qualifications",
    "emptyBody": "Lorsque vous terminez une formation qui donne une qualification, vous la voyez ici.",
    "holds": "Valide",
    "notHolding": "Non valide actuellement",
    "notHoldingBody": "Aucun enregistrement de cette qualification n'est valide pour le moment.",
    "validUntil": "Valide jusqu'au {date}",
    "openEnded": "Valide, sans date de fin",
    "expiresIn_one": "Expire dans {count} jour",
    "expiresIn_other": "Expire dans {count} jours",
    "expiresToday": "Expire aujourd'hui",
    "renewalStopped": "Ne sera pas renouvelée",
    "groundsLabel": "Pourquoi elle est valide",
    "groundWindowUntil": "jusqu'au {date}",
    "groundWindowOpen": "sans date de fin",
    "originCompletionNamed": "Achèvement de {title}",
    "origin": {
      "completion": "Achèvement d'une formation",
      "external_training": "Formation externe",
      "self_declared": "Déclaration personnelle",
      "administrative": "Enregistrée administrativement"
    },
    "evidence": {
      "trusted": "Enregistrée automatiquement",
      "verifiable": "Accordée à titre provisoire, peut être corrigée par la suite",
      "declaration": "Sur déclaration personnelle"
    },
    "history_one": "Historique ({count} enregistrement antérieur)",
    "history_other": "Historique ({count} enregistrements antérieurs)",
    "historyWindow": "Du {from} au {until} inclus",
    "historyWindowOpen": "À partir du {from}, sans date de fin",
    "endedOn": "Terminée le {date}",
    "status": {
      "valid": "Valide",
      "not_yet_valid": "Pas encore commencée",
      "expired": "Expirée",
      "ended_by_choice": "Terminée",
      "superseded": "Remplacée",
      "corrected": "Corrigée",
      "withdrawn": "Retirée",
      "never_valid": "Jamais valide"
    },
    "reason": {
      "superseded": "Remplacée par un enregistrement plus récent",
      "corrected": "Corrigée : la validité avait été mal enregistrée",
      "withdrawn_from_now": "Retirée : elle ne s'applique plus à partir de ce moment",
      "never_valid": "Retirée : vous ne l'avez jamais détenue"
    }
  },
  "myExternalRequests": {
    "title": "Mes demandes",
    "description": "Vos demandes de formation hors catalogue, et leur état d’avancement.",
    "new": "Nouvelle demande",
    "newTitle": "Nouvelle demande de formation externe",
    "back": "Retour à Mes demandes",
    "loading": "Chargement des demandes…",
    "loadError": "Vos demandes n’ont pas pu être chargées.",
    "retry": "Réessayer",
    "emptyTitle": "Aucune demande pour l’instant",
    "emptyBody": "Vous souhaitez suivre une formation qui ne figure pas au catalogue ? Faites-en la demande ici.",
    "emptyBodyNoTypes": "Il n’y a rien à demander pour le moment.",
    "noTypesTitle": "Rien à demander",
    "notFoundTitle": "Demande introuvable",
    "notFoundBody": "Cette demande n’existe pas ou ne vous appartient pas.",
    "untitled": "Demande sans titre",
    "continue": "Continuer",
    "open": "Consulter",
    "submittedOn": "soumise le {date}",
    "withdrawnOn": "retirée le {date}",
    "rejectedTitle": "Votre demande a été refusée",
    "rejectedNoComment": "Aucune explication n'a été donnée.",
    "runningNotice": "Votre demande a été approuvée. La formation est enregistrée à votre nom.",
    "awaitingManagement": "En cours de traitement — en attente d'une décision de l'administration",
    "withdraw": "Retirer la demande",
    "withdrawTitle": "Retirer la demande ?",
    "withdrawBody": "Aucune décision n’a encore été prise sur votre demande. Si vous la retirez, elle ne sera pas examinée. Cette action est irréversible.",
    "discardTitle": "Supprimer le brouillon ?",
    "discardBody": "Le brouillon et tout ce que vous avez saisi seront supprimés. Cette action est irréversible.",
    "cancel": "Annuler",
    "status": {
      "concept": "Brouillon",
      "submitted": "Soumise",
      "in_approval": "En cours de traitement",
      "rejected": "Refusée",
      "withdrawn": "Retirée",
      "running": "En cours"
    },
    "reason": {
      "form_updated": "Le formulaire a été mis à jour depuis que vous avez commencé. Vos valeurs sont conservées pour les champs restés identiques ; veuillez le vérifier et le soumettre à nouveau.",
      "request_not_concept": "Cette demande a déjà été soumise et ne peut plus être modifiée.",
      "request_not_withdrawable": "Cette demande ne peut plus être retirée.",
      "type_not_live": "Ce type de demande n’est plus ouvert.",
      "unknown": "Cette action n’est plus possible pour cette demande.",
      "attachments_full": "Cette demande a déjà atteint le nombre maximal de pièces jointes."
    },
    "form": {
      "type": "Type de demande",
      "typePlaceholder": "Choisissez un type",
      "submit": "Soumettre",
      "save": "Enregistrer comme brouillon",
      "discard": "Supprimer le brouillon",
      "submitHint": "Une fois soumise, la demande ne peut plus être modifiée, mais vous pouvez la retirer tant qu’aucune décision n’a été prise.",
      "otherProvider": "Un autre organisme",
      "providerChoice": "Organisme de formation",
      "providerPlaceholder": "Choisissez un organisme",
      "providerName": "Nom de l’organisme",
      "didYouMean": "Vouliez-vous dire l’un de ceux-ci ?",
      "teacherName": "Nom du formateur ou du coach",
      "teacherNameHint": "Facultatif.",
      "firstDay": "Premier jour",
      "lastDay": "Dernier jour",
      "day": "Jour {number}",
      "removeDay": "Supprimer le jour",
      "addDay": "Ajouter un jour",
      "price": "{name} : prix",
      "quantity": "{name} : quantité",
      "costHint": "Le total est calculé lors de la soumission.",
      "saved": "Votre brouillon a été enregistré.",
      "submitted": "Votre demande a été soumise. Vous recevrez une confirmation par e-mail.",
      "checkFields": "Tout n’a pas été correctement rempli. Veuillez vérifier les champs signalés.",
      "failed": "Cela n’a pas fonctionné. Veuillez réessayer."
    },
    "detail": {
      "heading": "Ce que vous avez demandé",
      "provider": "Organisme de formation",
      "period": "Période",
      "costs": "Coûts",
      "costLine": "Poste de coût",
      "excl": "HT",
      "incl": "TTC",
      "total": "Total",
      "vatUnknown": "inconnu",
      "empty": "–",
      "yes": "Oui",
      "no": "Non"
    },
    "tiles": {
      "heading": "Vous ne trouvez pas votre bonheur ?",
      "body": "Demandez une formation qui ne figure pas dans le catalogue."
    },
    "attachments": {
      "heading": "Pièces jointes",
      "none": "Aucune pièce jointe.",
      "hint": "Par exemple un devis ou un programme. PDF, JPG ou PNG, {max} fichiers au maximum.",
      "full": "Cette demande a atteint le nombre maximal de pièces jointes ({max}). Supprimez-en une pour en ajouter une autre.",
      "remove": "Supprimer",
      "removeNamed": "Supprimer la pièce jointe {name}",
      "failed": "La pièce jointe n’a pas pu être traitée. Veuillez réessayer.",
      "unnamed": "Pièce jointe",
      "saveFirst": "Vous pourrez ajouter des pièces jointes après avoir enregistré la demande comme brouillon."
    }
  },
  "questionnaireInvite": {
    "loading": "Ouverture du questionnaire…",
    "loadError": "Le questionnaire n'a pas pu être ouvert. Vérifiez votre connexion et réessayez.",
    "retry": "Réessayer",
    "closedTitle": "Ce lien ne fonctionne plus",
    "closedBody": "Si vous avez déjà rempli le questionnaire, votre réponse a été enregistrée.",
    "empty": "Ce questionnaire ne contient aucune question : il n'y a donc rien à remplir.",
    "language": "Langue",
    "subject": "Ce questionnaire porte sur {title}.",
    "subjectWithDates": "Ce questionnaire porte sur {title} ({dates}).",
    "anonymous": "Votre nom n'est pas affiché avec vos réponses.",
    "requiredNote": "Les questions marquées d'un * sont obligatoires.",
    "yes": "Oui",
    "no": "Non",
    "other": "Autre, précisez",
    "charsBetween": "Utilisez au moins {min} et au plus {max} caractères.",
    "charsMin": "Utilisez au moins {min} caractères.",
    "charsMax": "Utilisez au plus {max} caractères.",
    "choicesBetween": "Veuillez en choisir au moins {min} et au plus {max}.",
    "choicesMin": "Veuillez en choisir au moins {min}.",
    "choicesMax": "Veuillez en choisir au plus {max}.",
    "star": "{value} sur {max} étoiles",
    "starLabelled": "{value} sur {max} étoiles : {label}",
    "remarks": "Remarques",
    "remarksHint": "Vous souhaitez ajouter quelque chose que les questions n'abordent pas ? Vous pouvez le faire ici.",
    "submit": "Envoyer",
    "submitFailed": "L'envoi n'a pas abouti. Vos réponses sont toujours là ; veuillez réessayer.",
    "fixErrors": "Tout n'est pas encore correctement rempli. Veuillez vérifier les questions signalées.",
    "submittedTitle": "Merci d'avoir répondu",
    "submittedBody": "Vos réponses ont été envoyées. Vous pouvez maintenant fermer cette fenêtre."
  },
  "questionnaireAssignments": {
    "open": "Questionnaires",
    "openFor": "Questionnaires pour {training}",
    "heading": "Règles de questionnaires pour {training}",
    "heading_test": "Règles de test pour {training}",
    "headingGeneric": "Règles de questionnaires pour cette formation",
    "headingGeneric_test": "Règles de test pour cette formation",
    "add": "Ajouter une règle",
    "add_test": "Ajouter un test",
    "intro": "Une règle est permanente : ce questionnaire part à ce moment vers toute personne qui remplit les conditions. Une formation peut avoir plusieurs règles, même avec le même questionnaire — par exemple à mi-parcours et à la fin.",
    "intro_test": "Une règle est permanente : ce test part à ce moment vers toute personne qui remplit les conditions. Une formation peut avoir plusieurs règles, même avec le même test — par exemple à mi-parcours et à la fin.",
    "notFound": "Cette formation n’existe pas (ou plus).",
    "loadError": "Les règles de cette formation n’ont pas pu être chargées.",
    "loadError_test": "Les règles de test de cette formation n’ont pas pu être chargées.",
    "empty": "Cette formation n’a pas encore de règle de questionnaire.",
    "empty_test": "Cette formation n’a pas encore de test.",
    "showArchived_one": "Afficher la règle archivée ({count})",
    "showArchived_test_one": "Afficher la règle de test archivée ({count})",
    "showArchived_other": "Afficher les règles archivées ({count})",
    "showArchived_test_other": "Afficher les règles de test archivées ({count})",
    "onlyArchived": "Toutes les règles de cette formation sont archivées.",
    "onlyArchived_test": "Toutes les règles de test de cette formation sont archivées.",
    "unknownForm": "Questionnaire sans nom",
    "unknownForm_test": "Test sans nom",
    "panel": {
      "title": "Règles des questionnaires",
      "title_test": "Tests",
      "empty": "Cette formation n'a pas encore de règles de questionnaire.",
      "add": "Ajouter une règle",
      "mandatory": "Obligatoire : {answer}"
    },
    "name": "{form} — {moment} ; {conditions}",
    "anonymous": "Anonyme",
    "actionFailed": "Cela n’a pas fonctionné. Veuillez réessayer.",
    "table": {
      "caption": "Règles de cette formation",
      "caption_test": "Règles de test de cette formation",
      "form": "Questionnaire",
      "form_test": "Test",
      "moment": "Moment",
      "conditions": "Conditions",
      "status": "Statut",
      "invitations": "Invitations",
      "actions": "Actions",
      "invitationCount_one": "{count} invitation",
      "invitationCount_other": "{count} invitations",
      "invitationsNamed_one": "{count} invitation pour {name} : voir le suivi",
      "invitationsNamed_other": "{count} invitations pour {name} : voir le suivi"
    },
    "status": {
      "active": "En cours",
      "paused": "En pause",
      "archived": "Archivée"
    },
    "actions": {
      "edit": "Modifier",
      "editNamed": "Modifier {name}",
      "pause": "Mettre en pause",
      "pauseNamed": "Mettre en pause {name}",
      "resume": "Reprendre…",
      "resumeNamed": "Reprendre {name}",
      "archive": "Archiver",
      "archiveNamed": "Archiver {name}",
      "delete": "Supprimer",
      "deleteNamed": "Supprimer {name}"
    },
    "pause": {
      "title": "Mettre la règle en pause",
      "title_test": "Mettre la règle de test en pause",
      "body": "Une règle en pause n’envoie rien. Les invitations sont tout de même créées et mises en attente ; lors de la reprise, vous choisissez si elles partent quand même. Les liens déjà envoyés continuent de fonctionner.",
      "body_test": "Une règle en pause n’envoie rien. Les invitations sont tout de même créées et mises en attente ; lors de la reprise, vous choisissez si elles partent quand même.",
      "confirm": "Mettre en pause",
      "done": "La règle est en pause.",
      "done_test": "La règle de test a été mise en pause."
    },
    "archive": {
      "title": "Archiver la règle",
      "title_test": "Archiver la règle de test",
      "body": "L’archivage arrête définitivement cette règle. Les invitations pas encore envoyées sont annulées. Les liens déjà envoyés continuent de fonctionner jusqu’à leur expiration.",
      "body_test": "L’archivage arrête définitivement cette règle. Les invitations qui n’ont pas encore été envoyées sont annulées.",
      "confirm": "Archiver",
      "done": "La règle est archivée.",
      "done_test": "La règle de test a été archivée."
    },
    "delete": {
      "title": "Supprimer la règle",
      "title_test": "Supprimer la règle de test",
      "body": "Rien n’a encore été envoyé depuis cette règle, elle peut donc être supprimée.",
      "bodyWithInvitations_one": "Rien n’a encore été envoyé depuis cette règle, elle peut donc être supprimée. L’invitation en attente ({count}) est supprimée avec elle ; personne ne l’a vue.",
      "bodyWithInvitations_other": "Rien n’a encore été envoyé depuis cette règle, elle peut donc être supprimée. Les {count} invitations en attente sont supprimées avec elle ; personne ne les a vues.",
      "confirm": "Supprimer",
      "done": "La règle est supprimée.",
      "done_test": "La règle de test a été supprimée."
    },
    "resume": {
      "title": "Reprendre la règle",
      "title_test": "Reprendre la règle de test",
      "confirm": "Reprendre",
      "loadError": "Ce qui est en attente n’a pas pu être chargé.",
      "nothingHeld": "Rien n’est en attente. La reprise réactive la règle ; les personnes qui terminent ensuite reçoivent le questionnaire tel qu’il sera alors.",
      "nothingHeld_test": "Rien n’est en attente. La reprise réactive la règle ; les personnes qui terminent ensuite reçoivent le test tel qu’il sera alors.",
      "done": "La règle fonctionne à nouveau. Repris : {refrozen}, annulés : {withdrawn}.",
      "done_test": "La règle de test est de nouveau active. Reprises : {refrozen}, expirées : {withdrawn}."
    },
    "duplicate": {
      "existing": "Voici la règle existante : {name}.",
      "existing_test": "Voici la règle de test existante : {name}.",
      "existingUnknown": "La règle existante ne figure pas dans cette liste. Actualisez la page pour la voir.",
      "existingUnknown_test": "La règle de test existante ne figure pas dans cette liste. Actualisez la page pour la voir.",
      "marker": "Existe déjà avec le même moment et les mêmes conditions",
      "toList": "Afficher la règle existante dans la liste",
      "toList_test": "Afficher la règle de test existante dans la liste"
    },
    "errors": {
      "wholeNumber": "Saisissez un nombre entier, 0 ou plus."
    },
    "saved": {
      "created": "La règle est ajoutée.",
      "created_test": "La règle de test a été ajoutée.",
      "updated": "La règle est enregistrée.",
      "updated_test": "La règle de test a été enregistrée.",
      "replaced": "La nouvelle règle est créée et l’ancienne est archivée.",
      "replaced_test": "La nouvelle règle de test est créée et l’ancienne est archivée.",
      "replacedArchiveFailed": "La nouvelle règle est créée, mais l’ancienne n’a pas pu être archivée. Archivez-la vous-même, sinon les deux fonctionneront.",
      "replacedArchiveFailed_test": "La nouvelle règle de test a été créée, mais l’ancienne n’a pas pu être archivée. Archivez-la vous-même, sinon les deux restent actives."
    },
    "editor": {
      "newTitle": "Ajouter une règle",
      "newTitle_test": "Ajouter un test",
      "editTitle": "Modifier la règle",
      "editTitle_test": "Modifier la règle de test",
      "replaceTitle": "Nouvelle règle à la place de celle-ci",
      "replaceTitle_test": "Nouvelle règle de test à la place de celle-ci",
      "replaceConfirm": "Créer et archiver l’ancienne",
      "backToList": "Retour aux règles de la formation",
      "backToList_test": "Retour aux tests de la formation",
      "asideTitle": "Ce que cela signifie",
      "nothingSkipped": "Rien n'est ignoré à ce moment.",
      "notFound": "Cette règle n’existe pas (ou plus) pour cette formation.",
      "notFound_test": "Cette règle de test n’existe pas (ou plus) pour cette formation.",
      "archived": "Cette règle est archivée et ne peut plus être modifiée. Créez-en une nouvelle si vous souhaitez changer quelque chose.",
      "archived_test": "Cette règle de test est archivée et ne peut plus être modifiée. Créez-en une nouvelle si vous voulez changer quelque chose.",
      "fromNow": "Une modification s’applique aux invitations créées à partir de maintenant.",
      "locked_one": "{count} invitation a déjà été créée à partir de cette règle. Le questionnaire, le rôle, le moment et les conditions sont donc figés. Vous pouvez encore modifier le délai de réponse, l’introduction, le rappel et activer l’anonymat.",
      "locked_test_one": "{count} invitation a déjà été créée à partir de cette règle. Le test, le rôle, le moment et les conditions sont donc figés. Vous pouvez encore modifier le délai de réponse, l’introduction, le correcteur et le résultat pour le participant.",
      "locked_other": "{count} invitations ont déjà été créées à partir de cette règle. Le questionnaire, le rôle, le moment et les conditions sont donc figés. Vous pouvez encore modifier le délai de réponse, l’introduction, le rappel et activer l’anonymat.",
      "locked_test_other": "{count} invitations ont déjà été créées à partir de cette règle. Le test, le rôle, le moment et les conditions sont donc figés. Vous pouvez encore modifier le délai de réponse, l’introduction, le correcteur et le résultat pour le participant.",
      "replace": "En créer une nouvelle et archiver celle-ci",
      "replacing": "Vous créez une nouvelle règle à partir de {name}. Après l’enregistrement, celle-ci est archivée : ce qui y est encore en attente est annulé, les liens déjà envoyés continuent de fonctionner.",
      "replacing_test": "Vous créez une nouvelle règle de test à partir de {name}. Après l’enregistrement, celle-ci est archivée : ce qui y est encore en attente est annulé."
    },
    "field": {
      "form": "Questionnaire",
      "form_test": "Test",
      "formPlaceholder": "Choisissez un questionnaire publié",
      "formPlaceholder_test": "Choisissez un test publié",
      "noForms": "Il n’y a pas encore de questionnaire publié.",
      "noForms_test": "Il n’y a pas encore de test publié.",
      "formsError": "Les questionnaires à choisir n’ont pas pu être chargés.",
      "formsError_test": "Les tests proposés n’ont pas pu être chargés.",
      "toForms": "Aller aux questionnaires",
      "toForms_test": "Aller aux tests",
      "role": "Qui le remplit ?",
      "moment": "Quand part-il ?",
      "conditions": "Conditions",
      "attendance": "Présence minimale (%)",
      "attendanceHint": "Vide : aucune condition.",
      "attendanceHelp": "La part des séances auxquelles une personne a assisté. Les séances pour lesquelles une personne est excusée ne comptent pas.",
      "attendanceBeforeEnd": "Impossible avec un moment avant la fin de la séance : la présence n’est pas encore connue à ce moment-là.",
      "outcome": "Résultat",
      "outcomeAfterFinalise": "Réussi ou non réussi n’est possible qu’avec le moment après la clôture : avant, il n’y a pas encore de résultat.",
      "sending": "Envoi",
      "mailIntro": "Introduction personnalisée dans l’invitation",
      "mailIntroHint": "Vide : le texte par défaut de l’invitation.",
      "anonymous": "Anonyme : ne pas afficher les noms avec les réponses",
      "anonymousHint": "Vous voyez alors combien d’invitations se trouvent dans chaque statut, mais pas de qui elles sont.",
      "anonymousLocked": "Ne peut plus être désactivé : des invitations avec cette promesse existent déjà.",
      "anonymousWarning": "Attention : les réponses ne sont affichées que regroupées, et seulement une fois qu’au moins {floor} personnes ont répondu, toutes sessions de cette formation confondues. Avec de petits groupes, cela peut prendre plusieurs sessions.",
      "delayAmount": "Combien plus tard",
      "delayHint": "0 signifie dès la clôture.",
      "delayUnit": "Unité",
      "session": "Quelle séance",
      "sessionHint": "Selon la date et l’heure de début ; les séances sans date ne comptent pas.",
      "sessionNumber": "Numéro de la séance",
      "offsetAmount": "Combien",
      "offsetHint": "0 signifie à la fin de la séance.",
      "offsetUnit": "Unité",
      "offsetDirection": "Par rapport à la fin",
      "afterLastDays": "Nombre de jours après la dernière séance",
      "afterLastDaysHint": "0 signifie à la fin.",
      "afterLastDaysHelp": "En jours calendaires, à partir de la fin de la dernière séance.",
      "fixedAt": "Date et heure",
      "fixedAtHint": "Dans votre propre fuseau horaire. Un moment déjà passé n’est pas possible.",
      "mandatory": "Obligatoire pour la réussite",
      "mandatoryHint": "La formation n’est considérée comme réussie qu’une fois ce questionnaire rempli. Il se remplit dans Mes questionnaires après connexion, sans lien, et n’expire pas.",
      "delivery": "Comment le test est-il passé ?",
      "deliveryDigital": "Numérique",
      "deliveryDigitalHint": "La personne passe le test dans l’application ; le formateur le corrige.",
      "deliveryExternal": "Externe",
      "deliveryExternalHint": "Le test est passé et corrigé en dehors du système. Vous n’enregistrez ici que le résultat, par personne dans la grille de présence. Aucune invitation n’est envoyée.",
      "deliveryExternalGrading": "Vous enregistrez le résultat dans la grille de présence, lors de la clôture de la session.",
      "externalTestTitle": "Test externe",
      "mandatory_test": "Compte pour la réussite",
      "mandatoryHint_test": "La formation n’est réussie que lorsque le test a été remis, corrigé et réussi. Une qualification liée à la formation n’est alors seulement attribuée — pas par la présence. Un test non réussi laisse le participant sur « non réussi » jusqu’à ce que le formateur en décide autrement.",
      "mandatoryNeedsMoment": "Possible uniquement avec un moment avant l’achèvement : un questionnaire après l’achèvement ne peut plus retenir un achèvement déjà enregistré.",
      "mandatoryNotEach": "Impossible à chaque séance : on ne saurait pas quelle invitation retient la réussite.",
      "mandatoryNoAttendance": "Ne peut pas être combiné avec une condition de présence : qui ne la remplit pas ne reçoit jamais le questionnaire et ne pourrait alors plus réussir.",
      "attendanceMandatory": "Impossible pour un questionnaire obligatoire : qui ne remplit pas la condition ne pourrait alors plus jamais réussir.",
      "reminderMandatory": "Un questionnaire obligatoire ne se ferme pas à une date ; un rappel préalable n’a donc pas de moment. Envoyez les rappels depuis l’aperçu de la règle.",
      "grading": "Correction",
      "grader": "Correcteur",
      "graderPlaceholder": "Choisissez un correcteur (facultatif)",
      "graderHint": "Vide : les formateurs de la session corrigent.",
      "showAnswers": "Afficher les réponses au participant",
      "showAnswersHint": "Activé : après la correction, le participant voit aussi les questions avec ses réponses et les commentaires sur chaque réponse. Désactivé : il ne voit que le résultat, le score et le commentaire général, qu’il voit toujours."
    },
    "role": {
      "participant": "Participant",
      "teacher": "Formateur",
      "manager": "Responsable",
      "later": "Prévu plus tard : les formateurs et les responsables le remplissent en étant connectés."
    },
    "moment": {
      "after_finalise": "Après la clôture",
      "after_finaliseHint": "Lors de l’enregistrement de la clôture, immédiatement ou plus tard.",
      "at_session": "Lors d’une séance",
      "at_sessionHint": "Autour de la fin d’une séance — par exemple à mi-parcours de la formation.",
      "after_last_session": "Après la dernière séance",
      "after_last_sessionHint": "Quelques jours après la fin de la dernière séance, indépendamment de la clôture.",
      "fixed_datetime": "À une date fixe",
      "fixed_datetimeHint": "Un seul moment pour toutes les personnes inscrites ou ayant terminé à cette date."
    },
    "outcome": {
      "any": "Peu importe",
      "passed": "Uniquement ceux qui ont réussi",
      "not_passed": "Uniquement ceux qui n’ont pas réussi"
    },
    "unit": {
      "minutes": "minutes",
      "hours": "heures",
      "days": "jours"
    },
    "selector": {
      "number": "Séance numéro…",
      "last": "La dernière",
      "each": "Chaque séance"
    },
    "direction": {
      "after": "après la fin",
      "before": "avant la fin"
    },
    "skipped": {
      "counting": "Calcul de ce qui est déjà passé…",
      "failed": "Impossible de calculer combien de moments sont déjà passés.",
      "nothingPlanned": "Aucune séance datée sur laquelle tombe ce moment n’est encore au planning.",
      "sessionsNone_one": "{count} séance prévue, encore à venir.",
      "sessionsNone_other": "{count} séances prévues, toutes encore à venir.",
      "occurrencesNone_one": "{count} session prévue ; ce moment y est encore à venir.",
      "occurrencesNone_other": "{count} sessions prévues ; ce moment est encore à venir pour toutes.",
      "sessions_one": "{past} séance sur {count} est déjà passée ; rien n’est envoyé pour elle.",
      "sessions_other": "{past} séances sur {count} sont déjà passées ; rien n’est envoyé pour celles-ci.",
      "occurrences_one": "Pour {past} session sur {count}, ce moment est déjà passé ; rien n’y est envoyé.",
      "occurrences_other": "Pour {past} sessions sur {count}, ce moment est déjà passé ; rien n’y est envoyé.",
      "rule": "Une règle n’envoie qu’aux moments encore à venir, à compter de l’enregistrement."
    },
    "duration": {
      "minutes_one": "{count} minute",
      "minutes_other": "{count} minutes",
      "hours_one": "{count} heure",
      "hours_other": "{count} heures",
      "days_one": "{count} jour",
      "days_other": "{count} jours"
    },
    "summary": {
      "afterFinaliseNow": "Dès la clôture",
      "afterFinaliseLater": "{delay} après la clôture",
      "sessionNumber": "la séance {number}",
      "session_last": "la dernière séance",
      "session_each": "chaque séance",
      "atSessionEnd": "À la fin de {session}",
      "beforeSessionEnd": "{offset} avant la fin de {session}",
      "afterSessionEnd": "{offset} après la fin de {session}",
      "afterLastSessionSameDay": "À la fin de la dernière séance",
      "afterLastSession": "{days} après la dernière séance",
      "fixed": "Le {date}",
      "noMoment": "Sans moment",
      "attendance": "présence d’au moins {percent} %",
      "passed": "réussi uniquement",
      "notPassed": "non réussi uniquement",
      "noConditions": "aucune condition",
      "mandatory": "obligatoire pour la réussite"
    }
  },
  "questionnaireOverview": {
    "intro": "Toutes les règles d’évaluation des questionnaires au même endroit : celles d’une formation et les questionnaires autonomes. Sans choix, vous voyez les règles d’évaluation en cours et en pause ; choisissez Toutes sous Statut pour inclure les archivées.",
    "intro_test": "Toutes les règles de test au même endroit : celles d’une formation. Sans choix, vous voyez les règles de test en cours et en pause ; choisissez Toutes sous Statut pour inclure les archivées.",
    "empty": "Il n’y a pas encore de règles d’évaluation.",
    "empty_test": "Il n’y a pas encore de règle de test.",
    "noMatch": "Aucune règle d’évaluation ne correspond à ces filtres.",
    "noMatch_test": "Aucune règle de test ne correspond à ces filtres.",
    "loadError": "Les règles d’évaluation n’ont pas pu être chargées.",
    "loadError_test": "Les règles de test n’ont pas pu être chargées.",
    "unknownForm": "Questionnaire sans nom",
    "unknownForm_test": "Test sans nom",
    "unknownTraining": "Formation inconnue",
    "anonymous": "Anonyme",
    "survey": "Questionnaire autonome",
    "name": "{form} — {target}",
    "cols": {
      "form": "Questionnaire",
      "form_test": "Test",
      "target": "Formation ou public cible",
      "moment": "Moment",
      "status": "Statut",
      "mandatory": "Obligatoire",
      "sent": "Envoyés",
      "submitted": "Remplis",
      "open": "Ouverts",
      "actions": "Actions"
    },
    "filters": {
      "status": "Statut",
      "statusDefault": "En cours et en pause",
      "statusAll": "Toutes",
      "kind": "Type",
      "kindTraining": "Pour une formation",
      "kindSurvey": "Questionnaire autonome",
      "form": "Questionnaire",
      "form_test": "Test",
      "training": "Formation",
      "all": "Tous"
    },
    "actions": {
      "status": "Voir le statut",
      "statusNamed": "Voir le statut de {name}",
      "training": "Formation",
      "trainingNamed": "Ouvrir les règles de la formation pour {name}",
      "edit": "Modifier",
      "editNamed": "Modifier {name}"
    }
  },
  "questionnaireWindow": {
    "field": {
      "window": "Délai de réponse en jours",
      "windowHint": "Durée pendant laquelle le lien reste ouvert après son envoi. Par défaut {days} jours, jamais plus de {ceiling} jours. 0 signifie : aussi longtemps que possible.",
      "windowZero": "Pas de délai fixe : le lien reste ouvert aussi longtemps que possible, au maximum {ceiling} jours (en cas d’envoi {from} : jusqu’au {date}).",
      "windowCapped": "C’est plus long que le maximum : le lien se ferme après {ceiling} jours (en cas d’envoi {from} : le {date}).",
      "reminder": "Rappel avant la clôture, en jours",
      "reminderHint": "Ce nombre de jours avant la clôture du lien, le destinataire reçoit un rappel avec un nouveau lien ; le premier lien continue de fonctionner. Vide : pas de rappel.",
      "reminderAt_one": "Rappel {count} jour avant la clôture, le {date} (en cas d’envoi {from}).",
      "reminderAt_other": "Rappel {count} jours avant la clôture, le {date} (en cas d’envoi {from}).",
      "reminderOutside_one": "Un rappel {count} jour avant la clôture ne tombe pas dans le délai de réponse de {window} jours. Choisissez moins de jours.",
      "reminderOutside_other": "Un rappel {count} jours avant la clôture ne tombe pas dans le délai de réponse de {window} jours. Choisissez moins de jours.",
      "today": "aujourd’hui",
      "onDate": "le {date}",
      "afterSend": "Rappel {number} après l’envoi, en jours",
      "afterSendHint_one": "Ce nombre de jours après l’envoi, le destinataire reçoit un rappel avec un nouveau lien ; le premier lien continue de fonctionner. {max} au plus, par ordre croissant. Le premier est possible après {count} jour au minimum.",
      "afterSendHint_other": "Ce nombre de jours après l’envoi, le destinataire reçoit un rappel avec un nouveau lien ; le premier lien continue de fonctionner. {max} au plus, par ordre croissant. Le premier est possible après {count} jours au minimum.",
      "afterSendAdd": "Ajouter un rappel après l’envoi",
      "afterSendRemove": "Supprimer le rappel {number} après l’envoi",
      "afterSendRemoveLabel": "Supprimer"
    }
  },
  "questionnaireSurveyRecipients": {
    "back": "Retour aux questionnaires autonomes",
    "heading": "Destinataires",
    "note": "Voici le public tel qu’il est actuellement. La liste définitive est établie au moment de l’envoi, à la date d’envoi prévue.",
    "notFound": "Ce questionnaire autonome n’existe pas (ou plus).",
    "loadError": "Les destinataires n’ont pas pu être chargés.",
    "empty": "Le public ne contient encore rien à afficher.",
    "total_one": "{count} destinataire au total",
    "total_other": "{count} destinataires au total",
    "duplicates_one": "{count} personne figure dans plus d’une partie et n’est comptée qu’une fois.",
    "duplicates_other": "{count} personnes figurent dans plus d’une partie et ne sont comptées qu’une fois.",
    "countsOnly": "Vous ne voyez que des nombres : les noms et les adresses e-mail sont réservés aux personnes autorisées à consulter les utilisateurs.",
    "treeLabel": "Parties du public",
    "subUnitsLabel": "Unités sous {name}",
    "count_one": "{count} personne",
    "count_other": "{count} personnes",
    "directly": "Directement dans {name} : {count}",
    "expandNamed": "Déplier {name}",
    "collapseNamed": "Replier {name}",
    "branch": {
      "everyone": "Tout le monde (tous les utilisateurs actifs)",
      "individuals": "Personnes choisies"
    },
    "people": {
      "name": "Nom",
      "email": "Adresse e-mail",
      "empty": "Il n’y a plus personne ici.",
      "forbidden": "Vous ne pouvez pas voir les noms : il faut pour cela le droit de consulter les utilisateurs.",
      "loadError": "Les personnes de {name} n’ont pas pu être chargées."
    }
  },
  "questionnaireSurveys": {
    "intro": "Un questionnaire autonome n’est pas lié à une formation : vous envoyez un questionnaire publié à un public, maintenant ou à une date fixe. Les personnes concernées sont comptées au moment de l’envoi.",
    "new": "Nouveau questionnaire autonome",
    "loadError": "Les questionnaires autonomes n’ont pas pu être chargés.",
    "empty": "Il n’y a pas encore de questionnaire autonome.",
    "onlyArchived": "Il n’y a que des questionnaires autonomes archivés.",
    "showArchived_one": "Afficher le questionnaire archivé ({count})",
    "showArchived_other": "Afficher les questionnaires archivés ({count})",
    "unknownForm": "Questionnaire inconnu",
    "anonymous": {
      "chooseAudience": "La possibilité de l’anonymat dépend de la taille du public. Choisissez d’abord un public.",
      "unknown": "On ne peut dire si l’anonymat est possible qu’une fois le public compté.",
      "unavailable_one": "L’anonymat n’est pas possible : ce public compte {count} personne, sous le seuil de {floor}. Ainsi, le questionnaire ne promet rien qu’il ne puisse tenir.",
      "unavailable_other": "L’anonymat n’est pas possible : ce public compte {count} personnes, sous le seuil de {floor}. Ainsi, le questionnaire ne promet rien qu’il ne puisse tenir.",
      "willDrop": "Ce questionnaire était anonyme ; cela sera retiré à l’enregistrement."
    },
    "name": "{form}, {date}",
    "actionFailed": "Cela n’a pas fonctionné. Veuillez réessayer.",
    "sentTo_one": "à {count} personne",
    "sentTo_other": "à {count} personnes",
    "heldReason_one": "Non envoyé : l’anonymat avait été promis, mais lors de l’envoi le public comptait {count} personne, sous le seuil. Modifiez-le pour le replanifier.",
    "heldReason_other": "Non envoyé : l’anonymat avait été promis, mais lors de l’envoi le public comptait {count} personnes, sous le seuil. Modifiez-le pour le replanifier.",
    "state": {
      "scheduled": "Planifié",
      "sent": "Envoyé",
      "held": "Retenu",
      "archived": "Archivé"
    },
    "table": {
      "caption": "Questionnaires autonomes, avec leur public, leur moment et leur statut",
      "form": "Questionnaire",
      "audience": "Public",
      "moment": "Moment",
      "state": "Statut",
      "invitations": "Invitations",
      "actions": "Actions",
      "invitationCount_one": "{count} invitation",
      "invitationCount_other": "{count} invitations",
      "invitationsNamed_one": "{count} invitation pour {name} : voir le suivi",
      "invitationsNamed_other": "{count} invitations pour {name} : voir le suivi",
      "recipientsNow": "Destinataires (actuellement {count})",
      "recipientsNamed": "Destinataires de {name} : actuellement {count}, voir de qui il s’agit"
    },
    "actions": {
      "edit": "Modifier",
      "editNamed": "Modifier {name}",
      "archive": "Archiver",
      "archiveNamed": "Archiver {name}",
      "delete": "Supprimer",
      "deleteNamed": "Supprimer {name}"
    },
    "archive": {
      "title": "Archiver le questionnaire autonome",
      "body": "L’archivage arrête définitivement ce questionnaire. Les liens déjà envoyés continuent de fonctionner jusqu’à leur expiration.",
      "confirm": "Archiver",
      "done": "Le questionnaire autonome est archivé."
    },
    "delete": {
      "title": "Supprimer le questionnaire autonome",
      "body": "Rien n’a encore été envoyé depuis ce questionnaire, il peut donc être supprimé.",
      "confirm": "Supprimer",
      "done": "Le questionnaire autonome est supprimé."
    },
    "saved": {
      "now_one": "Le questionnaire part vers {count} personne dès votre confirmation.",
      "now_other": "Le questionnaire part vers {count} personnes dès votre confirmation. Pour un grand groupe, il peut falloir quelques minutes avant que tout le monde le reçoive.",
      "date_one": "Le questionnaire part le {date} ; le public compte actuellement {count} personne. Les personnes concernées seront recomptées à ce moment-là.",
      "date_other": "Le questionnaire part le {date} ; le public compte actuellement {count} personnes. Les personnes concernées seront recomptées à ce moment-là."
    },
    "audience": {
      "everyone": "Tout le monde",
      "units_one": "{count} unité",
      "units_other": "{count} unités",
      "roles_one": "{count} rôle",
      "roles_other": "{count} rôles",
      "people_one": "{count} personne",
      "people_other": "{count} personnes",
      "none": "Aucun public"
    },
    "editor": {
      "newTitle": "Nouveau questionnaire autonome",
      "editTitle": "Modifier le questionnaire autonome",
      "backToList": "Vers les questionnaires autonomes",
      "notFound": "Ce questionnaire autonome n’existe pas (ou plus).",
      "loadError": "Le questionnaire autonome n’a pas pu être chargé.",
      "closedSent_one": "Ce questionnaire a été envoyé le {date} à {count} personne. Il ne peut plus être modifié ; vous pouvez l’archiver depuis la liste.",
      "closedSent_other": "Ce questionnaire a été envoyé le {date} à {count} personnes. Il ne peut plus être modifié ; vous pouvez l’archiver depuis la liste.",
      "closedArchived": "Ce questionnaire est archivé et ne peut plus être modifié.",
      "toInvitations": "Vers les invitations",
      "review": "Vérifier et confirmer",
      "heldNotice_one": "Ce questionnaire n’a pas été envoyé : il était anonyme, mais lors de l’envoi le public comptait {count} personne, sous le seuil. Choisissez un public plus large ou renoncez à l’anonymat ; l’enregistrement le replanifie.",
      "heldNotice_other": "Ce questionnaire n’a pas été envoyé : il était anonyme, mais lors de l’envoi le public comptait {count} personnes, sous le seuil. Choisissez un public plus large ou renoncez à l’anonymat ; l’enregistrement le replanifie."
    },
    "field": {
      "form": "Questionnaire",
      "formPlaceholder": "Choisissez un questionnaire publié",
      "formsError": "Les questionnaires à choisir n’ont pas pu être chargés.",
      "noForms": "Il n’y a pas encore de questionnaire publié.",
      "audience": "Public",
      "audienceHint": "Choisissez des unités, des rôles, des personnes ou tout le monde. Une personne qui relève de plusieurs lignes reçoit une seule invitation. Seules les personnes actives comptent.",
      "addSegment": "Ajouter une ligne",
      "moment": "Quand part-il ?",
      "fixedAt": "Date et heure",
      "fixedAtHint": "Dans votre propre fuseau horaire. Un moment déjà passé n’est pas possible.",
      "sending": "Envoi",
      "anonymous": "Anonyme : ne pas afficher les noms avec les réponses",
      "anonymousHint": "Vous voyez alors combien d’invitations se trouvent dans chaque statut, mais pas de qui elles sont. Possible à partir de {floor} personnes."
    },
    "moment": {
      "now": "Maintenant",
      "nowHint": "Dès votre confirmation. Pour un grand groupe, il peut falloir quelques minutes avant que tout le monde le reçoive.",
      "date": "À une date fixe",
      "dateHint": "Les personnes qui font partie du public à ce moment-là le reçoivent."
    },
    "segment": {
      "label": "Ligne {number} du public",
      "type": "Type, ligne {number}",
      "org_units": "Unités organisationnelles",
      "roles": "Rôles",
      "individuals": "Personnes choisies",
      "everyone": "Tout le monde",
      "everyoneHint": "Toutes les personnes actives de cet environnement.",
      "includeSubUnits": "Inclure les unités en dessous",
      "remove": "Retirer",
      "removeNamed": "Retirer la ligne {number}"
    },
    "picker": {
      "units": "Rechercher une unité",
      "unitsNamed": "Unités, ligne {number}",
      "roles": "Rechercher un rôle",
      "rolesNamed": "Rôles, ligne {number}",
      "people": "Rechercher par nom ou adresse e-mail",
      "peopleNamed": "Personnes, ligne {number}",
      "loadError": "La liste à choisir n’a pas pu être chargée."
    },
    "preview": {
      "title": "Destinataires",
      "nothing": "Choisissez un public ; vous verrez alors ici combien de personnes il compte actuellement.",
      "counting": "Comptage…",
      "updating": "Mise à jour…",
      "count_one": "{count} personne",
      "count_other": "{count} personnes",
      "failed": "Le nombre n’a pas pu être compté.",
      "rule": "Seules les personnes actives comptent. Le public est recompté lors de l’envoi."
    },
    "errors": {
      "noAudience": "Choisissez au moins un public.",
      "segmentIncomplete": "Choisissez qui relève de cette ligne, ou retirez la ligne.",
      "nobody": "Ce public ne compte personne actuellement : rien ne partirait.",
      "countFailed": "Le nombre de destinataires n’a pas pu être compté. Veuillez réessayer."
    },
    "confirm": {
      "title": "Confirmer l’envoi",
      "count_one": "Ce questionnaire part vers {count} personne.",
      "count_other": "Ce questionnaire part vers {count} personnes.",
      "form": "Questionnaire",
      "when": "Quand",
      "anonymous": "Anonyme",
      "yes": "Oui",
      "no": "Non",
      "now": "Dès votre confirmation",
      "nowHint": "Il part immédiatement ; pour un grand groupe, il peut falloir quelques minutes avant que tout le monde le reçoive. Ensuite, vous ne pourrez plus le modifier, seulement l’archiver.",
      "dateHint": "Vous pouvez le modifier jusqu’à ce moment. Les personnes concernées seront alors recomptées ; le nombre peut différer.",
      "sendNow": "Confirmer et envoyer",
      "schedule": "Confirmer et planifier",
      "changed_one": "Le nombre a changé : le public compte désormais {count} personne au lieu de {previous}. Veuillez confirmer à nouveau.",
      "changed_other": "Le nombre a changé : le public compte désormais {count} personnes au lieu de {previous}. Veuillez confirmer à nouveau."
    }
  },
  "assetLimits": {
    "uploadHint": "{types} — max. {max} Mo",
    "fileTooLarge": "Ce fichier fait {size} Mo. Le maximum est de {max} Mo.",
    "fileTypeRejected": "Ce type de fichier n’est pas autorisé. Types autorisés : {types}."
  },
  "uploadLimits": {
    "platformDescription": "Ces valeurs s’appliquent à tout environnement qui n’a pas la sienne. Les clients ne peuvent pas les modifier : une liste de types de fichiers est un paramètre de sécurité.",
    "tenantDescription": "Ce que vous définissez ici ne s’applique qu’à cet environnement. Laissez un champ vide pour revenir à la valeur qui s’applique à tous les environnements.",
    "storageUsage": "Cet environnement utilise actuellement {used} sur {quota} Mo ({percent} %) pour son propre contenu.",
    "sources": {
      "tenant": "Valeur propre à cet environnement",
      "platform": "Définie pour toute la plateforme",
      "fallback": "Valeur par défaut"
    },
    "units": {
      "kilobytes": "Valeur (Mo)",
      "megabytes": "Valeur (Mo)",
      "count": "Valeur"
    },
    "types": "Types de fichiers autorisés",
    "addType": "Ajouter un type",
    "add": "Ajouter",
    "removeType": "Supprimer {type}",
    "forbiddenHint": "Ces types ne peuvent pas être autorisés car ils peuvent contenir des scripts : {types}.",
    "ceilingHint": "Au maximum {max} Mo — le serveur web n’accepte pas davantage.",
    "overCeiling": "La limite ne peut pas dépasser {max} Mo.",
    "mustBeNumber": "Saisissez un nombre positif.",
    "notOverridable": "Cette limite s’applique à tous les environnements et n’est pas modifiable ici.",
    "clearOverride": "Revenir à la valeur par défaut",
    "fallbackNote": "Sans valeur propre, {value} s’applique ici.",
    "saved": "Les limites ont été enregistrées.",
    "nothingChanged": "Rien n’a changé, il n’y a donc rien à enregistrer.",
    "loadError": "Impossible de charger les limites de téléversement."
  },
  "platformSettings": {
    "title": "Paramètres globaux",
    "sections": {
      "general": "Général",
      "mail": "E-mail",
      "files": "Fichiers"
    },
    "general": {
      "empty": "Aucun paramètre global sous cette rubrique pour l’instant."
    },
    "mail": {
      "transportTitle": "Expéditeur & transport (par défaut)",
      "mode": "Mode d’envoi",
      "modeRelay": "Relais de la plateforme (recommandé)",
      "modeSmtp": "Votre propre serveur SMTP",
      "fromAddress": "Adresse de l’expéditeur",
      "fromName": "Nom de l’expéditeur",
      "replyTo": "Reply-To",
      "smtpHost": "Hôte SMTP",
      "smtpPort": "Port SMTP",
      "smtpEncryption": "Chiffrement",
      "smtpUsername": "Nom d’utilisateur SMTP",
      "smtpPassword": "Mot de passe SMTP",
      "passwordSet": "Un mot de passe est défini — laissez vide pour le conserver.",
      "connectionTest": "Tester la connexion",
      "connectionHint": "Teste les paramètres de transport enregistrés sans envoyer d’e-mail. Enregistrez d’abord.",
      "connectionOk": "Connexion réussie.",
      "testTitle": "E-mail de test",
      "testHint": "Envoie un e-mail de test via le transport de la plateforme, en dehors de tout tenant.",
      "testTo": "Adresse de test",
      "testToInvalid": "Saisissez une adresse e-mail valide.",
      "testSend": "Envoyer le test",
      "testOk": "E-mail de test envoyé.",
      "dnsTitle": "Contrôle DNS (SPF/DKIM/DMARC)",
      "dnsHint": "Vérifie les enregistrements d’authentification e-mail du domaine From de la plateforme. Enregistrez d’abord.",
      "dnsCheck": "Vérifier le DNS",
      "dnsDomain": "Domaine",
      "dkimSelector": "Sélecteur DKIM (facultatif)",
      "dkimSelectorHint": "Sélecteur DKIM, p. ex. 'default' ou 's1' — nécessaire pour consulter le bon enregistrement DKIM.",
      "dnsExpected": "Ajoutez un enregistrement TXT sur {host} contenant :",
      "spfNoRelay": "n’inclut pas notre relais",
      "dnsStatus": {
        "ok": "OK",
        "warn": "avertissement",
        "missing": "manquant",
        "skipped": "non vérifié"
      },
      "lifecycleTitle": "Envoi & conservation (par défaut)",
      "sendingEnabled": "Envoyer réellement les e-mails",
      "openTracking": "Suivi des ouvertures (pixel)",
      "storeTransactionalBody": "Conserver le contenu des e-mails transactionnels",
      "delayMinutes": "Délai (minutes)",
      "retentionDays": "Conservation (jours)"
    }
  },
  "common": {
    "filePicker": {
      "drop": "Glissez un fichier ici ou cliquez pour le choisir",
      "choose": "Choisir un fichier",
      "replace": "Remplacer",
      "remove": "Supprimer"
    },
    "dropzone": {
      "primary": "Glissez des fichiers ici ou cliquez pour choisir",
      "secondary": "Plusieurs fichiers à la fois est possible (max 10 Mo par fichier)"
    },
    "cancel": "Annuler",
    "close": "Fermer",
    "copy": "Copier",
    "copied": "Copié !",
    "create": "Créer",
    "save": "Enregistrer",
    "saved": "Enregistré",
    "loading": "Chargement…",
    "error": "Une erreur s'est produite",
    "edit": "Modifier",
    "open": "Ouvrir",
    "search": "Rechercher",
    "yes": "Oui",
    "no": "Non",
    "tableEmpty": "Aucune ligne à afficher.",
    "tableNoMatch": "Aucun résultat ne correspond à votre recherche.",
    "tableMatchCount": "{matched} sur {total}",
    "tableRange": "{from}–{to} sur {total}",
    "tablePageSize": "Par page",
    "tablePageOf": "Page {current} sur {total}",
    "tableExport": "Exporter CSV",
    "tableExportHint": "Toutes les lignes filtrées, dans l'ordre de tri actuel. La colonne Actions est omise.",
    "delete": "Supprimer",
    "remove": "Retirer",
    "expand": "Développer",
    "collapse": "Réduire",
    "unknownError": "Une erreur s'est produite. Veuillez réessayer.",
    "fieldRequired": "Ce champ est obligatoire.",
    "invalidEmail": "Veuillez saisir une adresse e-mail valide.",
    "view": "Consulter",
    "weekday": {
      "1": "lundi",
      "2": "mardi",
      "3": "mercredi",
      "4": "jeudi",
      "5": "vendredi",
      "6": "samedi",
      "7": "dimanche"
    },
    "saving": "Enregistrement…",
    "actions": "Actions",
    "tableRowNumber": "#",
    "tableSelectAll": "Sélectionner toutes les lignes",
    "tableSelectRow": "Sélectionner la ligne {n}",
    "tableSortAsc": "trié par ordre croissant",
    "tableSortDesc": "trié par ordre décroissant",
    "tableScrollRegion": "Tableau, défilement horizontal",
    "tablePreviousPage": "Page précédente",
    "tableNextPage": "Page suivante",
    "helpFor": "Explication : {field}",
    "moveUp": "Vers le haut",
    "moveDown": "Vers le bas"
  },
  "shadowBanner": {
    "stop": "Arrêter le mode fantôme",
    "startedAt": "actif depuis {time}",
    "userShadow": {
      "heading": "Vous travaillez en tant que {name}",
      "subline": "Initié par {impersonator}",
      "sublineWithOrigin": "Initié par {impersonator} (en tant que fantôme du superadmin {origin})"
    },
    "superadminTenantAdmin": {
      "heading": "Vous travaillez en tant qu'administrateur de tenant via un fantôme superadmin",
      "subline": "Superadmin d'origine : {origin}"
    }
  },
  "localeOverrides": {
    "heading": "Textes",
    "intro": "Remplacez ici les textes de l'application par langue. Un remplacement vide retombe sur le texte par défaut.",
    "searchPlaceholder": "Rechercher par clé ou par texte…",
    "colKey": "Clé",
    "default": "Par défaut",
    "override": "Remplacement",
    "reset": "Réinitialiser",
    "resetNamespace": "Réinitialiser le namespace",
    "historyAction": "Historique",
    "namespaceCount": "{total} clés · {overridden} remplacées",
    "requiredPlaceholders": "Utilisez : {list}",
    "confirmResetTitle": "Réinitialiser le namespace ?",
    "confirmResetBody": "Supprime tous les remplacements dans '{namespace}' pour cette langue. Les textes par défaut seront à nouveau utilisés.",
    "historyTitle": "Historique — {key}",
    "empty": {
      "all": "Aucune clé à afficher pour l'instant.",
      "search": "Aucun résultat pour cette recherche."
    },
    "history": {
      "empty": "Aucune modification enregistrée.",
      "before": "Valeur précédente",
      "after": "Nouvelle valeur",
      "disabledHint": "Pas d'historique — aucun remplacement enregistré pour cette clé pour l'instant.",
      "by": "par {actor}",
      "byShadow": "par {impersonator} (fantôme de {actor})",
      "byShadowFromSuperadmin": "par {impersonator} (fantôme de {actor} ; connecté en tant que superadmin {origin})",
      "bySuperadminShadow": "par {actor} (superadmin {origin} via fantôme)",
      "action": {
        "created": "Créé",
        "updated": "Modifié",
        "deleted": "Supprimé"
      }
    },
    "errors": {
      "html": "Les balises HTML ne sont pas autorisées.",
      "placeholder": "Placeholder(s) manquant(s) : {list}",
      "saveFailed": "Échec de l'enregistrement."
    }
  },
  "auth": {
    "login": {
      "title": "Se connecter",
      "subtitle": "Accès superadmin à la plateforme BCS LMS/LXP.",
      "email": "Adresse e-mail",
      "password": "Mot de passe",
      "remember": "Rester connecté",
      "submit": "Se connecter",
      "genericError": "Connexion impossible. Veuillez réessayer."
    },
    "mfa": {
      "title": "Deuxième étape",
      "subtitle": "Saisissez le code de votre application d’authentification.",
      "code": "Code",
      "submit": "Confirmer",
      "recoveryHint": "Pas accès à votre application ? Utilisez l’un de vos codes de récupération.",
      "noRecoveryHint": "Il ne vous reste plus de codes de récupération."
    }
  },
  "superadmin": {
    "dashboard": {
      "heading": "Tableau de bord",
      "intro": "Vue d'ensemble de la plateforme BCS LMS/LXP.",
      "totalTenants": "Total des tenants",
      "activeTenants": "Tenants actifs",
      "imports": {
        "activeImports": "Imports actifs",
        "allClearTitle": "Imports — tout est en ordre",
        "allClearBody": "Aucun import en échec au cours des 7 derniers jours.",
        "failuresTitle": "Imports — échecs récents",
        "failuresBody": "{failed24h} en échec au cours des 24 dernières heures · {failed7d} au cours des 7 derniers jours."
      },
      "storage": {
        "allClearTitle": "Stockage — tout est en ordre",
        "allClearBody": "Aucun des {count} environnements n'approche sa limite de stockage.",
        "attentionTitle": "Stockage — nécessite votre attention",
        "attentionBody": "{warn} environnements approchent de leur limite · {over} l'ont dépassée.",
        "usage": "{used} sur {quota} Mo ({percent} %)"
      }
    },
    "tenants": {
      "heading": "Tenants",
      "new": "Nouveau tenant",
      "edit": "Modifier le tenant — {name}",
      "empty": "Aucun tenant pour le moment. Créez le premier pour commencer.",
      "confirmDelete": "Supprimer le tenant ?",
      "confirmDeleteBody": "Ceci supprime {name} (suppression logique). Les données sont conservées et peuvent être restaurées par un ingénieur.",
      "confirmSlugLabel": "Saisissez « {slug} » pour confirmer",
      "confirmSlugHint": "Le slug du tenant. Sensible à la casse.",
      "confirmDeleteDomainTitle": "Supprimer le domaine ?",
      "confirmDeleteDomainBody": "Ceci supprime définitivement {host}. L'hôte ne sera plus résolu et les utilisateurs ne pourront plus accéder à ce tenant par ce biais.",
      "cols": {
        "name": "Nom",
        "slug": "Slug",
        "status": "Statut",
        "locale": "Langue",
        "domains": "Domaines"
      },
      "legacyDomainHint": "Hôte résiduel d'un ancien slug ou domaine personnalisé. Il pointe toujours vers ce tenant, mais n'est plus utilisé pour les nouvelles URL de connexion. Utilisez le × pour le supprimer.",
      "removeDomain": "Supprimer {host}",
      "manageDomainHint": "Hôte de gestion — session distincte pour l'administration du tenant (ADR-0028).",
      "contentDomainHint": "Hôte de contenu — le matériel e-learning s'y exécute, dans sa propre origine (ADR-0033 § 4).",
      "loginUrlTitle": "URL de connexion admin à usage unique",
      "loginUrlBody": "Envoyez cette URL au nouvel administrateur du tenant. Elle ne fonctionne qu'une seule fois et expire au bout de 15 minutes.",
      "orgStructure": "Structure organisationnelle",
      "manage": "Gérer",
      "fields": {
        "adminEmail": "E-mail du premier administrateur",
        "adminHint": "Facultatif — créez le premier administrateur du tenant dans la même étape. Il recevra prochainement une URL de connexion.",
        "adminName": "Nom du premier administrateur",
        "availableLocales": "Langues disponibles",
        "availableLocalesHint": "Langues parmi lesquelles les utilisateurs du tenant peuvent choisir. Cochez-en au moins une ; la langue par défaut doit être cochée.",
        "availableLocalesRequired": "Au moins une langue doit être disponible.",
        "bcsNumber": "Numéro BCS",
        "bcsNumberHint": "Le numéro de client que nous utilisons au sein de BCS pour ce client. Unique par tenant.",
        "contentSlug": "Slug de l'hôte de contenu",
        "contentSlugHint": "L'hôte qui diffuse le contenu e-learning, sous forme d'un seul label sous le domaine central. Laissez vide pour content-<slug>. Il doit différer du slug du locataire et du slug d'administration : cette séparation est précisément la raison d'être de cet hôte. Remarque : chaque environnement nécessite une règle DNS/proxy pour ce nom.",
        "currency": "Devise",
        "currencyHint": "La devise utilisée au sein de ce tenant, par exemple pour les prix et les budgets.",
        "customDomain": "Domaine personnalisé",
        "customDomainHint": "Facultatif. Un seul nom d'hôte (p. ex. leren.acme.nl) par lequel le tenant est également accessible. DNS + TLS relèvent de la responsabilité du tenant ; laissez vide pour conserver uniquement le sous-domaine par défaut.",
        "locale": "Langue par défaut",
        "localeHint": "Appliquée aux nouveaux utilisateurs du tenant, sauf s'ils choisissent eux-mêmes une autre langue.",
        "localeNotAvailable": "La langue par défaut doit également être cochée dans la liste des langues disponibles.",
        "manageSlug": "Slug de gestion",
        "manageSlugHint": "Sous-domaine de la console d'administration (un seul label sous le domaine de la plateforme). Laissez vide pour le manage-<slug> par défaut.",
        "name": "Nom d'affichage",
        "noPlatformLocales": "Aucune langue de plateforme activée pour le moment — ajoutez-en au moins une via le menu Langues.",
        "retentionDays": "Conservation des utilisateurs supprimés (jours)",
        "retentionDaysHint": "Nombre de jours après lesquels les utilisateurs supprimés (suppression logique) sont effacés définitivement (RGPD). Vide = 365 jours par défaut. Appliqué par la tâche de conservation quotidienne.",
        "slug": "Slug",
        "slugHint": "Lettres minuscules, chiffres et tirets. Constitue le sous-domaine par défaut.",
        "status": "Statut",
        "themeMode": "Thème",
        "themeModeHint": "Définissez le thème de couleurs de ce tenant : laisser les utilisateurs choisir (bouton dans la barre) ou imposer clair/sombre.",
        "themeModes": {
          "dark": "Toujours sombre",
          "light": "Toujours clair",
          "switch": "L'utilisateur choisit (bouton)"
        },
        "timezone": "Fuseau horaire",
        "timezoneHint": "Les imports planifiés s'exécutent à l'heure locale de ce fuseau horaire — un tenant sur Mexico_City avec une planification à 07:00 s'exécute à 07:00 heure de Mexico, pas à 07:00 aux Pays-Bas."
      },
      "seed": {
        "hint": "Facultatif — reprenez un ensemble de configurations depuis un tenant existant. Ne rien sélectionner crée un tenant vierge.",
        "sourceLabel": "Copier depuis le tenant",
        "sourceBlank": "— tenant vierge (aucune copie) —",
        "scopesLegend": "Éléments à copier",
        "toastCopied": "Tenant créé. Copié :",
        "toastSkipped": "Ignoré (rien à copier) :",
        "scopes": {
          "org_structure": {
            "label": "Structure organisationnelle",
            "hint": "Catégories + leur hiérarchie + schémas de champs personnalisés. Les unités elles-mêmes (services, équipes) ne sont PAS copiées."
          },
          "user_field_schema": {
            "label": "Schéma de champs utilisateur",
            "hint": "La définition complète des champs personnalisés des utilisateurs de ce tenant."
          },
          "display_name_format": {
            "label": "Format du nom d'affichage",
            "hint": "Modèle qui compose les noms d'affichage des utilisateurs. Entraîne aussi la copie du schéma de champs utilisateur."
          },
          "branding": {
            "label": "Image de marque",
            "hint": "Tokens de couleur + logo. Le fichier du logo est également copié."
          },
          "import_sources": {
            "label": "Sources d'import",
            "hint": "Les lignes sources + leur mappage slot/colonne. Entraîne aussi la copie de la structure organisationnelle et du schéma de champs utilisateur — le mappage référence les niveaux organisationnels + les champs utilisateur. Les identifiants ne sont JAMAIS copiés ; les sources arrivent désactivées avec des identifiants vides, à compléter par l'administrateur avant activation."
          },
          "workflow_templates": {
            "label": "Workflows",
            "hint": "Les définitions de workflows du tenant source (déclencheur → condition → étapes). Les exécutions restent propres à chaque tenant ; seules les définitions sont copiées. Le jeu global par défaut est de toute façon déjà installé dans chaque nouveau tenant."
          }
        }
      },
      "statusLabels": {
        "implementation": "Implémentation",
        "active": "Actif",
        "suspended": "Suspendu",
        "archived": "Archivé"
      },
      "statusHints": {
        "implementation": "Statut par défaut des tenants nouvellement créés. Le tenant fonctionne normalement pour l'équipe d'implémentation, mais aucun e-mail transactionnel n'est envoyé — passez sur Actif dès que la plateforme est configurée et prête à inviter de vrais utilisateurs.",
        "active": "En production pour les utilisateurs finaux. Connexions, e-mails et toutes les fonctionnalités fonctionnent normalement.",
        "suspended": "Le tenant est en pause. Les connexions des utilisateurs finaux sont refusées ; les sessions existantes reçoivent une erreur 503 à la requête suivante et sont déconnectées. La connexion superadmin « shadow » fonctionne toujours, afin que vous puissiez investiguer ou débloquer le tenant de l'intérieur.",
        "archived": "Le tenant est clôturé. Le site renvoie 404 à tout le monde, y compris à la connexion superadmin « shadow ». Les données restent dans la base de données ; levez d'abord l'archivage si vous avez de nouveau besoin d'un accès."
      },
      "cards": {
        "general": "Informations générales",
        "generalHint": "Nom, slug, domaine personnalisé et statut du tenant.",
        "languages": "Langues",
        "languagesHint": "Langue par défaut et langues parmi lesquelles les utilisateurs de ce tenant peuvent choisir."
      },
      "sections": {
        "general": "Général",
        "locales": "Langues",
        "branding": "Apparence",
        "mail": "E-mail",
        "pickerLabel": "Section",
        "login": "Connexion",
        "limits": "Fichiers",
        "modules": "Modules",
        "documents": "Documents"
      },
      "modules": {
        "intro": "Les modules dont dispose cet environnement. Seul BCS active ou désactive un module ; l’administrateur de l’environnement ne voit jamais un module désactivé.",
        "empty": "Aucun module n’est encore enregistré. Tout ce que la plateforme sait faire aujourd’hui est disponible pour chaque environnement.",
        "loadError": "Impossible de charger les modules.",
        "retry": "Réessayer",
        "state": {
          "standard": "Présent par défaut",
          "sold": "Vendu",
          "legacy_activatable": "Plus vendu, encore activable",
          "retired": "En voie de suppression"
        },
        "on": "Activé",
        "off": "Désactivé",
        "alwaysOn": "Toujours actif, ne peut pas être désactivé.",
        "retiredOff": "En voie de suppression : ne peut plus être activé.",
        "enable": "Activer",
        "disable": "Désactiver",
        "enabledBy": "Activé par {name} le {date}",
        "disabledBy": "Désactivé par {name} le {date}",
        "removedPerson": "un administrateur supprimé",
        "unknownPerson": "inconnu",
        "neverSwitched": "Jamais activé ni désactivé.",
        "confirmRetiredTitle": "Désactiver un module en voie de suppression ?",
        "confirmRetiredBody": "Le module {module} est en voie de suppression. Si vous le désactivez maintenant, vous ne pourrez plus le réactiver. Les données sont conservées.",
        "confirmRetired": "Désactiver quand même"
      },
      "mail": {
        "transportTitle": "Expéditeur & transport",
        "mode": "Mode d'envoi",
        "modeInherit": "Valeur globale par défaut",
        "modeInheritHint": "Suit la valeur globale par défaut : {mode}",
        "modeRelay": "Relais de la plateforme (recommandé)",
        "modeSmtp": "Votre propre serveur SMTP",
        "fromAddress": "Adresse d'expéditeur",
        "fromName": "Nom d'expéditeur",
        "replyTo": "Répondre à (Reply-To)",
        "smtpHost": "Hôte SMTP",
        "smtpPort": "Port SMTP",
        "smtpEncryption": "Chiffrement",
        "smtpUsername": "Nom d'utilisateur SMTP",
        "smtpPassword": "Mot de passe SMTP",
        "passwordSet": "Un mot de passe est défini — laissez vide pour le conserver.",
        "lifecycleTitle": "Envoi & conservation",
        "sendingEnabled": "Envoyer réellement les e-mails",
        "openTracking": "Suivi d'ouverture (pixel)",
        "storeTransactionalBody": "Conserver le contenu des e-mails transactionnels",
        "delayMinutes": "Délai (minutes)",
        "retentionDays": "Conservation (jours)",
        "testTitle": "E-mail de test",
        "testHint": "Envoie un e-mail de test via le transport configuré, même lorsque l'envoi est désactivé.",
        "testTo": "Adresse de test",
        "testToInvalid": "Saisissez une adresse e-mail valide.",
        "testSend": "Envoyer le test",
        "testOk": "E-mail de test envoyé.",
        "connectionTest": "Tester la connexion",
        "connectionHint": "Teste les paramètres de transport enregistrés sans envoyer d'e-mail. Enregistrez d'abord.",
        "connectionOk": "Connexion réussie.",
        "dnsTitle": "Vérification DNS (SPF/DKIM/DMARC)",
        "dnsHint": "Vérifie les enregistrements d'authentification e-mail du domaine expéditeur (From) configuré. Prédit si les e-mails passeront les filtres anti-spam des destinataires. Enregistrez d'abord.",
        "dnsCheck": "Vérifier le DNS",
        "dnsDomain": "Domaine",
        "dkimSelector": "Sélecteur DKIM (facultatif)",
        "dkimSelectorHint": "Sélecteur DKIM, p. ex. 'default' ou 's1' — nécessaire pour consulter le bon enregistrement DKIM.",
        "dnsExpected": "Ajoutez un enregistrement TXT sur {host} contenant :",
        "spfNoRelay": "n'inclut pas notre relais",
        "dnsStatus": {
          "ok": "OK",
          "warn": "avertissement",
          "missing": "manquant",
          "skipped": "non vérifié"
        }
      },
      "unsavedConfirm": "Vous avez des modifications non enregistrées. Continuer sans enregistrer ?",
      "userFields": {
        "baseHeading": "Champs de base",
        "baseHint": "Toujours présents sur chaque utilisateur. Champs fixes — seuls le libellé et « obligatoire » sont modifiables.",
        "requiredLabel": "Obligatoire",
        "labelForLocale": "Libellé ({locale})",
        "schemaHeading": "Champs supplémentaires",
        "schemaHint": "Chaque champ défini ici apparaît sur chaque profil utilisateur. Les types disponibles sont les mêmes que pour les unités de la structure organisationnelle.",
        "displayNameHeading": "Format du nom d'affichage",
        "displayNameHint": "Compose le libellé d'affichage de l'utilisateur à partir de ses champs de nom séparés. Les jetons entre accolades (first_name, last_name, email, ou toute clé de champ personnalisé) sont remplacés par la valeur de l'utilisateur concerné. Le format par défaut produit « Jan Janssen » ; passez à un format nom-prénom pour des annuaires triables, ou combinez avec un champ personnalisé « initialen ».",
        "displayNameFormat": "Modèle de format",
        "displayNameUnknownTokens": "Jetons inconnus dans le modèle — corrigez-les, sinon ils produiront des chaînes vides :",
        "displayNameTokensHeading": "Jetons disponibles",
        "displayNamePreview": "Aperçu :"
      },
      "branding": {
        "heading": "Apparence",
        "hint": "Personnalisez l'apparence de l'espace de travail de ce tenant. Les modifications prennent effet au prochain chargement de page.",
        "primaryColor": "Couleur de marque",
        "primaryColorHint": "Valeur hexadécimale (p. ex. #1a56db). Appliquée aux boutons, aux liens et à l'indicateur de navigation actif. Laissez vide pour la valeur par défaut de la plateforme.",
        "accentColor": "Couleur d'accent",
        "accentColorHint": "Valeur hexadécimale (p. ex. #13796d). Utilisée comme seconde couleur du dégradé des boutons primaires ainsi que pour les puces et icônes secondaires. Laissez vide pour la valeur par défaut de la plateforme.",
        "buttonHoverColor": "Couleur de survol des boutons",
        "buttonHoverColorHint": "Valeur hexadécimale. Arrière-plan des boutons primaires lorsque le curseur les survole. Laissez vide pour utiliser une variante légèrement plus foncée de la couleur de marque.",
        "activeIndicatorColor": "Indicateur de menu actif",
        "activeIndicatorColorHint": "Valeur hexadécimale. La fine barre colorée à gauche de la page actuellement ouverte dans la barre latérale. Laissez vide pour suivre la couleur de marque.",
        "sidebarColor": "Couleur de la barre latérale",
        "sidebarColorHint": "Valeur hexadécimale (p. ex. #1B1F33). Remplace l'arrière-plan sombre par défaut de la barre latérale. Doit être suffisamment foncée pour que le texte blanc reste lisible — les valeurs qui échouent au contrôle de contraste sont rejetées à l'enregistrement.",
        "sidebarPreview": "Aperçu en direct de la barre latérale avec cette couleur",
        "nameInUi": "Nom du portail",
        "nameInUiHint": "Nom affiché dans la barre latérale et l'onglet du navigateur. Si laissé vide, le nom d'affichage du tenant est utilisé.",
        "senderName": "Nom d'expéditeur formation",
        "senderNameHint": "Le nom sous lequel la fonction formation est connue chez ce client (RH, Développement, Formation). Signe les messages liés à l'apprentissage, par exemple « HRD — Acme Care » ; les messages de compte et d'accès ne portent que le nom de l'organisation. Le champ peut rester vide : seul le nom de l'organisation apparaîtra.",
        "logo": "Logo",
        "logoHint": "PNG ou JPG, 2 Mo max. Affiché dans la barre latérale à la place du logo BCS par défaut.",
        "logoUpload": "Téléverser un logo",
        "logoReplace": "Remplacer",
        "logoRemove": "Supprimer le logo",
        "logoPreview": "Aperçu du logo",
        "logoInvalid": "Échec du téléversement. Vérifiez le type de fichier (PNG/JPG) et la taille (2 Mo max).",
        "logoLayout": "Disposition logo + nom",
        "logoLayoutHint": "Choisissez comment le logo et le nom du portail se combinent dans la barre latérale et sur l'écran de connexion.",
        "logoLayouts": {
          "logo_then_title": "Logo avec le nom à côté",
          "logo_above_title": "Logo avec le nom en dessous",
          "logo_only": "Logo uniquement",
          "title_only": "Nom uniquement"
        },
        "logoAlign": "Alignement du bloc de marque",
        "logoAlignHint": "Détermine si le logo + le nom se placent au début de l'en-tête de la barre latérale ou sont centrés horizontalement. S'applique quelle que soit la disposition choisie ci-dessus.",
        "logoAligns": {
          "left": "Aligné au début",
          "center": "Centré"
        },
        "favicon": "Favicon",
        "faviconHint": "PNG, JPG ou ICO, 256 Ko max. Affiché dans l'onglet du navigateur à la place du favicon BCS par défaut.",
        "faviconUpload": "Téléverser un favicon",
        "faviconReplace": "Remplacer",
        "faviconRemove": "Supprimer le favicon",
        "faviconPreview": "Aperçu du favicon",
        "faviconInvalid": "Échec du téléversement. Vérifiez le type de fichier (PNG/JPG/ICO) et la taille (256 Ko max)."
      },
      "bcs": {
        "title": "BCS Login (OIDC)",
        "intro": "Choisissez le mode de connexion pour ce client et configurez BCS Login (Keycloak). Les secrets client ne sont jamais affichés ; laissez vide pour les conserver.",
        "mode": "Mode de connexion",
        "modePassword": "E-mail et mot de passe",
        "modeBcs": "BCS Login (OIDC)",
        "modeDev": "Connexion dev",
        "baseUrl": "URL de base",
        "realm": "Realm",
        "clientId": "ID client",
        "customerNr": "Numéro de client",
        "customerNrHint": "Vide = {number}, le numéro BCS sous Général. Ne remplissez ce champ que si cet environnement a besoin d’un autre numéro.",
        "customerNrEmpty": "Pas encore de numéro BCS sous Général",
        "customerNrMissing": "BCS Login ne peut pas être activé sans numéro de client — renseignez le numéro BCS sous Général, ou indiquez-en un ici.",
        "environmentCode": "Code d’environnement",
        "applicationCode": "Code d’application",
        "scopes": "Scopes",
        "clientSecret": "Secret client",
        "secretSet": "Laissez vide pour conserver le secret existant. Ne le remplissez que pour le remplacer.",
        "secretRequired": "Requis pour activer BCS Login.",
        "jitProvision": "Créer automatiquement les utilisateurs inconnus (JIT)",
        "provisioningTitle": "Création des comptes dans BCS Login",
        "provisioningConfigured": "Le client de provisioning est configuré sur le serveur et s'applique à tous les environnements. Il ne figure pas ici car il relève de la ligne de produits et non d'un client.",
        "provisioningMissing": "Aucun client de provisioning n'est configuré sur ce serveur : aucun compte n'est donc créé dans BCS Login ni révoqué. Il s'agit d'un réglage du serveur, pas d'un réglage de cet environnement.",
        "saveFailed": "Échec de l’enregistrement",
        "genericError": "Enregistrement impossible. Vérifiez les informations et réessayez.",
        "customerNrNoGeneral": "Aucun numéro BCS n’est encore renseigné sous Général. Renseignez-le là, ou donnez ici un numéro propre à cet environnement.",
        "customerNrOverrideTitle": "Numéro de client propre à cet environnement",
        "customerNrOverride": "La connexion utilise {override} au lieu de {general} provenant de Général. Si ce n’est pas correct, videz ce champ."
      },
      "documents": {
        "heading": "Documents",
        "intro": "Si les modèles de certificat BCS peuvent être choisis dans cet environnement. Désactivé prime sur le paramètre du client.",
        "available": "Modèles BCS disponibles",
        "saveFailed": "L'enregistrement a échoué.",
        "offNote": "Désactivé : le client ne voit pas les modèles BCS et ne peut pas les activer. Là où l'un d'eux est déjà choisi, il continue à créer des certificats."
      }
    },
    "auditLog": {
      "heading": "Journal d'audit",
      "intro": "Historique en lecture seule des modifications apportées à ce tenant. Les plus récentes en premier. Filtrez par préfixe d'action, acteur ou type de cible pour affiner la vue.",
      "empty": "Aucune entrée d'audit ne correspond aux filtres actuels.",
      "diffShow": "Afficher le diff",
      "pageOf": "Page {current} sur {total}",
      "filters": {
        "actionPlaceholder": "user.",
        "actorComboPlaceholder": "Rechercher par nom ou e-mail…",
        "actorComboAria": "Filtrer par acteur",
        "sectionSuperadmins": "Superadmins",
        "sectionUsers": "Utilisateurs",
        "targetTypePlaceholder": "User, Tenant…",
        "from": "Du",
        "to": "Jusqu'au",
        "clearAll": "Effacer tous les filtres"
      },
      "cols": {
        "when": "Quand",
        "actor": "Acteur",
        "action": "Action",
        "target": "Cible",
        "diff": "Diff"
      }
    },
    "superadmins": {
      "heading": "Superadmins",
      "intro": "Gérez l'équipe plateforme. Ajoutez un collègue, renommez-le ou renouvelez son mot de passe, supprimez-le lors de son départ.",
      "new": "Ajouter un superadmin",
      "edit": "Modifier le superadmin",
      "empty": "Aucun superadmin pour le moment — c'est inhabituel ; le superadmin initial (seed) devrait figurer ici.",
      "mfaOn": "MFA activée",
      "mfaOff": "MFA désactivée",
      "resetPassword": "Réinitialiser le mot de passe",
      "resetPasswordSubmit": "Réinitialiser le mot de passe",
      "resetPasswordBody": "Définissez un nouveau mot de passe pour {name}. Il devra être utilisé à la prochaine connexion.",
      "confirmDelete": "Supprimer le superadmin ?",
      "confirmDeleteBody": "Supprime {name} (suppression logique). Ses entrées du journal d'audit sont conservées ; sa session est invalidée à la prochaine requête.",
      "cols": {
        "name": "Nom",
        "email": "E-mail",
        "mfa": "MFA"
      },
      "fields": {
        "name": "Nom",
        "email": "E-mail",
        "password": "Mot de passe",
        "passwordHint": "Au moins 12 caractères avec des lettres (majuscules et minuscules) et des chiffres."
      }
    }
  },
  "tenantSetup": {
    "heading": "Configuration du tenant",
    "intro": "Tout ce dont ce tenant a besoin pour démarrer ou pour ajuster plus tard. Choisissez une section pour vous y plonger.",
    "comingSoon": "Bientôt disponible",
    "impersonate": "Se connecter en tant qu'administrateur du tenant",
    "impersonateGenericError": "Impossible de générer une URL de connexion pour ce tenant.",
    "impersonateUrlTitle": "URL de connexion à usage unique pour l'administrateur du tenant",
    "impersonateUrlBody": "Ouvrez cette URL dans ce navigateur, ou copiez-la pour l'utiliser dans un autre navigateur ou une fenêtre de navigation privée. Elle fonctionne une seule fois et expire rapidement.",
    "impersonateUrlOpen": "Ouvrir dans un nouvel onglet",
    "sections": {
      "orgStructure": {
        "title": "Structure de l'organisation",
        "description": "Définissez les catégories, leur hiérarchie et les champs personnalisés que l'administrateur du tenant peut remplir par unité."
      },
      "imports": {
        "title": "Imports d'utilisateurs",
        "description": "Téléversements CSV, flux SFTP ou intégrations avec des systèmes RH (AFAS, YouForce, HR2Day, Polaris)."
      },
      "platformSettings": {
        "title": "Paramètres de la plateforme",
        "description": "Branding, auth-driver, limites de licence et autres réglages à l'échelle du tenant."
      },
      "auditLog": {
        "title": "Journal d'audit",
        "description": "Historique en lecture seule des modifications sur ce tenant : qui a modifié quoi, et quand. Filtrez par action, acteur ou type de cible."
      }
    }
  },
  "platformAssets": {
    "add": "Ajouter des images",
    "addError": "L'ajout a échoué. Veuillez réessayer.",
    "confirmRemove": "Êtes-vous sûr ? L'image disparaîtra pour tous ceux qui l'utilisent.",
    "empty": "Il n'y a encore aucune image dans la bibliothèque.",
    "heading": "Bibliothèque de la plateforme",
    "intro": "Les images que nous fournissons. Elles ne sont pas copiées vers les environnements : elles sont stockées ici une seule fois. Cliquez sur une image pour voir où elle se trouve, la déployer ou la retirer. PNG et JPG uniquement ; plusieurs à la fois est possible.",
    "loadError": "La bibliothèque n'a pas pu être chargée.",
    "next": "Suivant",
    "pageOf": "Page {page} sur {total}",
    "pagination": "Pagination",
    "prev": "Précédent",
    "push": "Déployer",
    "pushConfirm": "Déployer vers {count} environnement(s)",
    "pushError": "Le déploiement a échoué. Veuillez réessayer.",
    "syncError": "La mise à jour des environnements a échoué.",
    "altError": "Le texte alternatif n'a pas pu être enregistré.",
    "revokeError": "L'image n'a pas pu être retirée.",
    "pushHas": "La possède déjà",
    "pushIntro": "Choisissez les environnements auxquels cette image est destinée. Rien ne se passe pour les environnements non cochés.",
    "sourceChangedHint": "Voici ce que contient la source actuellement. Si vous la reprenez, elle devient l'image — dans chaque environnement qui la possède, partout où elle est utilisée.",
    "syncDone": "{pushed} disponibilités ajoutées sur {tenants} environnements. Les images qu'un administrateur avait retirées n'ont pas été touchées.",
    "sync": "Mettre à jour dans tous les environnements",
    "altHint": "Chaque environnement reçoit ce texte. Un environnement peut le remplacer par langue ; là où il ne le fait pas, celui-ci est conservé.",
    "altHeading": "Texte alternatif fourni",
    "selectAll": "Tous les environnements",
    "rolloutHeading": "Déployer vers les environnements",
    "pushLoadError": "Les environnements n'ont pas pu être chargés.",
    "pushRemoved": "Retirée par le client",
    "revokeFor": "Retirer de {name}",
    "revoke": "Retirer",
    "pushRevoked": "Retirée par nos soins",
    "remove": "Supprimer",
    "removeError": "La suppression a échoué. Veuillez réessayer.",
    "removeFor": "Supprimer {name}"
  },
  "platformLocales": {
    "heading": "Langues de la plateforme",
    "intro": "Le catalogue des langues parmi lesquelles les tenants peuvent choisir. Les entrées désactivées restent dans le tableau pour référence, mais n'apparaissent plus dans les formulaires des tenants. Ajouter une langue ici ne fournit pas de traduction — assurez-vous que le bundle src/shared/i18n/locales/[code].json correspondant existe, sinon les utilisateurs verront les textes de repli en anglais.",
    "new": "Ajouter une langue",
    "edit": "Modifier la langue",
    "empty": "Aucune langue pour l'instant. Ajoutez-en une pour que les tenants puissent la choisir.",
    "on": "Activée",
    "off": "Désactivée",
    "cols": {
      "code": "Code",
      "label": "Libellé",
      "enabled": "Activée"
    },
    "confirmDelete": "Supprimer la langue ?",
    "confirmDeleteBody": "Supprime {label} ({code}) du catalogue. Les tenants qui référencent encore ce code dans leurs paramètres le perdront silencieusement au prochain enregistrement.",
    "fields": {
      "code": "Code",
      "codeHint": "Uniquement une langue pour laquelle la plateforme dispose de textes : {codes}.",
      "label": "Libellé natif",
      "labelHint": "Comment les locuteurs de la langue écrivent le nom de leur propre langue (Nederlands, Deutsch, Français, …).",
      "position": "Position",
      "positionHint": "Les numéros les plus bas apparaissent en premier dans les listes déroulantes des tenants.",
      "enabled": "Activée"
    }
  },
  "orgStructure": {
    "userFields": {
      "heading": "Champs utilisateur",
      "intro": "S'applique à tous les utilisateurs de ce tenant. Définissez le libellé de l'ID externe, des champs supplémentaires (mêmes types que pour les unités) et le format du nom d'affichage."
    },
    "userStructure": {
      "title": "Structure utilisateur",
      "summary": "{count} champs supplémentaires · nom d'affichage :"
    },
    "heading": "Structure organisationnelle",
    "intro": "Définissez les catégories, leur hiérarchie et les champs personnalisés qu'un administrateur de tenant peut remplir par unité. Faites glisser les lignes pour les réordonner ou changer d'unité parente.",
    "new": "Ajouter une catégorie",
    "edit": "Modifier la catégorie",
    "empty": "Aucune catégorie définie pour l'instant. Ajoutez la première pour commencer.",
    "customFields": "champ(s) personnalisé(s)",
    "confirmDelete": "Supprimer la catégorie ?",
    "confirmDeleteBody": "Supprime « {name} ». Les unités de cette catégorie et toutes les affectations d'utilisateurs à celles-ci seront supprimées — saisissez « {name} » pour confirmer.",
    "confirmDeletePrompt": "Saisissez le nom de la catégorie pour confirmer",
    "moveUpSibling": "Monter au sein du même niveau",
    "moveDownSibling": "Descendre au sein du même niveau",
    "moveOutdent": "Un niveau plus haut (hors de la catégorie parente)",
    "moveIndent": "Un niveau plus bas (sous la catégorie au-dessus)",
    "dragHint": "Faites glisser une catégorie : déposez-la sur une autre pour en faire une enfant, déposez-la au-dessus ou en dessous pour la réordonner au même niveau.",
    "dragHandle": "Faire glisser pour déplacer",
    "badge": {
      "required": "Obligatoire",
      "multiple": "Multiple"
    },
    "fields": {
      "key": "Clé",
      "keyHint": "Identifiant stable, lettres minuscules/chiffres/tirets/underscores. Utilisé plus tard dans l'interface de mapping de l'import RH.",
      "parent": "Rattachée à",
      "parentNone": "Aucune (niveau supérieur)",
      "parentHint": "Détermine la position de cette catégorie dans l'arborescence — comme le glisser-déposer, mais plus précis.",
      "labelFor": "Libellé ({locale})",
      "fieldSchema": "Champs personnalisés pour les unités de cette catégorie",
      "fieldSchemaHint": "Forme : { \"fields\": [{ \"key\": \"code\", \"type\": \"string\", \"required\": true, \"label\": { \"fr\": \"Code\" } }] }. Types : string, text, email, number, date, boolean, userid.",
      "fieldSchemaHintShort": "Chaque champ défini ici devient un champ de saisie typé sur chaque unité de cette catégorie (dans l'application tenant)."
    },
    "membership": {
      "heading": "Appartenance des utilisateurs",
      "hint": "Détermine comment les utilisateurs sont affectés aux unités de cette catégorie.",
      "membershipRequired": "Chaque utilisateur doit appartenir à au moins une unité de cette catégorie.",
      "allowMultipleUnits": "Un utilisateur peut appartenir à plusieurs unités de cette catégorie.",
      "allowNesting": "Une unité peut être rattachée à une autre unité de la même catégorie.",
      "allowNestingHint": "Activez cette option si votre structure comporte par exemple des équipes au sein d'équipes. Si elle est désactivée, une unité ne peut être rattachée qu'à la catégorie parente.",
      "ancestorAutoRequiredHint": "Une catégorie obligatoire rend implicitement ses catégories parentes obligatoires aussi — sinon les utilisateurs ne pourraient pas choisir d'unité.",
      "impactWarn": "{count} utilisateur(s) existant(s) n'ont actuellement aucune unité dans cette catégorie — leurs comptes restent actifs, mais la prochaine modification exigera un choix.",
      "impactSoftValidated": "Cette catégorie n'a pas encore d'unités ; la rendre obligatoire ne prendra effet qu'une fois que vous en aurez ajouté."
    },
    "externalIdLabel": {
      "heading": "Libellé de l'ID externe",
      "hint": "Le champ ID externe est toujours présent sur chaque unité de cette catégorie. Utilisez ceci pour renommer le libellé — par exemple « Code de centre de coûts ». Laissez vide pour utiliser le libellé par défaut « ID externe ».",
      "labelFor": "Libellé ({locale})"
    }
  },
  "tenant": {
    "dashboard": {
      "heading": "Mon tableau de bord",
      "intro": "Ce qui vous attend, en un seul endroit.",
      "loading": "Chargement de votre tableau de bord…",
      "loadError": "Votre tableau de bord n’a pas pu être chargé.",
      "retry": "Réessayer",
      "emptyTitle": "Rien ne vous attend pour le moment",
      "emptyBody": "Dès qu’une tâche, une approbation, une formation ou une demande vous concerne, elle apparaît ici.",
      "block": {
        "loading": "Chargement…",
        "loadError": "Ce bloc n’a pas pu être chargé.",
        "retry": "Réessayer",
        "viewAll": "Tout afficher",
        "count_one": "{count} en cours",
        "count_other": "{count} en cours"
      },
      "tasks": {
        "title": "Mes tâches",
        "empty": "Vous n’avez aucune tâche en cours.",
        "openUntil": "Ouvert jusqu’au {date}",
        "submittedOn": "Envoyé le {date}",
        "attendanceSince": "Présence à compléter depuis le {date}",
        "untitledActivity": "Formation sans titre",
        "typeLink": "{label} ({count})",
        "kind": {
          "questionnaire": "Questionnaire",
          "grading": "Correction",
          "attendance": "Présence"
        }
      },
      "approvals": {
        "title": "Approbations en attente",
        "empty": "Aucune approbation ne vous attend.",
        "unknownApplicant": "Demandeur inconnu",
        "decideBefore": "À décider avant le {date}",
        "kind": {
          "enrollment": "Inscription",
          "cancellation": "Annulation",
          "external_request": "Formation externe",
          "other": "Demande"
        }
      },
      "myCourses": {
        "title": "Mes formations",
        "count_one": "{count} formation",
        "count_other": "{count} formations",
        "empty": "Vous n’êtes inscrit à rien qui attende quelque chose de vous ou qui soit en cours.",
        "progress": "{percent} % terminé",
        "state": {
          "waiting": "Vous attend",
          "active": "En cours",
          "upcoming": "À venir"
        },
        "action": {
          "respond_offer": "Une place vous a été proposée : répondez",
          "fill_questionnaire_one": "Un questionnaire ou un test vous attend",
          "fill_questionnaire_other": "{count} questionnaires ou tests vous attendent",
          "start": "Pas encore commencé",
          "continue": "Continuer",
          "attend": "Session"
        }
      },
      "nextTraining": {
        "title": "Ma prochaine formation",
        "empty": "Aucune formation n’est plus prévue pour vous."
      },
      "myLessons": {
        "title": "Mes cours cette semaine",
        "empty": "Vous ne donnez pas cours cette semaine.",
        "count_one": "{count} cours",
        "count_other": "{count} cours"
      },
      "session": {
        "inZone": "{when} (fuseau horaire {zone})"
      },
      "myRequests": {
        "empty": "Vous n’avez aucune demande en cours.",
        "emptyCanStart": "Demandez une formation qui ne figure pas au catalogue."
      }
    },
    "adminDashboard": {
      "heading": "Tableau de bord",
      "intro": "Ce qui vous attend, ce qui s’est passé aujourd’hui et ce que contient votre environnement.",
      "loading": "Chargement du tableau de bord…",
      "loadError": "Le tableau de bord n’a pas pu être chargé.",
      "retry": "Réessayer",
      "emptyTitle": "Rien pour vous ici pour l’instant",
      "emptyBody": "Vos droits ne donnent accès à aucun bloc du tableau de bord d’administration. Utilisez le menu pour continuer.",
      "nothingWaiting": "Rien ne vous attend.",
      "zones": {
        "waiting": "Ce qui m’attend",
        "today": "Ce qui s’est passé aujourd’hui",
        "now": "Ce qui se passe maintenant",
        "environment": "Ce que contient mon environnement"
      },
      "signals": {
        "title": "Signaux",
        "empty": "Aucun signal.",
        "count_one": "{count} signal",
        "count_other": "{count} signaux",
        "cancelledToday_one": "{count} annulation aujourd’hui",
        "cancelledToday_other": "{count} annulations aujourd’hui",
        "belowMinimum": "Sous le minimum : {taken} sur au moins {minimum} participants",
        "decide": "Cette formation a-t-elle lieu ?"
      },
      "logins": {
        "title": "Connexions",
        "today": "Aujourd’hui",
        "yesterday": "Dernière connexion hier"
      },
      "enrollmentsToday": {
        "title": "Inscriptions aujourd’hui",
        "enrolled": "Inscriptions",
        "cancelled": "Annulations"
      },
      "logStrip": {
        "title": "Récemment dans le journal",
        "empty": "Aucune connexion, inscription ou annulation dans le journal pour l’instant.",
        "someone": "Quelqu’un",
        "login": "{name} s’est connecté",
        "enrollment": "{name} s’est inscrit à {course}",
        "enrollmentNoCourse": "{name} s’est inscrit",
        "cancellation": "{name} a annulé son inscription à {course}",
        "cancellationNoCourse": "{name} a annulé une inscription",
        "enrollmentByOther": "{actor} a inscrit {participant} à {course}",
        "enrollmentByOtherNoCourse": "{actor} a inscrit {participant}",
        "enrollmentNoActor": "{participant} a été inscrit à {course}",
        "enrollmentNoActorNoCourse": "{participant} a été inscrit",
        "cancellationByOther": "{actor} a annulé l’inscription de {participant} à {course}",
        "cancellationByOtherNoCourse": "{actor} a annulé l’inscription de {participant}",
        "cancellationNoActor": "L’inscription de {participant} à {course} a été annulée",
        "cancellationNoActorNoCourse": "L’inscription de {participant} a été annulée",
        "erased": "Utilisateur supprimé"
      },
      "shortcuts": {
        "title": "Raccourcis",
        "empty": "Aucun raccourci.",
        "users": "Utilisateurs actifs",
        "catalog": "Catalogue"
      },
      "failedCertificates": {
        "title": "Certificats non créés",
        "count_one": "{count} certificat",
        "count_other": "{count} certificats",
        "empty": "Tous les certificats ont été créés."
      },
      "documentTemplateUpdates": {
        "title": "Nouvelle version d’un modèle BCS",
        "count_one": "{count} modèle",
        "count_other": "{count} modèles",
        "empty": "Aucune nouvelle version.",
        "versions": "Version {from} → {to}",
        "tenant_logo_changed": "Nouveau logo de l’environnement",
        "tenant_logo_removed": "Logo de l’environnement supprimé"
      }
    },
    "sendMessage": {
      "title": "Envoyer un message",
      "intro": "Rédigez un message et choisissez qui le reçoit. Vous verrez combien d'utilisateurs il atteint avant l'envoi.",
      "subject": "Objet",
      "body": "Message",
      "audience": "Destinataires",
      "segmentType": "Audience",
      "types": {
        "individuals": "Utilisateurs individuels",
        "orgUnits": "Unités organisationnelles",
        "orgUnitManagers": "Responsables d'unité",
        "everyone": "Tout le monde",
        "everyoneHint": "Tous les utilisateurs actifs."
      },
      "pickUsers": "Rechercher et sélectionner des utilisateurs…",
      "pickUnits": "Rechercher et sélectionner des unités…",
      "includeDescendants": "Inclure les sous-unités",
      "addSegment": "Ajouter une audience",
      "attachments": "Pièces jointes",
      "addAttachment": "Ajouter une pièce jointe",
      "attachmentError": "Échec de l'envoi — vérifiez le type et la taille du fichier (max 10 Mo).",
      "timing": "Moment d'envoi",
      "when": "Quand envoyer",
      "whenNow": "Immédiatement",
      "whenLater": "Planifier à une date/heure",
      "scheduledFor": "Envoyer le",
      "reaches": "Atteint {count} utilisateur(s)",
      "noAudience": "Aucune audience sélectionnée pour l'instant.",
      "send": "Envoyer",
      "sent": "Message planifié pour {count} destinataire(s).",
      "confirmTitle": "Envoyer le message ?",
      "confirmBody": "Ce message sera envoyé à {count} utilisateur(s).",
      "confirmBodyUnknown": "Voulez-vous vraiment envoyer ce message ?",
      "confirmSend": "Oui, envoyer",
      "editor": {
        "toolbar": "Mise en forme",
        "bold": "Gras",
        "italic": "Italique",
        "underline": "Souligner",
        "heading": "Titre",
        "bulletList": "Liste à puces",
        "numberList": "Liste numérotée",
        "alignLeft": "Aligner à gauche",
        "alignCenter": "Centrer",
        "alignRight": "Aligner à droite",
        "link": "Insérer un lien",
        "linkPrompt": "Saisissez une URL https :",
        "linkTitle": "Insérer un lien",
        "linkTextLabel": "Texte",
        "linkUrlLabel": "URL",
        "linkInsert": "Insérer",
        "linkInvalid": "Utilisez un lien https:// ou mailto:.",
        "linkChipHint": "Le tag {tag} devient le lien cliquable.",
        "linkRemove": "Supprimer le lien"
      }
    }
  },
  "orgChart": {
    "heading": "Organigramme",
    "coverage": {
      "title": "Qui fait partie de {name} ?",
      "back": "Retour au groupe",
      "today": "Voici qui en fait partie aujourd’hui. Un groupe fonctionne avec des règles : demain, ce peut être quelqu’un d’autre.",
      "ofTotal": "{members} sur {total}",
      "emptyUnit": "aucune personne",
      "namedIncluded": "inclus par la règle",
      "namedExcluded": "exclu par la règle",
      "legendFull": "tout le monde en fait partie",
      "legendSome": "une partie en fait partie",
      "legendNone": "personne n’en fait partie",
      "legendNamedIncluded": "la règle nomme cette unité : inclure",
      "legendNamedExcluded": "la règle nomme cette unité : exclure",
      "total": "{count} personnes au total.",
      "unplaced": "Parmi elles, {count} n’appartiennent à aucune unité et ne figurent donc pas ici.",
      "unavailable": "Impossible de charger les personnes couvertes par ce groupe."
    },
    "hint": "Faites glisser un bloc sur sa nouvelle unité parente pour le déplacer ; faites glisser l'arrière-plan pour déplacer la vue, faites défiler pour zoomer. Clavier : flèches = naviguer, Entrée = modifier l'unité, espace = replier/déplier.",
    "levelFilter": "Afficher les catégories",
    "search": "Rechercher une unité…",
    "expandAll": "Tout déplier",
    "collapseAll": "Tout replier",
    "export": "Exporter en image (PNG)",
    "exportPdf": "Télécharger en PDF — texte vectoriel net, même pour les grands organigrammes",
    "print": "Imprimer l'organigramme",
    "hits_one": "{count} résultat — Entrée pour y aller",
    "hits_other": "{count} résultats — Entrée pour passer au suivant",
    "back": "Vue tableau",
    "fit": "Ajuster à l'écran",
    "zoomIn": "Zoom avant",
    "zoomOut": "Zoom arrière",
    "expand": "Déplier les unités subordonnées",
    "collapse": "Replier les unités subordonnées",
    "members_one": "{count} membre",
    "members_other": "{count} membres",
    "empty": "Pas encore d'unités — créez-les d'abord dans la vue tableau.",
    "toUnits": "Vers les unités d'organisation"
  },
  "orgUnitsList": {
    "heading": "Unités par catégorie",
    "viewChart": "Organigramme",
    "intro": "Vue d'ensemble par catégorie. Cliquez sur un onglet pour changer de catégorie et sur une ligne pour ouvrir la page de détail.",
    "level": "Catégorie",
    "searchPlaceholder": "Rechercher par nom, ID externe, unité parente ou attribut…",
    "addFor": "Nouvelle unité « {level} »",
    "empty": "Aucune unité dans cette catégorie. Ajoutez-en une ou ajustez votre recherche.",
    "unknownUser": "Utilisateur inconnu",
    "viewMembers": "Voir les {count} membres de cette unité",
    "col": {
      "name": "Nom",
      "parent": "Unité parente",
      "members": "Membres"
    }
  },
  "unitDetail": {
    "loading": "Chargement…",
    "detailsHeading": "Détails",
    "membersHeading": "Membres",
    "membersNonLeafHint": "Les utilisateurs sont généralement rattachés au niveau le plus profond ; cette unité peut aussi avoir des membres, mais c'est inhabituel.",
    "noMembers": "Pas encore de membres.",
    "childrenHeading": "Unités enfants",
    "noChildren": "Pas encore d'unités enfants."
  },
  "userProfile": {
    "avatar": {
      "heading": "Photo de profil",
      "upload": "Téléverser une photo",
      "replace": "Remplacer la photo",
      "remove": "Supprimer",
      "present": "Une photo de profil est définie",
      "cropTitle": "Recadrer la photo",
      "cropHint": "Faites glisser pour repositionner et utilisez le curseur pour zoomer.",
      "cropZoom": "Zoom",
      "cropConfirm": "Appliquer"
    },
    "loading": "Chargement…",
    "openLink": "Profil",
    "detailsHeading": "Détails du profil",
    "assignmentsHeading": "Appartenance à l'organisation",
    "assignmentsHint": "Choisissez pour chaque catégorie la ou les unités auxquelles cet utilisateur appartient. Une sous-catégorie devient disponible dès que sa catégorie parente est remplie.",
    "noCategories": "Aucune catégorie définie — demandez à BCS Learning de renseigner la structure organisationnelle.",
    "noUnitsForCategory": "Aucune unité dans « {category} » — ajoutez-en d'abord via Structure organisationnelle.",
    "pickPlaceholder": "Choisir…",
    "pickerLockedNoParent": "Renseignez d'abord « {parent} » pour activer ce sélecteur.",
    "cascadeClearedToast": "Retiré de « {category} » : {names} (parent modifié)",
    "save": "Enregistrer",
    "savedToast": "Affectations enregistrées.",
    "saveError": "Échec de l'enregistrement — vérifiez les erreurs par catégorie.",
    "customFieldsHeading": "Champs supplémentaires",
    "deletedBanner": "Cet utilisateur a été supprimé. La modification est désactivée — vous pouvez restaurer l'utilisateur ou effacer définitivement ses données.",
    "lastLogin": "Dernière connexion : {when}",
    "lastLoginNever": "Jamais connecté",
    "restore": "Restaurer l'utilisateur",
    "restoreError": "Échec de la restauration. Veuillez réessayer.",
    "gdpr": {
      "heading": "Confidentialité (RGPD)",
      "intro": "Exportez toutes les données de cet utilisateur, ou effacez-les définitivement sur demande.",
      "export": "Exporter les données",
      "exportError": "Échec de l'exportation. Veuillez réessayer.",
      "erase": "Effacer les données",
      "eraseError": "Échec de l'effacement. Veuillez réessayer.",
      "eraseConfirmTitle": "Effacer définitivement les données ?",
      "eraseConfirmBody": "Cette action supprime {name} de façon irréversible : profil, liens et appartenances. Des traces anonymisées sont conservées pour la piste d'audit. Cette action ne peut pas être annulée.",
      "eraseConfirmLabel": "Saisissez l'adresse e-mail pour confirmer : {email}"
    }
  },
  "tenantUsers": {
    "heading": "Utilisateurs",
    "impersonate": "Se connecter en tant que",
    "impersonateFailed": "La connexion en tant que cet utilisateur a échoué.",
    "new": "Nouvel utilisateur",
    "edit": "Modifier l'utilisateur — {name}",
    "empty": "Aucun utilisateur pour l'instant.",
    "confirmDelete": "Supprimer l'utilisateur ?",
    "confirmDeleteBody": "Supprime {name} (suppression réversible). La piste d'audit est conservée.",
    "viewDeleted": "Utilisateurs supprimés",
    "backToActive": "Retour aux utilisateurs actifs",
    "deletedHeading": "Utilisateurs supprimés",
    "deletedListIntro": "Vous consultez les utilisateurs supprimés. Ouvrez un profil pour restaurer l'utilisateur ou effacer définitivement ses données.",
    "deletedEmpty": "Aucun utilisateur supprimé.",
    "bulkErase": "Effacer définitivement ({count})",
    "bulkEraseTitle": "Effacer définitivement les utilisateurs ?",
    "bulkEraseBody": "Vous êtes sur le point d'effacer irréversiblement {count} utilisateur(s) : profils, liens et appartenances. Des traces anonymisées sont conservées pour la piste d'audit. Cette action ne peut pas être annulée.",
    "bulkEraseConfirmLabel": "Saisissez le nombre pour confirmer : {count}",
    "bulkEraseConfirm": "Effacer définitivement",
    "bulkEraseError": "Échec de l'effacement. Veuillez réessayer.",
    "bulkEraseDone": "{count} utilisateur(s) définitivement effacé(s).",
    "bulkEraseDoneSkipped": "{count} utilisateur(s) définitivement effacé(s) ; {skipped} ignoré(s) (dernier administrateur).",
    "bulkEraseDonePartial": "{count} utilisateur(s) définitivement effacé(s). {failed} n'ont pas pu être effacé(s) et figurent toujours dans la liste ; l'erreur a été signalée.",
    "bulkEraseDonePartialSkipped": "{count} utilisateur(s) définitivement effacé(s) ; {skipped} ignoré(s) (dernier administrateur). {failed} n'ont pas pu être effacé(s) et figurent toujours dans la liste ; l'erreur a été signalée.",
    "fields": {
      "name": "Nom",
      "firstName": "Prénom",
      "lastName": "Nom",
      "displayNameLabel": "Nom d'affichage :",
      "email": "E-mail",
      "role": "Rôle",
      "status": "Statut",
      "isExternal": "Utilisateur externe",
      "isExternalHint": "Sans contrat de travail avec cette organisation — par exemple un auditeur, un formateur indépendant ou un sous-traitant. Un message à « tout le monde » ne parvient pas aux comptes externes par défaut.",
      "isLearner": "Suit des formations",
      "isLearnerHint": "Cette personne apprend et compte dans les rapports sur les activités suivies. Indépendant d'externe : un sous-traitant est externe et apprenant, un auditeur externe et non apprenant. Désactivé signifie aussi : pas de rôle de base Utilisateur.",
      "externalId": "ID externe",
      "phone": "Téléphone",
      "hireDate": "Date d'entrée",
      "endDate": "Date de sortie",
      "accountValidFrom": "Compte valide à partir du",
      "accountValidFromHint": "Avant cette date, l'utilisateur ne peut pas encore se connecter. Vide = valide immédiatement.",
      "accountValidUntil": "Compte valide jusqu'au",
      "accountValidUntilHint": "Après cette date, l'utilisateur ne peut plus se connecter. Vide = valide indéfiniment.",
      "deletedAt": "Supprimé le",
      "roles": "Rôles"
    },
    "status": {
      "active": "Actif",
      "invited": "Invité",
      "suspended": "Suspendu",
      "expired": "Expiré",
      "not_yet_valid": "Pas encore valide"
    },
    "roles": {
      "tenant-admin": "Administrateur",
      "user": "Utilisateur"
    },
    "filteredByUnit": "Filtré sur les membres de « {unit} ».",
    "clearFilter": "Afficher tous les utilisateurs",
    "baseRoleNote": "Chaque nouvel utilisateur reçoit également le rôle de base Utilisateur.",
    "createdButRoleFailed": "L’utilisateur a été créé, mais tous les rôles n’ont pas pu être attribués :",
    "toProfile": "Aller au profil",
    "filteredByRole": "Uniquement les utilisateurs ayant le rôle « {role} ».",
    "manageRoles": "Gérer les rôles et la portée →",
    "pickRoles": "Choisissez un ou plusieurs rôles"
  },
  "orgUnits": {
    "heading": "Unités organisationnelles",
    "missingParent": "Unité parente obligatoire manquante",
    "missingParentBanner_one": "{count} unité devrait être rattachée à une unité parente selon la structure actuelle, mais n'en a pas. Rattachez-la via Modifier.",
    "missingParentBanner_other": "{count} unités devraient être rattachées à une unité parente selon la structure actuelle, mais n'en ont pas. Rattachez-les via Modifier.",
    "intro": "Remplissez l'arborescence définie par le superadmin. Ajoutez des unités enfants, modifiez les attributs et affectez les utilisateurs du tenant.",
    "new": "Ajouter une unité",
    "edit": "Modifier l'unité",
    "empty": "Aucune unité pour l'instant. Ajoutez votre première organisation au sommet.",
    "noLevelsTitle": "Aucune catégorie définie",
    "noLevelsBody": "Demandez à BCS Learning de définir au moins une catégorie avant de pouvoir ajouter des unités.",
    "confirmDelete": "Supprimer l'unité ?",
    "confirmDeleteBody": "Suppression logique de {name}. Possible uniquement lorsque l’unité est vide : aucun collaborateur dedans et aucune unité en dessous.",
    "impactUnavailable": "Impossible de charger ce qui dépend de cette unité. Réessayez avant de supprimer.",
    "impact": {
      "blockedLead": "Impossible pour le moment — l’unité n’est pas vide :",
      "losingLead": "Ceci disparaîtra dès la suppression :",
      "users": "{count} collaborateur(s) s’y trouvent encore",
      "children": "{count} unité(s) se trouvent en dessous",
      "roleAssignments": "{count} attribution(s) de rôle portant sur cette unité n’accorderont plus rien",
      "accessGroups": "{count} groupe(s) d’accès sont cassés et n’incluent plus personne",
      "exclusions": "Attention : {count} groupe(s) d’accès excluent cette unité. Ils sont cassés eux aussi et n’incluent plus personne — tant que vous ne les réparez pas.",
      "nothingAttached": "Rien d’autre ne dépend de cette unité.",
      "groupNames": "Sont concernés : {names}."
    },
    "assignTitle": "Affecter un utilisateur à l'unité",
    "assignBody": "Choisissez un utilisateur à affecter à {name}. Seules les affectations actives apparaissent sur le profil utilisateur.",
    "assign": "Affecter",
    "fields": {
      "level": "Catégorie",
      "name": "Nom",
      "externalId": "ID externe",
      "externalIdHint": "Identifiant stable issu de votre système RH — utilisé lorsque le même enregistrement est réimporté.",
      "attributes": "Attributs personnalisés",
      "attributesHint": "Valeurs des champs personnalisés déclarés dans le schéma de cette catégorie.",
      "parent": "Unité parente",
      "parentOf": "{level} parent",
      "parentHintFree": "Facultatif. L'unité sous laquelle celle-ci est rattachée dans l'arborescence.",
      "parentHintConstrained": "Cette catégorie est rattachée sous « {level} » — seules les unités de cette catégorie sont affichées.",
      "parentRequired": "Cette catégorie doit être rattachée à une unité parente — choisissez-en une.",
      "pickParent": "choisissez une unité parente",
      "noParent": "— aucun parent (racine) —",
      "user": "Utilisateur"
    }
  },
  "fieldSchema": {
    "empty": "Aucun champ personnalisé pour l'instant. Cliquez sur « Ajouter un champ » pour définir le premier.",
    "addField": "Ajouter un champ",
    "fields": {
      "key": "Clé",
      "type": "Type",
      "required": "Obligatoire",
      "labelFor": "Libellé ({locale})",
      "role": "Rôle"
    },
    "dragHandle": "Glisser pour réorganiser",
    "labels": {
      "expand": "Afficher les libellés",
      "collapse": "Masquer les libellés",
      "none": "Aucun libellé renseigné",
      "collapsedSummary": "Libellés renseignés pour :"
    },
    "errors": {
      "invalidKey": "Utilisez des lettres minuscules, des chiffres, des tirets ou des tirets bas (p. ex. « cost_center »).",
      "duplicateKey": "Cette clé est déjà utilisée dans cette catégorie."
    },
    "roles": {
      "none": "Aucun rôle (champ propre)"
    }
  },
  "orgFields": {
    "types": {
      "string": "Texte (une ligne)",
      "text": "Texte (plusieurs lignes)",
      "email": "E-mail",
      "number": "Nombre",
      "date": "Date",
      "boolean": "Oui / Non",
      "userid": "Utilisateur (p. ex. manager)"
    }
  },
  "attributeForm": {
    "noFields": "Cette catégorie n'a pas de champs personnalisés.",
    "required": "Ce champ est obligatoire.",
    "boolean": {
      "label": "Oui"
    }
  },
  "profile": {
    "prefs": {
      "heading": "Préférences",
      "rememberDrafts": "Mémoriser les brouillons dans les formulaires",
      "rememberDraftsHint": "Enregistre vos saisies localement, sur toutes les pages, pour ne rien perdre."
    },
    "mfa": {
      "title": "Vérification en deux étapes",
      "intro": "Une étape supplémentaire lors de la connexion, en plus de votre mot de passe. Une application d’authentification est nécessaire.",
      "start": "Configurer",
      "qrAlt": "Code QR pour votre application d’authentification",
      "secretHint": "Pas de caméra ? Saisissez cette clé à la main :",
      "code": "Code de l’application",
      "confirm": "Activer",
      "on": "La vérification en deux étapes est activée.",
      "newCodes": "Nouveaux codes de récupération",
      "disable": "Désactiver",
      "codesTitle": "Conservez ces codes de récupération",
      "codesHint": "Vous ne les voyez qu’une fois. Conservez-les ailleurs que sur votre téléphone : sans l’un de ces codes, vous ne pourrez plus vous connecter si vous perdez votre application.",
      "genericError": "Cela n’a pas fonctionné. Veuillez réessayer."
    },
    "heading": "Mon profil",
    "intro": "Mettez à jour vos propres informations. Votre e-mail reste fixe — votre piste d'audit y est rattachée.",
    "saved": "Enregistré.",
    "fields": {
      "email": "E-mail",
      "name": "Nom",
      "locale": "Langue",
      "localeHint": "La langue dans laquelle l'application s'affiche."
    }
  },
  "tenantAuth": {
    "title": "Connexion en cours",
    "verifying": "Vérification de votre lien de connexion…",
    "success": "Connexion réussie ! Redirection vers votre espace de travail.",
    "failedTitle": "Échec de la connexion",
    "genericError": "Impossible de vous connecter. Demandez un nouveau lien de connexion à votre administrateur.",
    "sessionExpired": "Votre session a expiré. Veuillez rouvrir votre URL de dev-login pour vous reconnecter.",
    "needLoginUrl": "Connectez-vous en ouvrant l'URL de dev-login que votre administrateur vous a envoyée.",
    "loginUrlHint": "Chaque URL ne fonctionne qu'une seule fois et expire après 15 minutes — demandez-en une nouvelle si vous l'avez déjà utilisée.",
    "backHome": "Retour à l'accueil",
    "form": {
      "title": "Se connecter",
      "email": "Adresse e-mail",
      "password": "Mot de passe",
      "remember": "Rester connecté",
      "submit": "Se connecter",
      "forgotLink": "Mot de passe oublié ?",
      "loading": "Chargement…",
      "genericError": "Connexion impossible. Vérifiez vos informations et réessayez."
    },
    "forgot": {
      "title": "Mot de passe oublié ?",
      "intro": "Saisissez votre adresse e-mail et nous vous enverrons un lien pour définir un nouveau mot de passe.",
      "email": "Adresse e-mail",
      "submit": "Envoyer le lien de réinitialisation",
      "done": "Si un compte est associé à cette adresse, un lien de réinitialisation est en route. Consultez votre boîte de réception.",
      "backToLogin": "Retour à la connexion",
      "genericError": "Une erreur est survenue. Veuillez réessayer."
    },
    "reset": {
      "title": "Définir un nouveau mot de passe",
      "intro": "Choisissez un nouveau mot de passe pour votre compte.",
      "password": "Nouveau mot de passe",
      "passwordConfirmation": "Confirmez le nouveau mot de passe",
      "submit": "Définir le mot de passe",
      "success": "Votre mot de passe a été défini. Vous pouvez maintenant vous connecter.",
      "toLogin": "Aller à la connexion",
      "invalid": "Ce lien de réinitialisation est invalide ou a expiré. Demandez-en un nouveau.",
      "genericError": "Une erreur est survenue. Veuillez réessayer.",
      "missingToken": "Cette page nécessite un lien de réinitialisation valide. Utilisez le lien de votre e-mail."
    },
    "bcs": {
      "title": "Connexion",
      "lead": "Connectez-vous avec votre compte BCS.",
      "button": "Se connecter avec BCS",
      "failedTitle": "Échec de la connexion",
      "failedBody": "Une erreur s’est produite lors de la connexion avec BCS. Veuillez réessayer."
    }
  },
  "imports": {
    "heading": "Imports d'utilisateurs",
    "intro": "Sources d'import configurées pour ce tenant. Chaque source décrit un flux d'export RH (fichier ou flux) et la façon dont ses colonnes sont mappées sur les utilisateurs + unités de la plateforme. Une fois actives, les sources peuvent s'exécuter selon une planification.",
    "sources": {
      "heading": "Sources d'import",
      "intro": "Chaque ligne est un flux configuré — téléversement de fichier, dossier FTP ou API. Ouvrez-en un pour reparcourir l'assistant.",
      "new": "Nouvelle source d'import",
      "run": "Exécuter",
      "empty": "Aucune source d'import configurée pour le moment. Cliquez sur « Nouvelle source d'import » pour lancer l'assistant.",
      "confirmDelete": "Supprimer « {name} » ? Les utilisateurs et unités déjà importés via cette source sont conservés — seul leur lien avec la source est effacé.",
      "scheduleActive": "Active",
      "scheduleOff": "Planification désactivée",
      "scheduleNoTimes": "Active, mais aucun horaire configuré",
      "scheduleAt": "S'exécute chaque jour à {times}",
      "types": {
        "csv_upload": "Téléversement CSV",
        "csv_sftp": "FTP / SFTP",
        "api": "API"
      }
    },
    "preview": {
      "results": "Résultats de l'aperçu",
      "downloadExcel": "Télécharger au format Excel",
      "columnMismatchBanner": "Un ou plusieurs fichiers ne correspondent pas au mappage de colonnes enregistré — les champs sans colonne resteront vides lors de l'import. Vérifiez la liste des colonnes manquantes par slot ci-dessous avant de continuer.",
      "missingColumns": "Manquantes dans le fichier",
      "extraColumns": "En surplus dans le fichier (seront ignorées)",
      "errorClustersHeading": "Résumé des erreurs ({n} au total) — cliquez pour développer",
      "summary": {
        "rows": "lignes",
        "users": "Utilisateurs",
        "units": "Unités",
        "assignments": "Affectations",
        "errors": "Erreurs",
        "create": "{n} à créer",
        "update": "{n} à mettre à jour",
        "unchanged": "{n} inchangés",
        "skip": "{n} à ignorer",
        "noFile": "Aucun fichier fourni pour ce slot."
      },
      "table": {
        "row": "#",
        "actions": "Actions prévues",
        "errors": "Erreurs",
        "empty": "Rien à afficher — le fichier n'a produit aucune ligne.",
        "capped": "Affichage des 50 premières lignes + de toutes les lignes en erreur. Téléchargez l'Excel pour la liste complète."
      },
      "ops": {
        "create": "Créer",
        "update": "Mettre à jour",
        "skip_unchanged": "Inchangé",
        "skip": "Ignorer",
        "skip_duplicate": "Doublon",
        "excluded": "Exclu",
        "error": "Erreur"
      },
      "opsShort": {
        "create": "nouveau",
        "update": "mis à jour",
        "unchanged": "inchangé"
      }
    },
    "run": {
      "title": "Exécuter l'import",
      "intro": "Déposez les fichiers sources pour cette configuration. Chaque fichier est associé par son nom à un slot configuré — vérifiez les correspondances, corrigez les éventuels écarts et lancez un dry-run avant de valider.",
      "dropHere": "Déposez les fichiers CSV ici",
      "orPick": "ou cliquez pour choisir des fichiers",
      "filesHeading": "Fichiers",
      "filesEmpty": "Aucun fichier pour le moment. Déposez un ou plusieurs fichiers CSV ci-dessus.",
      "vendorHeading": "Import fournisseur — aucun téléversement nécessaire",
      "vendorBody": "Les enregistrements sont récupérés en direct depuis l'API {vendor} lorsque vous cliquez sur Aperçu ou Exécuter. Les slots configurés à l'étape de mappage sont interrogés dans l'ordre.",
      "matchedSlot": "Slot associé",
      "noMatch": "Aucun slot correspondant",
      "skip": "Ignorer ce fichier",
      "duplicateMatch": "Deux fichiers correspondent au même slot — choisissez un autre slot pour l'un des deux.",
      "missingSlots": "Ces slots configurés n'ont pas encore de fichier : {slots}",
      "headerToggle": "La première ligne contient les titres de colonnes",
      "headerToggleHint": "Désactivé = la première ligne est traitée comme des données et les colonnes sont désignées par des lettres A/B/C à la manière d'Excel.",
      "removeFile": "Retirer",
      "runPreview": "Lancer l'aperçu",
      "rerun": "Relancer l'aperçu",
      "running": "Aperçu en cours…",
      "noFilesPicked": "Choisissez au moins un CSV pour lancer l'aperçu.",
      "commit": "Valider l'import",
      "skipExisting": "{n} déjà lié(s)",
      "confirmTitle": "Valider cet import ?",
      "confirmBody": "Le dry-run est en lecture seule ; cette étape écrit réellement tout dans la base de données. Réimporter les mêmes fichiers plus tard est sans risque — les lignes déjà importées sont mises à jour sur place.",
      "confirmErrorsHint": "Certaines lignes comportaient des erreurs dans l'aperçu. Ces lignes seront ignorées lors de la validation ; les autres seront traitées normalement.",
      "confirmGo": "Oui, valider",
      "successTitle": "Import validé",
      "successCount": "{n} lignes modifiées",
      "successDone": "Retour à la vue d'ensemble",
      "remoteFilesHeading": "Fichiers sur le serveur",
      "slotResolveHeading": "Résolution slot → fichier",
      "slotResolveNoPattern": "(aucun motif de correspondance défini ; le slot ne s'exécutera pas)",
      "slotResolveNoMatch": "(aucun fichier distant ne correspond)",
      "remoteFilesHint": "Contenu actuel de {path} sur le serveur FTP. La tâche d'import sélectionne le fichier le plus récent correspondant au motif de chaque slot.",
      "refreshRemote": "Actualiser",
      "remoteEmpty": "Aucun fichier dans le dossier distant configuré pour le moment.",
      "confirmCommit": "Appliquer définitivement"
    },
    "runs": {
      "heading": "Exécutions récentes",
      "intro": "Toutes les tentatives d'import — brouillons en cours, exécutions terminées et échecs éventuels.",
      "empty": "Aucune exécution pour ce tenant pour le moment.",
      "discard": "Abandonner",
      "confirmDiscard": "Abandonner cette exécution d'import ? Les fichiers téléversés et les lignes analysées seront supprimés. Les exécutions validées ne peuvent pas être abandonnées.",
      "unnamedMapping": "(mappage supprimé)",
      "rowsSummary": "+{created} nouveaux · ~{updated} mis à jour · {failed} en échec",
      "status": {
        "draft": "Brouillon",
        "dry_run": "Dry-run",
        "running": "En cours",
        "succeeded": "Réussie",
        "failed": "Échouée",
        "cancelled": "Annulée"
      }
    },
    "runDetail": {
      "title": "Exécution d'import",
      "source": "Source",
      "noSource": "(source inconnue)",
      "mapping": "Mappage",
      "actor": "Démarrée par",
      "noActor": "(automatique)",
      "startedAt": "Démarrée",
      "finishedAt": "Terminée",
      "duration": "Durée",
      "totalsHeading": "Totaux",
      "noChange": "Aucune modification",
      "slotsHeading": "Par fichier",
      "errorRowsHeading": "Lignes en erreur",
      "errorRowsHint": "Limité à 50 lignes pour le stockage. L'export Excel du dry-run contient la liste complète.",
      "noDetail": "Cette exécution a été créée par un ancien flux d'import qui n'enregistrait pas de résumé détaillé.",
      "failureTitle": "Exécution échouée — aucune modification n'a été enregistrée",
      "failureBody": "Le moteur a rencontré une erreur et a annulé l'intégralité de la transaction. Les données sont dans leur état d'avant l'exécution ; corrigez les fichiers d'entrée et lancez une nouvelle exécution."
    },
    "wizard": {
      "titleNew": "Nouvelle source d'import",
      "titleEdit": "Modifier la source d'import",
      "stepperLabel": "Étapes de l'assistant",
      "back": "Retour",
      "nextStep": "Suivant",
      "finish": "Terminer",
      "vendorDocsLink": "Documentation {vendor} →",
      "steps": {
        "type": "Type & nom",
        "connection": "Connexion",
        "mapping": "Mappage",
        "exclusions": "Exclusions",
        "schedule": "Planification"
      },
      "step1": {
        "heading": "Étape 1 — type & nom",
        "hint": "Choisissez comment ce tenant livre ses données. La phase 1 ne propose que le téléversement de fichiers ; FTP et API suivront.",
        "name": "Nom",
        "nameRequired": "Donnez à la source un nom reconnaissable.",
        "type": "Type de source",
        "types": {
          "csv_upload": "Téléversement CSV",
          "csv_uploadHint": "L'équipe d'implémentation téléverse le ou les fichiers manuellement à chaque fois.",
          "csv_sftp": "FTP / SFTP",
          "csv_sftpHint": "Les fichiers sont récupérés selon une planification depuis un serveur FTP, SFTP ou FTPS distant.",
          "api": "API",
          "comingSoon": "Bientôt disponible"
        },
        "vendorConfig": "Configuration {vendor}",
        "testVendorConn": "Tester la connexion",
        "testVendorOk": "La connexion fonctionne ! Slot « {slot} » testé, {n} enregistrement d'exemple récupéré.",
        "testVendorFail": "Échec de la connexion"
      },
      "fileBrowser": {
        "heading": "Parcourir les fichiers du serveur",
        "hint": "Cliquez sur un fichier pour l'utiliser comme exemple pour ce slot. Le nom du fichier devient aussi le motif de correspondance du slot pour les exécutions planifiées (le fichier correspondant le plus récent est choisi à chaque exécution).",
        "empty": "Aucun fichier CSV / TXT / TSV dans le dossier distant configuré."
      },
      "connection": {
        "heading": "Détails de la connexion",
        "hint": "Où la tâche d'import doit récupérer les fichiers. Choisissez le protocole pris en charge par votre système RH ; le reste du formulaire s'adapte à ce choix.",
        "protocol": "Protocole",
        "protocols": {
          "sftp": "SFTP (SSH)",
          "ftp": "FTP (non chiffré)",
          "ftps_explicit": "FTPS — TLS explicite (port 21)",
          "ftps_implicit": "FTPS — TLS implicite (port 990)"
        },
        "host": "Hôte",
        "port": "Port",
        "portHint": "Laissez vide pour utiliser le port par défaut du protocole (22 pour SFTP, 21 pour FTP/FTPS explicite, 990 pour FTPS implicite).",
        "remotePath": "Dossier distant",
        "remotePathHint": "Où l'import cherchera les fichiers. Par défaut, le répertoire personnel du serveur.",
        "username": "Nom d'utilisateur",
        "password": "Mot de passe",
        "passwordSftpHint": "Facultatif pour SFTP — laissez vide si vous utilisez une authentification par clé.",
        "passwordFtpHint": "Requis pour FTP / FTPS.",
        "passwordSavedPlaceholder": "(enregistré — laissez vide pour conserver)",
        "privateKey": "Clé privée SSH",
        "privateKeyHint": "Choisissez le fichier .pem / .key. Nous lisons uniquement son contenu texte ; le fichier lui-même n'est jamais téléversé tel quel. Chiffré au repos.",
        "privateKeyLoaded": "Clé chargée — enregistrée à l'étape suivante.",
        "privateKeyAlreadySaved": "(enregistrée — choisissez un nouveau fichier pour la remplacer)",
        "passphrase": "Phrase secrète de la clé",
        "passphraseHint": "Ne remplissez ceci que si le fichier de clé SSH est lui-même chiffré avec une phrase secrète.",
        "passphraseSavedPlaceholder": "(enregistrée — laissez vide pour conserver)",
        "hostFingerprint": "Empreinte de l'hôte (facultatif)",
        "hostFingerprintHint": "Empreinte SHA-256 de la clé publique d'hôte du serveur. Si renseignée, nous refusons la connexion en cas de non-correspondance — utile comme protection MITM pour les planifications de longue durée.",
        "testButton": "Tester la connexion",
        "testNeedsSave": "Enregistrez d'abord la connexion, puis testez.",
        "testSuccess": "Connecté — {n} fichier(s) trouvé(s) dans le dossier distant.",
        "testFailure": "Échec de la connexion"
      },
      "step2": {
        "heading": "Étape 2 — mappage",
        "hint": "Par fichier : téléversez un CSV pour voir cinq lignes d'exemple, puis reliez chaque colonne à un champ de la plateforme. Une même ligne peut produire un utilisateur PLUS une ou plusieurs unités à n'importe quel niveau organisationnel — choisissez la bonne cible par colonne.",
        "hintVendor": "Par endpoint : récupérez un exemple auprès du fournisseur pour voir cinq enregistrements d'exemple, puis reliez chaque champ à un champ de la plateforme. Une même ligne peut produire un utilisateur PLUS une ou plusieurs unités à n'importe quel niveau organisationnel — choisissez la bonne cible par colonne.",
        "addFile": "Ajouter un fichier",
        "addEndpoint": "Ajouter un endpoint",
        "empty": "Aucun fichier configuré pour le moment. Cliquez sur « Ajouter un fichier » pour commencer.",
        "slotLabel": "Fichier {n}",
        "slotName": "Nom du slot",
        "matchFilename": "Correspondance de nom de fichier (facultatif)",
        "hasHeaderRow": "La première ligne contient les titres de colonnes",
        "uploadSample": "Téléverser un CSV d'exemple",
        "replaceSample": "Remplacer l'exemple",
        "pickServerFile": "Choisir un fichier sur le serveur",
        "replaceServerFile": "Remplacer le fichier du serveur",
        "fetchVendorSample": "Récupérer un exemple auprès du fournisseur",
        "refreshVendorSample": "Actualiser l'exemple fournisseur",
        "slotNameNeededForSample": "Choisissez d'abord un slot pour que nous sachions quel endpoint du fournisseur interroger.",
        "pickVendorSlot": "— choisissez un endpoint —",
        "slotLabelInput": "Label (facultatif)",
        "slotLabelInputHint": "Un nom convivial affiché dans les rapports d'exécution et les tableaux de bord. Laissez vide pour utiliser la clé de l'endpoint.",
        "slotLabelPlaceholder": "Employés — Siège",
        "serverFileSampleNeeded": "pas encore d'aperçu — choisissez à nouveau le fichier pour actualiser",
        "rowCount": "({n} lignes)",
        "sampleHeading": "Aperçu de l'exemple (5 lignes réparties dans le fichier)",
        "mapHeading": "Mappage des colonnes",
        "mapHint": "Choisissez quel champ de la plateforme chaque colonne CSV alimente. Laissez sur « Ignorer » si une colonne ne doit pas être importée. Plusieurs colonnes peuvent cibler des entités différentes (p. ex. champs utilisateur + champs de service + champs de fonction dans la même ligne).",
        "mapWithoutSampleHint": "Téléversez à nouveau le CSV pour voir les lignes d'exemple. Le mappage ci-dessous a été enregistré précédemment et reste appliqué.",
        "skipColumn": "Ignorer cette colonne",
        "groupUser": "Utilisateur",
        "groupOrgUnit": "Unité organisationnelle : {level}",
        "fields": {
          "external_id": "ID externe",
          "name": "Nom complet",
          "first_name": "Prénom",
          "last_name": "Nom de famille",
          "email": "E-mail",
          "locale": "Langue",
          "status": "Statut",
          "parent_external_id": "Parent (ID externe)",
          "parent_external_id_named": "Parent {parent} (ID externe)",
          "parent_same_level_external_id": "{level} parent au même niveau (ID externe)",
          "user_unit_link": "Lien vers {level} (par ID externe)"
        },
        "transformLabel": "Normaliser",
        "transforms": {
          "none": "Aucune (valeur brute)",
          "trim": "Supprimer les espaces superflus",
          "digits_only": "Chiffres uniquement (310.031.100.010 → 310031100010)",
          "strip_dots": "Supprimer les points (1.234 → 1234)",
          "lowercase": "Minuscules",
          "uppercase": "Majuscules"
        },
        "prefixLabel": "Préfixe",
        "prefixPlaceholder": "texte littéral ou un modèle",
        "idHint": "Les colonnes d'identifiants peuvent être normalisées + préfixées avant la mise en correspondance. Un modèle de préfixe peut reprendre d'autres cellules de la même ligne en plaçant le titre de la colonne entre accolades. Configurez les deux côtés d'un lien inter-fichiers avec le même préfixe + la même normalisation — sinon le moteur les traite comme des identifiants différents."
      },
      "exclusions": {
        "heading": "Exclusions",
        "hint": "Utilisateurs + unités à ignorer même lorsqu'ils figurent dans les fichiers sources. Les identifiants sont comparés à la valeur FINALE après préfixe/normalisation écrite par le moteur (c.-à-d. le même ID que vous voyez sur la plateforme). Une entrée par ligne.",
        "unitsLabel": "Unités à exclure — {level}",
        "unitsHint": "ID externes des unités de ce niveau à ignorer. Un utilisateur sans lien restant à ce niveau est également exclu.",
        "unitsPlaceholder": "4587\n9999",
        "userIdsLabel": "Utilisateurs à exclure — par ID externe",
        "userIdsHint": "Correspondance exacte avec l'external_id préfixé.",
        "userIdsPlaceholder": "afas:12345",
        "emailsLabel": "Utilisateurs à exclure — par e-mail",
        "emailsHint": "Correspondance exacte, insensible à la casse. Utilisez un * en tête pour une règle de domaine, p. ex. *@oudbedrijf.nl",
        "emailsPlaceholder": "foo@old.nl\n*@oudbedrijf.nl"
      },
      "step3": {
        "heading": "Étape 3 — planification",
        "hint": "Quand cette source doit démarrer automatiquement. Les sources de la phase 1 ne s'exécutent que si la planification est active ET qu'au moins un horaire est défini.",
        "uploadHint": "Une source basée sur le téléversement ne s'exécute que lorsque l'équipe d'implémentation téléverse manuellement le ou les fichiers et déclenche l'exécution — il n'y a pas de planification automatique. Lancez les dry-runs et les validations via la page « Exécuter » de la source.",
        "activate": "La source est active",
        "timesHeading": "Horaires d'exécution quotidiens",
        "timesHint": "Ajoutez autant d'horaires que nécessaire — la source s'exécute chaque jour à chacun d'eux.",
        "noTimes": "Aucun horaire pour le moment. Cliquez ci-dessous pour en ajouter un.",
        "addTime": "Ajouter un horaire"
      }
    },
    "editor": {
      "newTitle": "Nouveau mappage",
      "editTitle": "Modifier le mappage",
      "intro": "Un mappage est une liste de slots. Chaque slot correspond à une forme de fichier CSV (p. ex. « users.csv ») et indique à l'importateur quelle colonne est mappée sur quel champ de la plateforme.",
      "name": "Nom",
      "description": "Description",
      "slotsHeading": "Slots",
      "slotsIntro": "Ajoutez un slot par forme de fichier CSV. Déposez un CSV d'exemple pour détecter automatiquement les en-têtes — vérifiez les correspondances et ajustez.",
      "addUserSlot": "Slot utilisateurs",
      "addOrgUnitSlot": "Slot unités organisationnelles",
      "noSlots": "Aucun slot pour le moment. Ajoutez un slot utilisateurs ou unités organisationnelles pour commencer le mappage.",
      "slotLabel": "Slot {n}",
      "slotName": "Nom du slot",
      "targetUser": "utilisateurs",
      "targetOrgUnit": "unités organisationnelles",
      "targetLevelKey": "Niveau organisationnel",
      "targetLevelKeyHint": "À quelle catégorie de la structure organisationnelle ces lignes appartiennent.",
      "pickLevel": "— choisissez une catégorie —",
      "matchFilename": "Correspondance de nom de fichier (facultatif)",
      "matchFilenameHint": "Utilisé lors du téléversement pour sélectionner automatiquement ce slot lorsque l'utilisateur dépose un fichier portant ce nom.",
      "sampleDrop": "Déposez un CSV d'exemple ici, ou cliquez pour parcourir.",
      "sampleReplace": "Remplacer le CSV d'exemple",
      "sampleLoaded": "{n} colonnes + {rows} ligne(s) d'exemple. L'exemple n'est pas conservé — il sert uniquement à suggérer des mappages.",
      "sampleParseError": "Impossible de lire le fichier comme CSV. Essayez de l'enregistrer en UTF-8 avec des virgules ou des points-virgules comme séparateurs.",
      "columnsHeading": "Colonnes",
      "columnsHint": "Choisissez quelle colonne CSV alimente chaque champ de la plateforme. Les champs obligatoires sont marqués d'un *.",
      "pickColumn": "choisissez une colonne",
      "columnHeaderPlaceholder": "Saisissez le nom de l'en-tête CSV",
      "field": {
        "external_id": "ID externe",
        "email": "E-mail",
        "name": "Nom",
        "locale": "Langue",
        "status": "Statut",
        "parent_external_id": "Parent (ID externe)"
      },
      "unitAssignmentsHeading": "Affectations d'unités",
      "unitAssignmentsHint": "Par catégorie : quelle colonne CSV indique à l'importateur à quelle unité cet utilisateur appartient.",
      "addUnitAssignment": "Ajouter une affectation",
      "via": {
        "external_id": "par ID externe",
        "email": "par e-mail",
        "name": "par nom"
      },
      "previewHeading": "Aperçu de l'exemple ({n} ligne(s))",
      "strategyHeading": "Stratégie",
      "strategyHint": "Utilisez « enrichir » lorsque ce CSV contient des champs supplémentaires pour des utilisateurs ou des unités créés par un autre slot — p. ex. assignments.csv avec l'équipe et la fonction pour des utilisateurs issus de users.csv.",
      "strategy": {
        "createOrUpdate": "Créer ou mettre à jour — correspondance sur la clé d'identification, création lorsqu'aucune correspondance n'est trouvée.",
        "enrich": "Enrichir l'existant uniquement — correspondance via la colonne de jointure ci-dessous ; les lignes sans correspondance deviennent des erreurs dans le dry-run."
      },
      "joinOnHint": "Quelle colonne CSV contient la clé de recherche, et avec quel champ de la plateforme elle doit correspondre.",
      "joinOnFrom": "Colonne de jointure (ce fichier)",
      "joinOnVia": "Correspondre à"
    }
  },
  "locations": {
    "heading": "Lieux de formation",
    "intro": "Gérez les lieux de formation qui peuvent être choisis par jour lors de la planification d'une session.",
    "new": "Nouveau lieu de formation",
    "empty": "Aucun lieu de formation pour le moment. Ajoutez-en un pour pouvoir le choisir lors de la planification.",
    "editTitle": "Modifier le lieu de formation",
    "active": "Actif",
    "inactive": "Inactif",
    "confirmDelete": "Supprimer le lieu de formation ?",
    "confirmDeleteBody": "Voulez-vous vraiment supprimer « {name} » ? Les sessions qui utilisaient ce lieu de formation conservent leur lieu en texte libre.",
    "cols": {
      "name": "Nom",
      "city": "Ville",
      "capacity": "Capacité",
      "position": "Ordre",
      "active": "Actif",
      "kind": "Type"
    },
    "fields": {
      "name": "Nom",
      "city": "Ville",
      "address": "Adresse",
      "capacity": "Capacité",
      "capacityHint": "Capacité physique de la salle (informatif). Vide = inconnue.",
      "position": "Ordre",
      "positionHint": "Plus bas = plus haut dans la liste.",
      "active": "Actif (sélectionnable lors de la planification)",
      "isExternal": "Lieu de formation externe (fourni par un tiers)"
    },
    "internal": "Interne",
    "external": "Externe"
  },
  "externalPeople": {
    "heading": "Personnes externes",
    "intro": "Gérez les personnes externes (sans compte) que vous pouvez choisir comme formateur lors de la planification.",
    "new": "Nouvelle personne externe",
    "empty": "Il n'y a pas encore de personnes externes. Ajoutez-en une pour pouvoir la choisir comme formateur lors de la planification.",
    "editTitle": "Modifier la personne externe",
    "active": "Actif",
    "inactive": "Inactif",
    "confirmDelete": "Supprimer la personne externe ?",
    "confirmDeleteBody": "Voulez-vous vraiment supprimer « {name} » ? Vous ne pourrez plus choisir cette personne comme formateur. Les sessions dont elle est déjà le formateur la conservent comme formateur.",
    "cols": {
      "name": "Nom",
      "email": "E-mail",
      "position": "Ordre",
      "active": "Actif",
      "company": "Entreprise",
      "deletedAt": "Supprimée le"
    },
    "tabs": {
      "current": "Actuelles",
      "deleted": "Supprimées"
    },
    "deleted": {
      "intro": "Les personnes externes supprimées n’apparaissent plus dans la liste ni dans le choix du formateur, mais leur nom, leur adresse e-mail et leur remarque sont toujours enregistrés. Si vous recevez une demande d’effacement, effacez-les ici.",
      "empty": "Aucune personne externe supprimée n’est en attente d’effacement."
    },
    "fields": {
      "name": "Nom",
      "email": "E-mail",
      "note": "Remarque",
      "position": "Ordre",
      "positionHint": "Plus bas = plus haut dans la liste.",
      "active": "Actif (sélectionnable comme formateur)",
      "company": "Entreprise externe / organisme de formation",
      "companyHint": "Facultatif. Vide = indépendant."
    },
    "noCompany": "Aucune entreprise (indépendant)",
    "erase": {
      "action": "Effacer",
      "actionLabel": "Effacer : {name}",
      "title": "Effacer la personne externe ?",
      "irreversible": "L’effacement est définitif. Vous ne pourrez pas l’annuler.",
      "body": "Le nom, l’adresse e-mail et la remarque de « {name} » seront définitivement supprimés, de même que ces données dans le journal. La personne disparaît de cette liste et ne peut plus être choisie comme formateur.",
      "history": "L’historique des formateurs est conservé : les sessions dont cette personne était le formateur gardent leur formateur et l’affichent désormais comme « Personne externe supprimée ».",
      "confirmLabel": "Saisissez « {name} » pour confirmer",
      "confirmHint": "Saisissez le nom exactement tel qu’il apparaît ci-dessus.",
      "submit": "Effacer définitivement",
      "done": "« {name} » a été effacé. Les sessions dont cette personne était le formateur affichent désormais « Personne externe supprimée »."
    }
  },
  "cancellationReasons": {
    "heading": "Motifs d'annulation",
    "intro": "Gérez les motifs parmi lesquels un apprenant peut choisir lors de l'annulation d'une inscription.",
    "new": "Nouveau motif",
    "empty": "Aucun motif d'annulation pour le moment. Ajoutez-en un pour l'afficher dans la liste de choix.",
    "editTitle": "Modifier le motif",
    "active": "Actif",
    "inactive": "Inactif",
    "confirmDelete": "Supprimer le motif ?",
    "confirmDeleteBody": "Voulez-vous vraiment supprimer « {label} » ? Les inscriptions déjà annulées conservent leur motif.",
    "cols": {
      "label": "Motif",
      "position": "Ordre",
      "active": "Actif"
    },
    "fields": {
      "label": "Motif",
      "position": "Ordre",
      "positionHint": "Plus bas = plus haut dans la liste.",
      "active": "Actif (visible par les apprenants)"
    }
  },
  "externalCompanies": {
    "heading": "Entreprises externes",
    "intro": "Gérez les entreprises externes (organismes de formation, fournisseurs). Marquez une entreprise comme organisme de formation afin de choisir d'abord l'organisme puis le formateur lors de la planification.",
    "new": "Nouvelle entreprise externe",
    "empty": "Aucune entreprise externe pour le moment. Ajoutez-en une pour commencer.",
    "editTitle": "Modifier l'entreprise externe",
    "active": "Actif",
    "inactive": "Inactif",
    "confirmDelete": "Supprimer l'entreprise externe ?",
    "confirmDeleteBody": "Voulez-vous vraiment supprimer « {name} » ? Les formateurs liés à cette entreprise redeviennent des indépendants.",
    "cols": {
      "name": "Nom",
      "email": "E-mail",
      "educator": "Organisme de formation",
      "position": "Ordre",
      "active": "Actif",
      "origin": "Origine"
    },
    "fields": {
      "name": "Nom",
      "email": "E-mail",
      "phone": "Téléphone",
      "note": "Remarque",
      "position": "Ordre",
      "positionHint": "Plus bas = plus haut dans la liste.",
      "isEducator": "Est un organisme de formation (apparaît dans le choix du formateur)",
      "active": "Actif (sélectionnable lors de la planification)"
    },
    "promote": "Ajouter à la liste gérée",
    "origin": {
      "admin": "Administrateur",
      "request": "Demande"
    },
    "suggestions": {
      "heading": "Cherchiez-vous peut-être l'une de ces entreprises ?",
      "hint": "L'entreprise figure-t-elle déjà ci-dessus ? Utilisez-la plutôt que d'en créer une seconde."
    }
  },
  "roles": {
    "heading": "Rôles et droits",
    "intro": "Un rôle est un ensemble de droits. Ce qu'une personne peut faire vient du rôle ; où elle peut le faire, vous le choisissez lors de l'attribution. Les rôles appartiennent à votre organisation : vous pouvez les modifier, les dupliquer et en créer.",
    "empty": "Il n'y a encore aucun rôle dans cet environnement.",
    "loading": "Chargement des rôles…",
    "loadError": "Les rôles n'ont pas pu être chargés.",
    "new": "+ Nouveau rôle",
    "column": {
      "role": "Rôle",
      "rank": "Rang",
      "origin": "Origine",
      "permissions": "Droits",
      "assigned": "Attribué à",
      "actions": "Actions"
    },
    "permissionCount": "{held} sur {total}",
    "origin": {
      "standard": "Standard",
      "standard_customised": "Standard · modifié",
      "self_made": "Créé par vous"
    },
    "action": {
      "view": "Consulter",
      "edit": "Modifier",
      "duplicate": "Dupliquer",
      "delete": "Supprimer"
    },
    "rankHint": "Nombre plus élevé = moins de pouvoir",
    "readOnlyBanner": "Ce rôle a le rang {rank}. Vous ne pouvez modifier que les rôles dont le nombre est supérieur à votre propre rang ({own}).",
    "readOnlyBannerNoRank": "Ce rôle a le rang {rank}. Vous n'avez vous-même aucun rôle avec un rang, vous ne pouvez donc pas modifier de rôles.",
    "rankRangeHint": "De {min} à {max}. Nombre plus élevé = moins de pouvoir",
    "rankFixedHint": "Le rang de ce rôle est fixe",
    "rankOutOfRange": "Choisissez un rang de {min} à {max}.",
    "newAtoms": {
      "title_one": "Un nouveau droit a été ajouté",
      "title_other": "{count} nouveaux droits ont été ajoutés",
      "body": "Ils ne sont attribués à aucun rôle. Les nouveaux droits ne sont jamais activés automatiquement.",
      "show": "Voir les nouveautés"
    },
    "delete": {
      "title": "Supprimer le rôle ?",
      "body": "Le rôle {label} sera supprimé. Les attributions de ce rôle disparaissent avec lui.",
      "confirm": "Supprimer",
      "inUse": "Ce rôle est utilisé par un circuit de validation et ne peut pas être supprimé : {flows}"
    },
    "builder": {
      "newHeading": "Nouveau rôle",
      "name": "Nom du rôle",
      "nameHint": "Ce que voient les utilisateurs. Modifiable par langue ; la clé interne ne change pas.",
      "otherLanguages": "Autres langues",
      "rank": "Rang",
      "search": "Rechercher un droit…",
      "onlyEnabled": "Uniquement ce qui est activé",
      "expandAll": "Tout déplier",
      "collapseAll": "Tout replier",
      "moduleCount": "{held} sur {total}",
      "summary": "Ce que vous modifiez",
      "summaryOn": "Droits activés",
      "summaryRequired": "Ajouté comme prérequis",
      "summaryUnavailable": "Non disponible pour vous",
      "summaryPeople": "Personnes avec ce rôle",
      "lockedBy": "Accompagne : {atoms}",
      "notYours": "Vous ne détenez pas ce droit vous-même, vous ne pouvez donc pas l'attribuer.",
      "dangerous": "Dangereux",
      "indispensable": "Indispensable",
      "impact_one": "Cette modification concerne {count} personne.",
      "impact_other": "Cette modification concerne {count} personnes.",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "saving": "Enregistrement…",
      "saved": "Le rôle a été enregistré.",
      "templateDiff_one": "Il y a {count} droit du standard que ce rôle n'a pas encore.",
      "templateDiff_other": "Il y a {count} droits du standard que ce rôle n'a pas encore.",
      "addFromTemplate": "Ajouter",
      "viewPeople_one": "Voir la personne ayant ce rôle",
      "viewPeople_other": "Voir les {count} personnes ayant ce rôle"
    },
    "confirm": {
      "title": "Êtes-vous sûr ?",
      "added": "Droits ajoutés",
      "removed": "Droits retirés",
      "dangerousAdded_one": "{count} est dangereux",
      "dangerousAdded_other": "{count} sont dangereux",
      "impact_one": "Cela concerne {count} personne avec ce rôle.",
      "impact_other": "Cela concerne {count} personnes avec ce rôle.",
      "nothing": "Rien ne change au niveau des droits.",
      "confirm": "Enregistrer",
      "back": "Retour"
    },
    "count_one": "{count} rôle",
    "count_other": "{count} rôles"
  },
  "roleAssignment": {
    "heading": "Attribuer un rôle à {name}",
    "userLoadError": "Cet utilisateur n'a pas pu être chargé.",
    "intro": "Ce qu'une personne peut faire découle du rôle. Où cela s'applique, vous le choisissez ici.",
    "backToProfile": "← Retour au profil",
    "revoke": "Retirer",
    "includeSubtree": "Y compris les unités en dessous",
    "subtreeHint": "Sans cette option, le rôle ne s'applique qu'à l'unité choisie elle-même.",
    "pickRole": "Choisir un rôle",
    "pickOrgUnit": "Rechercher une unité",
    "current": {
      "heading": "Rôles actuels",
      "empty": "Cet utilisateur n'a pas encore de rôle.",
      "loadError": "Les rôles de cet utilisateur n'ont pas pu être chargés."
    },
    "add": {
      "heading": "Attribuer un rôle",
      "submit": "Attribuer"
    },
    "fields": {
      "role": "Rôle",
      "scope": "Où ce rôle s'applique-t-il ?",
      "orgUnit": "Unité organisationnelle"
    },
    "blocked": {
      "rank": "vous ne pouvez pas attribuer ce rôle",
      "delta": "vous ne détenez pas : {atoms}"
    },
    "scopeOption": {
      "tenant_wide": "L'environnement entier",
      "org_unit": "Une unité organisationnelle",
      "ownership": "Uniquement ce qui est lié à cette personne",
      "direct_reports": "Uniquement les collaborateurs directs de cette personne"
    },
    "scopeHint": {
      "tenant_wide": "Le rôle s'applique partout dans cet environnement.",
      "org_unit": "Le rôle s'applique au sein de l'unité choisie.",
      "ownership": "Le rôle s'applique à ce qui est lié à cette personne — par exemple les cours dont elle est responsable du contenu, ou les sessions qu'elle anime.",
      "direct_reports": "Le rôle ne s'applique qu'aux personnes dont cette personne est le responsable hiérarchique. Si personne n'a défini cette personne comme responsable, elle ne voit personne. Les sessions et le catalogue ne sont pas couverts par ce périmètre : un responsable travaille dans Mon équipe, dans l'application."
    },
    "scope": {
      "tenant_wide": "L'environnement entier",
      "ownership": "Uniquement ce qui est lié à cette personne",
      "direct_reports": "Uniquement les collaborateurs directs de cette personne",
      "orgUnitWithSubtree": "{unit} et tout ce qui se trouve en dessous",
      "orgUnitOnly": "{unit} uniquement"
    },
    "preview": {
      "heading": "Ce que cela couvre",
      "pickRoleFirst": "Choisissez d'abord un rôle — sans rôle, il n'y a rien à calculer.",
      "calculating": "Calcul en cours…",
      "failed": "Le calcul a échoué. Vous pouvez tout de même enregistrer ; il vous manque seulement l'aperçu.",
      "tenantWide": "Ce rôle s'applique partout dans cet environnement.",
      "ownership": "Aujourd'hui, cela signifie : les cours dont cette personne est responsable · les sessions qu'elle anime · ses propres inscriptions · son propre profil.",
      "directReports": "Aujourd'hui, cela signifie : les utilisateurs, inscriptions, participations et qualifications des personnes que cette personne encadre directement. Pas leurs responsables, ni les sessions ni le catalogue.",
      "units_one": "{count} unité organisationnelle",
      "units_other": "{count} unités organisationnelles",
      "people_one": "{count} personne relève de ce périmètre",
      "people_other": "{count} personnes relèvent de ce périmètre",
      "widerThanChosen": "Attention : vous avez choisi une unité, mais avec les unités en dessous cela en couvre davantage."
    }
  },
  "effectiveAccess": {
    "heading": "Ce que cette personne peut faire",
    "heldCount_one": "{count} droit sur {total}",
    "heldCount_other": "{count} droits sur {total}",
    "search": "Rechercher dans les droits",
    "searchPlaceholder": "Par exemple : inscription",
    "showUnheld": "Afficher aussi ce que cette personne ne peut pas faire",
    "noMatch": "Aucun droit ne correspond.",
    "moduleCount": "{count} sur {total}",
    "dangerous": "Dangereux",
    "notHeld": "Cette personne ne l'a pas.",
    "via": "via {role} — {scope} — {surface}",
    "impliedBy": "(est venu avec {atom})",
    "surface": {
      "app": "compte dans l'application",
      "manage": "compte dans la console d'administration"
    }
  },
  "attendance": {
    "title": "Présence",
    "myTeaching": "Mes sessions",
    "myTeachingEmpty": "Vous n'êtes encore associé à aucune session en tant que formateur.",
    "openBadge": "Présence à compléter",
    "participant": "Participant",
    "day": "Jour",
    "save": "Enregistrer la présence",
    "saved": "Présence enregistrée.",
    "noParticipants": "Personne n'occupe encore une place sur cette session.",
    "noDays": "Aucune journée n'est encore planifiée pour cette session.",
    "status": {
      "not_recorded": "Pas encore enregistré",
      "present": "Présent",
      "absent": "Absent",
      "excused": "Absent avec motif",
      "substituted": "Remplacé"
    },
    "completion": {
      "label": "Terminé",
      "true": "Oui",
      "false": "Non",
      "null": "Impossible de se prononcer",
      "explainNull": "Au moins une journée n'est pas encore enregistrée, aucune conclusion n'est donc possible."
    },
    "loadError": "La présence n'a pas pu être chargée.",
    "saveError": "La présence n'a pas pu être enregistrée.",
    "closeOut": {
      "action": "Clôturer la session",
      "achievedOn": "Obtenu le",
      "achievedOnHint": "Aujourd'hui par défaut. Pas dans le futur, ni avant une clôture antérieure du même participant pour cette activité.",
      "achievedOnInFuture": "La date d'obtention ne peut pas être dans le futur.",
      "outcome": "Résultat",
      "outcomeFor": "Résultat pour {name}",
      "skip": "Ignorer",
      "passed": "Réussi",
      "failed": "Non réussi",
      "reason": "Motif de l'écart",
      "reasonHint": "Ce résultat diffère de ce que dit la présence. Le motif est enregistré à côté.",
      "reasonRequired": "Il reste un écart sans motif. Renseignez-le avant de clôturer.",
      "needsForce": "Une journée est encore ouverte, il n'y a donc rien à en déduire. Seule une personne disposant du droit de forcer peut définir un résultat ici.",
      "notOpen": "Impossible à clôturer",
      "notOpenExplain": "Cette inscription n'est plus en cours. Elle figure encore dans la liste parce que de la présence y a été enregistrée.",
      "alreadyDone": "Déjà clôturé",
      "alreadyDoneOn": "Clôturé le {date}",
      "wasDeviation": "Écart par rapport à la présence",
      "confirmTitle": "Clôturer cette session ?",
      "confirmBody": "{finalized} participants reçoivent un résultat maintenant ; {skipped} sont ignorés et pourront être clôturés plus tard.",
      "confirmTerminal": "La session passera ensuite au statut clôturé. Cette action est irréversible.",
      "done": "Session clôturée. {finalized} participants clôturés, {skipped} ignorés.",
      "error": "La session n'a pas pu être clôturée.",
      "withdraw": "Retirer",
      "withdrawTitle": "Retirer la clôture de {name}",
      "withdrawExplain": "La clôture est conservée, avec la personne qui l'a enregistrée et le motif du retrait — elle ne compte simplement plus nulle part. Le champ se réouvre ensuite, afin que vous puissiez clôturer à nouveau.",
      "withdrawReason": "Pourquoi retirez-vous cette clôture ?",
      "withdrawReasonHint": "Plus tard, ce sera la seule explication disponible.",
      "withdrawError": "Le retrait a échoué. Réessayez ou actualisez la page.",
      "withdrawKind": "Qu'est-ce qui s'applique à partir de maintenant ?",
      "withdrawKindPlaceholder": "Faites un choix",
      "withdrawKindFromNow": "Il l'avait — plus à partir de maintenant",
      "withdrawKindNeverValid": "Le résultat était erroné — il ne l'a jamais eu",
      "withdrawKindHint": "Cela détermine à quoi ressemble un rapport portant sur une période antérieure. La première option laisse cet historique intact ; la seconde indique qu'un rapport antérieur était erroné."
    },
    "cellLabel": "{name} le {day} — {status}",
    "notes": {
      "column": "Notes",
      "title": "Notes sur {name}",
      "open": "Notes sur {name} ({count})",
      "empty": "Rien n'a encore été noté sur ce participant.",
      "new": "Nouvelle note",
      "newHint": "Vous seul voyez ceci, sauf si vous le partagez ci-dessous.",
      "add": "Enregistrer la note",
      "share": "Visible par le manager de ce participant",
      "sharedMarker": "partagé avec le manager",
      "by": "{author} — {date}",
      "unknownAuthor": "Inconnu",
      "error": "La note n'a pas pu être enregistrée.",
      "delete": "Supprimer",
      "edit": "Modifier la note",
      "editAction": "Modifier",
      "editedMarker": "modifiée"
    },
    "showCancelled": "Afficher aussi {count} participant(s) annulé(s)",
    "markAllPresent": "Tous présents",
    "markAllRow": "Journée entière",
    "external": {
      "column": "Test externe",
      "choose": "Résultat du test externe pour {participant}",
      "placeholder": "Résultat",
      "record": "Enregistrer",
      "error": "Le résultat n’a pas pu être enregistré.",
      "outcome": {
        "passed": "Réussi",
        "not_passed": "Non réussi"
      },
      "resultLabel": "Résultat de la partie externe pour {participant} (pourcentage ou note)",
      "resultPlaceholder": "p. ex. 72 % ou 14/20"
    }
  },
  "accessGroups": {
    "heading": "Groupes d’accès",
    "lead": "Une seule description de qui, utilisable à plusieurs endroits. Un groupe décrit des personnes par des règles — et non par une liste de noms — il reste donc juste quand quelqu’un change de service.",
    "new": "Nouveau groupe d’accès",
    "empty": "Il n’y a pas encore de groupes d’accès. Créez-en un dès qu’une activité d’apprentissage doit s’adresser à un groupe particulier.",
    "loadError": "Nous n’avons pas pu charger les groupes d’accès.",
    "backToList": "Retour à la vue d’ensemble",
    "memberCount": "{count} personnes",
    "showOnChart": "Afficher sur l’organigramme où se trouvent ces personnes",
    "usedByCount": "utilisé par {count} activités d’apprentissage",
    "usage": {
      "title": "Utilisé par {count} formation(s)",
      "nowhere": "Ce groupe n’est utilisé nulle part.",
      "hidden": "Et {count} formation(s) que vous n’êtes pas autorisé à voir.",
      "unavailable": "Impossible de charger les endroits où ce groupe est utilisé."
    },
    "impact": {
      "title": "Qu’est-ce qui change ?",
      "lead": "Ce groupe détermine la visibilité de {count} formation(s). Votre modification s’y applique immédiatement.",
      "gaining": "{count} personne(s) obtiendront un accès qu’elles n’ont pas aujourd’hui.",
      "losing": "{count} personne(s) perdront un accès qu’elles ont aujourd’hui.",
      "nobodyChanges": "Rien ne change pour personne : le groupe couvre les mêmes personnes.",
      "totals": "{current} membre(s) actuellement, {proposed} après enregistrement.",
      "confirm": "Enregistrer quand même",
      "unavailable": "Impossible de calculer ce que cette modification implique. Veuillez réessayer."
    },
    "columns": {
      "name": "Nom",
      "members": "Taille",
      "usedBy": "Utilisé par"
    },
    "fields": {
      "name": "Nom",
      "description": "Description"
    },
    "branch": {
      "include": "Qui en fait partie",
      "includeHint": "Toute personne correspondant à l’un de ces groupes en fait partie.",
      "exclude": "Qui en est exclu",
      "excludeHint": "L’exclusion l’emporte : qui correspond à ceci est exclu, même s’il convient ci-dessus."
    },
    "addGroup": "Ajouter un groupe",
    "removeGroup": "Supprimer le groupe",
    "noGroups": "Pas encore de groupes.",
    "allOf": "Correspond à tout ce qui suit",
    "and": "et",
    "or": "ou",
    "emptyGroupMatchesNobody": "Ce groupe n’a encore aucune condition et ne comprend donc personne.",
    "addCondition": "Ajouter une condition",
    "removeCondition": "Supprimer",
    "chooseKind": "Choisissez un type…",
    "choose": "Choisir…",
    "searchPerson": "Rechercher une personne…",
    "includeSubtree": "Y compris les unités en dessous",
    "unitWithSubtree": "{name} (et tout ce qui en dépend)",
    "unitOnly": "{name} uniquement",
    "unknownReference": "inconnu",
    "atom": {
      "org_unit": "Unité organisationnelle",
      "user": "Personne",
      "role": "Rôle"
    },
    "plain": {
      "label": "En langage courant :",
      "nobody": "Personne — il n’y a pas encore la moindre condition à remplir.",
      "except": "sauf"
    },
    "broken": {
      "badge": "Cassé",
      "notice": "Ce groupe fait référence à quelque chose qui n’existe plus ({count} référence(s)). Tant que c’est le cas, le groupe n’inclut personne — pas même via une règle d’exclusion. Supprimez la référence ou choisissez autre chose."
    },
    "references": {
      "title": "Cela figure dans des groupes d’accès",
      "lead": "Si vous le supprimez, ces groupes sont cassés : ils n’incluent plus personne tant que vous ne les réparez pas.",
      "excluding": "(exclut)"
    }
  },
  "ltiProviders": {
    "heading": "Connexions LTI",
    "intro": "Fournisseurs que vous pouvez relier à votre catalogue via LTI 1.1 ou 1.3. Vous en enregistrez un ici une seule fois ; ensuite vous le choisissez sur une activité d'apprentissage.",
    "new": "Ajouter un fournisseur",
    "editTitle": "Modifier le fournisseur",
    "empty": "Aucun fournisseur n'est encore enregistré.",
    "active": "Actif",
    "inactive": "Inactif",
    "secretSet": "Défini",
    "secretUnset": "Non défini",
    "confirmDelete": "Supprimer le fournisseur",
    "confirmDeleteBody": "Voulez-vous vraiment supprimer {name} ?",
    "confirmDeleteUnknown": "Les formations qui utilisent ce fournisseur sont archivées — elles disparaissent du catalogue, mais les résultats déjà obtenus sont conservés.",
    "confirmDeleteNone": "Aucune formation n’utilise ce fournisseur.",
    "confirmDeleteAffected_one": "Une formation sera archivée — elle disparaît du catalogue, mais les résultats déjà obtenus sont conservés.",
    "confirmDeleteAffected_other": "{count} formations seront archivées — elles disparaissent du catalogue, mais les résultats déjà obtenus sont conservés.",
    "confirmDeleteRest_one": "et une autre",
    "confirmDeleteRest_other": "et {count} autres",
    "cols": {
      "name": "Nom",
      "issuer": "Émetteur",
      "clientId": "Identifiant client",
      "secret": "Secret",
      "active": "Actif"
    },
    "fields": {
      "name": "Nom",
      "issuer": "Émetteur (issuer)",
      "issuerHint": "L'adresse que le fournisseur indique comme issuer, par exemple https://lti.exemple.fr",
      "clientId": "Identifiant client",
      "deploymentId": "Identifiant de déploiement",
      "authLoginUrl": "Adresse de connexion (OIDC)",
      "redirectUris": "Adresses de redirection",
      "redirectUrisHint": "Une adresse par ligne. C'est là que le système envoie le lancement signé ; les adresses absentes de cette liste sont refusées.",
      "jwksUrl": "Adresse JWKS",
      "jwksUrlHint": "C'est là que le système récupère les clés publiques du fournisseur. Une adresse de notre propre réseau est refusée.",
      "supportsDeepLinking": "Vous pouvez choisir un cours chez ce fournisseur",
      "supportsDeepLinkingHint": "Lorsque cette option est activée, une formation affiche le bouton « Choisir un cours » qui vous emmène chez le fournisseur pour le sélectionner. Nous ne pouvons pas déterminer nous-mêmes si un fournisseur le prend en charge — renseignez-vous auprès de lui en cas de doute. Lorsqu'elle est désactivée, vous saisissez l'adresse du cours manuellement.",
      "version": "Version LTI",
      "version13": "LTI 1.3 (recommandé)",
      "version11": "LTI 1.1",
      "consumerKey": "Clé (consumer key)",
      "consumerKeyHint": "La clé que le fournisseur vous a communiquée. Saisissez le mot de passe correspondant ci-dessous.",
      "clientSecret": "Secret client",
      "clientSecretHint": "Stocké chiffré et plus jamais affiché.",
      "clientSecretKeepHint": "Laissez vide pour conserver le secret enregistré. Saisissez une valeur pour le remplacer.",
      "active": "Actif"
    }
  },
  "digestSettings": {
    "heading": "E-mail récapitulatif",
    "intro": "Les notifications qui ne nécessitent pas leur propre message sont regroupées dans un e-mail périodique par destinataire. Définissez ici quand il part ; les notifications qui y figurent se choisissent par workflow.",
    "enabled": "Envoyer l’e-mail récapitulatif",
    "enabledHint": "Tant que ceci est désactivé, les notifications regroupées attendent et rien ne part. Rien n’est supprimé — réactivez-le et tout sera tout de même envoyé.",
    "willFallSilent_one": "Il y a {count} notification qui passe par l’e-mail récapitulatif. Elle reste muette tant que ceci est désactivé.",
    "willFallSilent_other": "Il y a {count} notifications qui passent par l’e-mail récapitulatif. Elles restent muettes tant que ceci est désactivé.",
    "frequencyLabel": "À quelle fréquence",
    "frequency": {
      "daily": "Chaque jour",
      "weekly": "Chaque semaine"
    },
    "weekdayLabel": "Quel jour",
    "timeLabel": "À quelle heure",
    "timeHint": "Dans le fuseau horaire de votre organisation. L’e-mail part par blocs de quinze minutes ; choisissez donc une heure à :00, :15, :30 ou :45.",
    "saved": "Les paramètres ont été enregistrés.",
    "saveFailed": "L’enregistrement a échoué."
  },
  "combobox": {
    "noResults": "Aucun résultat.",
    "loading": "Chargement…"
  },
  "aurora": {
    "modalClose": "Fermer",
    "alertDismiss": "Fermer le message",
    "passwordShow": "Afficher le mot de passe",
    "passwordHide": "Masquer le mot de passe",
    "comboboxRemove": "Retirer {label}"
  },
  "returnTrail": {
    "afterSave": {
      "form": "Après l’enregistrement, ceci est ajouté à la fin du formulaire « {title} » et vous y retournez.",
      "form_test": "Après l’enregistrement, ceci est ajouté à la fin du test « {title} » et vous y retournez.",
      "category": "Après l’enregistrement, ceci est ajouté à la fin de la catégorie « {title} » et vous y retournez."
    },
    "fromParent": {
      "form": "Vous travaillez ici à partir du formulaire « {title} ».",
      "form_test": "Vous travaillez ici depuis le test « {title} ».",
      "category": "Vous travaillez ici à partir de la catégorie « {title} »."
    },
    "back": {
      "form": "Retour au formulaire",
      "form_test": "Retour au test",
      "category": "Retour à la catégorie"
    },
    "cancel": {
      "form": "Annuler et retourner au formulaire",
      "form_test": "Annuler, retour au test",
      "category": "Annuler et retourner à la catégorie"
    },
    "saveAndReturn": {
      "form": "Enregistrer et retourner au formulaire",
      "form_test": "Enregistrer et retourner au test",
      "category": "Enregistrer et retourner à la catégorie"
    },
    "discard": {
      "title": "Abandonner les modifications ?",
      "body": "Ce que vous avez saisi ici n’est pas encore enregistré et sera perdu si vous revenez en arrière.",
      "keep": "Continuer à modifier",
      "confirm": "Abandonner et revenir"
    },
    "added": {
      "category": "La nouvelle catégorie a été créée et ajoutée à la fin du formulaire.",
      "category_test": "La nouvelle catégorie a été créée et ajoutée à la fin du test.",
      "question": "La nouvelle question a été créée et ajoutée à la fin de la catégorie."
    },
    "attachFailed": {
      "category": "La nouvelle catégorie a été enregistrée, mais n’a pas pu être ajoutée au formulaire. Corrigez-la et enregistrez à nouveau pour réessayer, ou revenez en arrière avec le bouton ci-dessus.",
      "category_test": "La nouvelle catégorie a été enregistrée mais n’a pas pu être ajoutée au test. Modifiez-la et enregistrez à nouveau pour réessayer, ou revenez avec le bouton ci-dessus.",
      "question": "La nouvelle question a été enregistrée, mais n’a pas pu être ajoutée à la catégorie. Corrigez-la et enregistrez à nouveau pour réessayer, ou revenez en arrière avec le bouton ci-dessus."
    }
  },
  "answerReadout": {
    "notAnswered": "Sans réponse",
    "scale": "{value} sur {max}",
    "scaleLabelled": "{value} sur {max} : {label}",
    "other": "Autre : {text}"
  },
  "testGrading": {
    "retry": "Réessayer",
    "outcome": {
      "passed": "Réussi",
      "not_passed": "Non réussi"
    },
    "queue": {
      "title": "Correction",
      "description": "Les tests envoyés qui vous attendent, par session. Déployez une session pour voir ses tests.",
      "loading": "Chargement des tests…",
      "loadError": "Les tests à corriger n’ont pas pu être chargés.",
      "emptyTitle": "Rien à corriger",
      "emptyBody": "Dès qu’un participant envoie un test dont vous êtes le correcteur, il apparaît ici.",
      "noTitle": "Formation sans nom",
      "noDate": "Pas de date",
      "count_one": "{count} test",
      "count_other": "{count} tests",
      "column": {
        "training": "Formation",
        "date": "Date",
        "count": "À corriger"
      },
      "responsesOf": "Tests de {title}",
      "unknownRespondent": "Participant inconnu",
      "submittedAt": "Envoyé le {date}",
      "grade": "Corriger",
      "gradeNamed": "Corriger le test de {name}",
      "expand": "Afficher les tests",
      "collapse": "Masquer les tests"
    },
    "grade": {
      "back": "Retour à la correction",
      "title": "Test de {name}",
      "loading": "Chargement du test…",
      "loadError": "Le test n’a pas pu être chargé.",
      "notFoundTitle": "Ce test n’est pas à votre disposition",
      "notFoundBody": "Il n’existe pas, n’a pas encore été envoyé, ou vous n’êtes pas correcteur de ce test.",
      "refused": "Vous ne pouvez pas corriger ce test.",
      "answers": "Réponses",
      "answerComment": "Commentaire sur cette réponse (facultatif)",
      "answerCommentHintVisible": "Le participant voit ce commentaire avec sa réponse.",
      "answerCommentHintHidden": "L’affichage des réponses est désactivé : ce commentaire reste entre vous et la gestion.",
      "answerCommentGiven": "Commentaire du correcteur",
      "respondentRemarks": "Remarque du participant",
      "judgement": "Évaluation",
      "outcome": "Résultat",
      "score": "Score (facultatif)",
      "scoreHint": "À titre indicatif uniquement : le score ne décide de rien. Vous choisissez vous-même le résultat.",
      "scoreInvalid": "Saisissez un nombre supérieur ou égal à zéro.",
      "scoreGiven": "Score : {score} (à titre indicatif)",
      "comment": "Commentaire sur le test (facultatif)",
      "commentHint": "Le participant voit toujours ce commentaire avec son résultat.",
      "save": "Enregistrer la correction",
      "saving": "Enregistrement…",
      "saved": "Le test de {name} a été corrigé.",
      "conflict": "Un autre correcteur a été plus rapide : ce test a été corrigé entre-temps. Ce que vous avez saisi n’a pas été enregistré. L’évaluation actuelle est affichée ci-dessous.",
      "saveError": "L’enregistrement a échoué. Vérifiez votre connexion et réessayez.",
      "gradedBy": "Corrigé par {name} le {date}",
      "answersVisibleToRespondent": "Le participant voit ce résultat, avec ses réponses et les commentaires sur chaque réponse.",
      "answersHiddenFromRespondent": "Le participant voit le résultat, le score et le commentaire général, mais pas ses réponses ni les commentaires sur chaque réponse."
    }
  },
  "testResult": {
    "title": "Résultat de {title}",
    "loading": "Chargement du résultat…",
    "loadError": "Le résultat n’a pas pu être chargé.",
    "retry": "Réessayer",
    "closedTitle": "Ce résultat n’est pas disponible",
    "closedBody": "Le test n’a pas encore été corrigé.",
    "gradedOn": "Corrigé le {date}",
    "outcome": "Résultat",
    "score": "Score : {score}",
    "scoreNote": "(à titre indicatif)",
    "graderComment": "Commentaire du correcteur",
    "answers": "Vos réponses",
    "answerComment": "Commentaire du correcteur",
    "answersHidden": "Pour ce test, vos réponses et les commentaires sur chaque question ne sont pas affichés."
  },
  "questionnaireResults": {
    "anonymous": "Anonyme",
    "retry": "Réessayer",
    "backToList": "Retour aux résultats",
    "notFoundTitle": "Introuvable",
    "notFoundBody": "Ce rapport n’existe pas, ou vous n’avez pas le droit de le consulter.",
    "responses_one": "{count} réponse",
    "responses_other": "{count} réponses",
    "suppressed": "Trop peu de réponses — {count} sur au moins {floor}",
    "suppressedWhy": "En dessous de ce minimum, nous n’affichons aucun résultat, pas même une moyenne. Ainsi, personne ne peut être reconnu après coup.",
    "list": {
      "title": "Résultats",
      "description": "Le résultat des évaluations de vos sessions. Un résultat n’apparaît que lorsque suffisamment de personnes ont répondu.",
      "loading": "Chargement des résultats…",
      "loadError": "Les sessions n’ont pas pu être chargées.",
      "emptyTitle": "Aucune session avec évaluation pour le moment",
      "emptyBody": "Dès qu’une de vos sessions aura une évaluation, elle apparaîtra ici.",
      "noTitle": "Sans nom",
      "noDate": "Pas de date",
      "noRules": "Aucune évaluation",
      "column": {
        "training": "Formation",
        "date": "Date",
        "rules": "Évaluations"
      }
    },
    "occurrence": {
      "loading": "Chargement du rapport…",
      "loadError": "Le rapport n’a pas pu être chargé.",
      "emptyTitle": "Aucune évaluation pour cette session",
      "emptyBody": "Aucune évaluation n’est en cours pour cette session, il n’y a donc rien à lire."
    },
    "rule": {
      "loading": "Chargement du rapport…",
      "loadError": "Le rapport n’a pas pu être chargé.",
      "subject": "{kind} · {training}",
      "kind": {
        "training": "Formation",
        "elearning": "E-learning",
        "survey": "Questionnaire indépendant"
      },
      "totalTitle": "Total sur toutes les sessions",
      "totalComplementWhy": "Le total reste masqué tant que, avec ce que vous pouvez lire par session, il dévoilerait une petite session. Il apparaît dès que ce n’est plus possible.",
      "textsPerOccurrence": "Les textes rédigés se lisent session par session.",
      "byOccurrenceTitle": "Par session",
      "byOccurrenceHint": "Seuls des nombres figurent ici. Le résultat d’une session se trouve dans son propre rapport.",
      "column": {
        "occurrence": "Session",
        "counted": "Réponses",
        "status": "Rapport"
      },
      "occurrenceGone": "Session plus disponible",
      "statusDisclosed": "Assez de réponses"
    },
    "question": {
      "untitled": "Question sans texte",
      "answers_one": "{count} réponse",
      "answers_other": "{count} réponses",
      "mean": "Moyenne : {mean} (échelle de {min} à {max})",
      "distributionOf": "Répartition des réponses à : {prompt}",
      "yes": "Oui",
      "no": "Non",
      "other": "Autre, à savoir",
      "multipleHint": "Plusieurs réponses pouvaient être choisies ; les parts ne totalisent donc pas 100 %.",
      "divergedTitle": "Cette question a été formulée autrement",
      "divergedBody": "Le libellé de cette question a changé au fil du temps. Les réponses ont été additionnées. Voici comment la question a été posée :",
      "formulation": "{prompt} — {count}×",
      "notAggregated": "Cette question a été comptée mais pas additionnée : son type diffère selon le formulaire ou ne peut pas encore être restitué."
    },
    "table": {
      "value": "Valeur",
      "answer": "Réponse",
      "count": "Nombre",
      "share": "Part",
      "shareOf": "Part"
    },
    "remarks": {
      "title": "Remarques"
    },
    "freeText": {
      "show": "Afficher les réponses à {label} ({count})",
      "hide": "Masquer les réponses à {label}",
      "loading": "Chargement des réponses…",
      "loadError": "Les réponses n’ont pas pu être chargées.",
      "order": "Les réponses sont affichées sans nom et dans un ordre aléatoire.",
      "listLabel": "Réponses à {label}",
      "pagerLabel": "Pages de réponses à {label}",
      "previous": "Précédent",
      "next": "Suivant",
      "pageOf": "Page {page} sur {last}"
    }
  },
  "qualifications": {
    "heading": "Qualifications",
    "intro": "Les qualifications que suit votre organisation, comme les secouristes, le VCA ou un permis de cariste. Une formation peut en accorder une : toute personne qui la termine la détient à partir de ce moment.",
    "tabs": {
      "definitions": "Définitions",
      "held": "Qui détient quoi"
    },
    "new": "Nouvelle qualification",
    "newTitle": "Nouvelle qualification",
    "editTitle": "Modifier la qualification",
    "count_one": "{count} qualification",
    "count_other": "{count} qualifications",
    "empty": "Aucune qualification pour le moment. Créez la première pour la lier à une formation.",
    "emptyFiltered": "Aucune qualification ne correspond à ces filtres.",
    "loadError": "Les qualifications n'ont pas pu être chargées.",
    "filter": {
      "status": "Afficher",
      "active": "Actives",
      "archived": "Archivées",
      "all": "Toutes"
    },
    "cols": {
      "name": "Nom",
      "validity": "Validité",
      "held": "Détenue par",
      "grants": "Formations"
    },
    "duration": {
      "none": "N'expire pas",
      "day_one": "{count} jour",
      "day_other": "{count} jours",
      "month_one": "{count} mois",
      "month_other": "{count} mois",
      "year_one": "{count} an",
      "year_other": "{count} ans"
    },
    "unit": {
      "day": "Jours",
      "month": "Mois",
      "year": "Ans"
    },
    "status": {
      "archived": "Archivée"
    },
    "fields": {
      "name": "Nom",
      "description": "Description",
      "expires": "Cette qualification expire",
      "amount": "Durée",
      "unit": "Unité",
      "unitPlaceholder": "Choisissez une unité",
      "durationHint": "La durée pendant laquelle la qualification reste valable après son attribution.",
      "durationChangeHint": "Une modification ne touche pas les détenteurs actuels : leur date de fin était fixée au moment où ils l'ont reçue.",
      "noEndHint": "Cette qualification n'a pas de date de fin. Les détenteurs la gardent jusqu'à ce que quelqu'un la retire.",
      "active": "Active",
      "activeHint": "Une qualification archivée ne peut plus être choisie ni accordée. Quiconque la détient, la garde."
    },
    "actions": {
      "editNamed": "Modifier {name}",
      "archive": "Archiver",
      "archiveNamed": "Archiver {name}",
      "restore": "Restaurer",
      "restoreNamed": "Restaurer {name}"
    },
    "archiveConfirm": {
      "title": "Archiver cette qualification ?",
      "body": "{name} ne pourra plus être choisie ni liée à une formation. Vous pourrez la restaurer plus tard.",
      "bodyHeld_one": "{name} est détenue par {count} personne. Elle la garde, mais la qualification ne pourra plus être choisie ni liée à une formation. Vous pourrez la restaurer plus tard.",
      "bodyHeld_other": "{name} est détenue par {count} personnes. Elles la gardent, mais la qualification ne pourra plus être choisie ni liée à une formation. Vous pourrez la restaurer plus tard."
    },
    "discard": {
      "title": "Abandonner les modifications ?",
      "body": "Vous avez des modifications non enregistrées. Si vous fermez maintenant, elles seront perdues.",
      "confirm": "Abandonner",
      "keep": "Continuer la modification"
    },
    "notice": {
      "created": "Qualification créée.",
      "updated": "Qualification enregistrée.",
      "archived": "{name} archivée.",
      "restored": "{name} restaurée."
    },
    "grantedBy": {
      "title": "Accordée par",
      "intro": "Les formations qui accordent cette qualification. Vous liez une formation depuis l'écran de la formation elle-même.",
      "empty": "Aucune formation n'accorde encore cette qualification.",
      "loadError": "Les formations n'ont pas pu être chargées.",
      "noEnd": "pas de date de fin",
      "own": "durée propre : {duration}",
      "inherited": "durée par défaut : {duration}"
    }
  },
  "heldQualifications": {
    "heading": "Qui détient quoi",
    "intro": "Toutes les qualifications que quelqu'un détient, avec leur validité et leur origine. Filtrez par personne, par qualification et par échéance.",
    "count_one": "{count} résultat",
    "count_other": "{count} résultats",
    "empty": "Personne ne détient encore de qualification. Des lignes apparaissent ici dès que quelqu'un termine une formation qui en accorde une.",
    "emptyFiltered": "Aucune ligne ne correspond à ces filtres.",
    "loadError": "Les qualifications détenues n'ont pas pu être chargées.",
    "noEnd": "pas de date de fin",
    "daysLeft_one": "encore {count} jour",
    "daysLeft_other": "encore {count} jours",
    "renewalStopped": "Renouvellement arrêté",
    "note": "Note (facultative)",
    "filter": {
      "qualification": "Qualification",
      "person": "Personne",
      "personPlaceholder": "Rechercher une personne",
      "status": "Statut",
      "expiring": "Expire",
      "any": "À tout moment",
      "expiringOption": "Dans les {days} jours",
      "all": "Tous",
      "archivedName": "{name} (archivée)",
      "clear": "Effacer les filtres"
    },
    "status": {
      "valid": "Valide",
      "not_yet_valid": "Pas encore valide",
      "expired": "Expirée",
      "ended_by_choice": "Terminée, non renouvelée",
      "superseded": "Remplacée",
      "corrected": "Corrigée",
      "withdrawn": "Retirée",
      "never_valid": "Jamais valide",
      "active": "Active (valide ou à venir)",
      "ended": "Terminée (toute raison)"
    },
    "origin": {
      "completion": "Formation terminée",
      "external_training": "Formation externe",
      "self_declared": "Déclarée par la personne",
      "administrative": "Enregistrée par un administrateur"
    },
    "evidence": {
      "trusted": "Enregistrée par le système",
      "verifiable": "Preuve vérifiable",
      "declaration": "Déclaration, non vérifiée"
    },
    "sourceType": {
      "completion_record": "Achèvement",
      "import_run": "Exécution d'import",
      "migration_run": "Exécution de migration"
    },
    "endReason": {
      "superseded": "Remplacée par une plus récente",
      "corrected": "Corrigée",
      "withdrawn_from_now": "Retirée à partir de maintenant",
      "never_valid": "Déclarée jamais valide"
    },
    "cols": {
      "person": "Personne",
      "qualification": "Qualification",
      "window": "Valide",
      "origin": "Origine",
      "ground": "Fondement",
      "status": "Statut"
    },
    "detail": {
      "window": "Validité",
      "origin": "Origine",
      "evidence": "Fondement",
      "source": "Source",
      "noSource": "Aucun événement source (enregistrée à la main)",
      "run": "Exécution",
      "ended": "Terminée",
      "renewalStopped": "Renouvellement arrêté",
      "recorded": "Enregistrée le"
    },
    "actions": {
      "withdraw": "Retirer",
      "withdrawNamed": "Retirer {name}",
      "stopRenewal": "Arrêter le renouvellement",
      "stopRenewalNamed": "Arrêter le renouvellement de {name}",
      "resumeRenewal": "Reprendre le renouvellement",
      "resumeRenewalNamed": "Reprendre le renouvellement de {name}"
    },
    "withdraw": {
      "title": "Retirer cette qualification ?",
      "body": "{name} : la qualification prend fin. Cette action est irréversible.",
      "reason": "Motif",
      "reasonPlaceholder": "Choisissez un motif",
      "reasonRequired": "Choisissez un motif pour le retrait.",
      "reasons": {
        "withdrawn_from_now": "À partir de maintenant",
        "never_valid": "Jamais valide"
      },
      "reasonHints": {
        "withdrawn_from_now": "La personne l'a détenue jusqu'à présent. Les rapports sur le passé la comptent toujours.",
        "never_valid": "Elle n'aurait jamais dû être accordée. Les rapports sur le passé ne la comptent plus."
      },
      "confirm": "Retirer"
    },
    "stopRenewal": {
      "title": "Arrêter le renouvellement ?",
      "body": "{name} : la qualification n'est pas renouvelée. Une fois arrivée à échéance, elle apparaît comme terminée et non comme expirée. Vous pouvez annuler tant qu'elle est encore valide.",
      "confirm": "Arrêter le renouvellement"
    },
    "resumeRenewal": {
      "title": "Reprendre le renouvellement ?",
      "body": "{name} : la qualification peut de nouveau être renouvelée.",
      "confirm": "Reprendre le renouvellement"
    },
    "notice": {
      "withdrawn": "{name} retirée.",
      "stopped": "Renouvellement de {name} arrêté.",
      "stoppedMany": "Renouvellement de {name} arrêté sur {count} lignes.",
      "resumed": "Renouvellement de {name} repris.",
      "resumedMany": "Renouvellement de {name} repris sur {count} lignes."
    }
  },
  "activityQualifications": {
    "title": "Accorde une qualification",
    "intro": "Toute personne qui termine cette formation détient ces qualifications à partir de ce moment.",
    "loadError": "Les qualifications liées n'ont pas pu être chargées.",
    "empty": "Cette formation n'accorde aucune qualification.",
    "emptyNew": "Aucune qualification choisie pour l’instant. Le lien est créé lorsque vous enregistrez l’activité.",
    "notForComposition": "Un lot ou un parcours ne délivre pas de qualification lui-même ; choisissez une activité simple pour en lier une.",
    "noEnd": "pas de date de fin",
    "own": "durée propre : {duration}",
    "inherited": "durée par défaut : {duration}",
    "add": "Lier une qualification",
    "addTitle": "Lier une qualification",
    "editTitle": "Modifier la validité",
    "qualification": "Qualification",
    "qualificationPlaceholder": "Choisissez une qualification",
    "qualificationRequired": "Choisissez une qualification.",
    "ownDurationHint": "Laissez vide pour utiliser la durée par défaut de la qualification.",
    "ownDurationHintWithDefault": "Laissez vide pour utiliser la valeur par défaut : {duration}.",
    "noEndHint": "Cette qualification n'a pas de date de fin ; il n'y a donc pas de durée à définir.",
    "editNamed": "Modifier {name}",
    "removeNamed": "Délier {name}",
    "remove": "Délier",
    "removeConfirm": {
      "title": "Délier cette qualification ?",
      "body": "{name} n'est plus accordée par cette formation. Les personnes qui la détiennent déjà la gardent."
    },
    "notice": {
      "added": "Qualification liée.",
      "updated": "Validité enregistrée.",
      "removed": "{name} déliée."
    }
  },
  "externalRequestTypes": {
    "list": {
      "heading": "Types de demande de formation externe",
      "intro": "Un type est par exemple une formation ou un coaching, avec son propre formulaire, ses lignes de coûts et sa chaîne. Il n'y a pas de type par défaut : configurez-en un d'abord, puis activez-le. Sans version en ligne, les collaborateurs n'ont aucun point d'entrée.",
      "new": "Nouveau type",
      "empty": "Il n'y a pas encore de type. Créez-en un pour pouvoir demander des formations externes.",
      "on": "Actif (v{number})",
      "off": "Inactif",
      "open": "Ouvrir",
      "cols": {
        "name": "Type",
        "status": "Statut",
        "versions": "Versions"
      },
      "fields": {
        "name": "Nom",
        "key": "Clé",
        "keyHint": "Lettres minuscules, chiffres et _. Vous ne pourrez plus modifier la clé ensuite."
      }
    },
    "detail": {
      "empty": "Ce type n'a pas encore de version.",
      "cols": {
        "version": "Version",
        "status": "Statut",
        "liveFrom": "En ligne à partir de"
      },
      "edit": "Modifier",
      "view": "Consulter",
      "goLive": "Mettre en ligne",
      "schedule": "Planifier",
      "unschedule": "Annuler la planification",
      "discard": "Supprimer",
      "newConceptFrom": "Nouveau brouillon à partir de celle-ci",
      "newConcept": "Nouveau brouillon vide",
      "conceptExists": "Il existe déjà un brouillon ; il ne peut y en avoir qu'un à la fois.",
      "notValid": "Cette version ne peut pas encore être mise en ligne. Ceci doit d'abord être correct :",
      "isOn": "Le type est actif : les collaborateurs peuvent le demander.",
      "isOff": "Le type est inactif : il n'y a pas de version en ligne, donc aucun point d'entrée pour les collaborateurs.",
      "rename": "Renommer",
      "scheduleTitle": "Planifier la version {number}",
      "liveFrom": "En ligne à partir de",
      "liveFromHint": "Fuseau horaire de l'environnement ({timezone}). À ce moment, la version est contrôlée à nouveau ; si quelque chose n'est plus valide, la version actuelle reste en ligne.",
      "discardTitle": "Supprimer le brouillon ?",
      "discardBody": "La version {number} sera supprimée. Une version en ligne ou clôturée est toujours conservée.",
      "catalogTile": {
        "heading": "Vignette dans le catalogue",
        "label": "Afficher une vignette dans le catalogue",
        "hintOn": "Les collaborateurs autorisés à faire une demande voient dans le catalogue une vignette qui leur permet de demander ce type.",
        "hintOff": "La vignette n’apparaît que lorsque ce type est activé (a une version en ligne)."
      }
    },
    "status": {
      "concept": "Brouillon",
      "scheduled": "Planifiée",
      "live": "En ligne",
      "phasing_out": "En extinction",
      "archived": "Archivée",
      "failed": "Échouée"
    },
    "transition": {
      "version_not_editable": "Seul un brouillon peut être modifié. Créez un nouveau brouillon à partir de cette version.",
      "version_wrong_state": "Ce n'est pas possible pour une version dans cet état.",
      "concept_exists": "Il existe déjà un brouillon pour ce type. Terminez-le ou supprimez-le.",
      "schedule_exists": "Un basculement est déjà planifié pour ce type.",
      "moment_not_in_future": "Choisissez un moment dans le futur."
    },
    "role": {
      "title": "Titre",
      "provider": "Organisme",
      "cost": "Coûts",
      "period": "Période",
      "qualification": "Qualification"
    },
    "phase": {
      "request": "Demande",
      "agreement": "Convention",
      "verification": "Vérification",
      "change": "Modification"
    },
    "cost": {
      "kind": {
        "fixed": "Montant fixe",
        "unit": "Prix × quantité"
      },
      "vat": {
        "none": "TVA inconnue",
        "excl": "Montant HT",
        "incl": "Montant TTC"
      },
      "empty": "Pas encore de ligne de coûts. Ajoutez-en au moins une : le total des lignes est le rôle Coûts.",
      "key": "Clé",
      "type": "Type",
      "vatLabel": "TVA",
      "rate": "Taux",
      "remove": "Supprimer",
      "add": "Ajouter une ligne de coûts"
    },
    "preview": {
      "heading": "Aperçu en direct",
      "language": "Langue de l'aperçu",
      "empty": "Ajoutez des champs pour voir le formulaire.",
      "noCostLines": "Ajoutez une ligne de coûts pour voir les coûts.",
      "price": "{name} — prix",
      "quantity": "{name} — quantité",
      "totalExcl": "Total HT",
      "totalIncl": "Total TTC",
      "vatUnknown": "inconnu (toutes les lignes ne connaissent pas leur TVA)",
      "firstDay": "premier jour",
      "lastDay": "dernier jour",
      "allDays": "Le collaborateur indique ici tous les jours de la formation.",
      "providerPlaceholder": "Choisir ou rechercher un organisme…",
      "qualificationPlaceholder": "Choisir une qualification…"
    },
    "editor": {
      "heading": "Version {number}",
      "introConcept": "Ce brouillon peut être modifié. La mise en ligne et la planification le contrôlent d'abord.",
      "introReadOnly": "Cette version est immuable. Pour la modifier, créez un nouveau brouillon à partir de cette version.",
      "back": "Retour au type",
      "check": "Contrôler",
      "checkOk": "Tout est correct : cette version peut être mise en ligne.",
      "checkMissing_one": "Il reste {count} point qui n'est pas correct :",
      "checkMissing_other": "Il reste {count} points qui ne sont pas corrects :",
      "checkStale": "Vous avez modifié quelque chose depuis le contrôle. Enregistrez et contrôlez à nouveau.",
      "saved": "Le brouillon a été enregistré.",
      "saveFailed": "Le brouillon n'a pas pu être enregistré.",
      "failed": "Le basculement vers cette version n'a pas eu lieu ; l'ancienne version est restée en ligne. Ceci n'était plus valide à ce moment :",
      "settings": "Paramètres",
      "settingsHint": "Les coûts sont lus sur la base choisie, de sorte qu'il n'y a jamais de conversion. Les règles avec conditions par phase viendront avec le graphe de processus ; ici, vous choisissez la chaîne pour la demande.",
      "costBasis": "Lire les coûts sur la base de",
      "basis": {
        "excl": "Total HT",
        "incl": "Total TTC"
      },
      "periodMode": "Période de la formation",
      "period": {
        "all_days": "Tous les jours",
        "first_last": "Premier et dernier jour",
        "none": "Pas de date"
      },
      "requestChain": "Chaîne d'approbation pour la demande",
      "noChain": "Pas encore de chaîne choisie",
      "learningForm": "Forme d'apprentissage de la formation",
      "learningFormHelp": "Une demande approuvée devient une formation externe au nom du collaborateur, avec cette forme d'apprentissage. La liste provient des formes d'apprentissage des paramètres du catalogue.",
      "learningFormDefault": "Par défaut ({name})",
      "agreementTemplate": "Convention",
      "noAgreement": "Aucune convention",
      "agreementUnavailable": "Disponible dès que les conventions pourront être émises",
      "moreRules": "Cette version a plus d'une règle pour la demande (par exemple issue d'un import). Elles restent en place ; vous pouvez les modifier avec le graphe de processus.",
      "form": "Formulaire",
      "formHint": "Le titre, l'organisme et les coûts sont toujours obligatoires. Donnez à chaque champ un nom dans chaque langue de l'environnement.",
      "costLines": "Lignes de coûts",
      "costHint": "La plateforme calcule le total et enregistre les lignes et le total ensemble comme instantané sur la demande."
    },
    "violation": {
      "cost_basis_missing": "Choisissez la base sur laquelle les coûts sont lus (HT ou TTC).",
      "period_mode_missing": "Choisissez ce que le type demande en matière de dates.",
      "learning_form_unknown": "La forme d'apprentissage choisie « {key} » ne fait plus partie des formes d'apprentissage de cet environnement. Choisissez-en une autre ou laissez le champ vide.",
      "field_key_invalid": "La clé « {key} » n'est pas valide : utilisez des lettres minuscules, des chiffres et _, en commençant par une lettre.",
      "field_key_duplicate": "La clé « {key} » figure sur deux champs.",
      "field_type_invalid": "Le champ « {key} » a un type inconnu.",
      "field_label_missing": "Le champ « {key} » n'a pas de libellé en {locale}.",
      "role_duplicate": "Le rôle {role} figure sur plus d'un champ.",
      "role_type_invalid": "Le champ « {key} » a un type qui ne convient pas au rôle {role}.",
      "role_must_be_required": "Le champ « {key} » avec le rôle {role} doit être obligatoire.",
      "role_missing": "Associez un champ au rôle {role}.",
      "period_role_without_period": "Il y a un champ avec le rôle Période, mais le type ne demande pas de date.",
      "cost_lines_missing": "Ajoutez au moins une ligne de coûts.",
      "cost_line_key_invalid": "La clé « {key} » d'une ligne de coûts n'est pas valide.",
      "cost_line_key_duplicate": "La clé « {key} » figure sur deux lignes de coûts.",
      "cost_line_kind_invalid": "La ligne de coûts « {key} » a un type inconnu.",
      "cost_line_label_missing": "La ligne de coûts « {key} » n'a pas de nom en {locale}.",
      "cost_line_vat_invalid": "La ligne de coûts « {key} » a un paramètre de TVA inconnu.",
      "cost_line_vat_rate_unknown": "La ligne de coûts « {key} » a un taux de TVA qui ne figure pas dans la liste.",
      "cost_basis_unavailable": "Le type lit les coûts TTC, mais la ligne de coûts « {key} » ne connaît pas sa TVA.",
      "phase_request_missing": "Choisissez une chaîne d'approbation pour la demande.",
      "phase_unknown": "La phase « {phase} » n'existe pas.",
      "rules_no_catch_all": "Les règles de la phase {phase} ne se terminent pas par une règle sans condition.",
      "rules_catch_all_not_last": "La règle {index} de la phase {phase} n'a pas de condition, donc les règles suivantes ne sont jamais atteintes.",
      "rule_chain_missing": "La règle {index} de la phase {phase} ne désigne aucune chaîne.",
      "chain_not_found": "La chaîne de la phase {phase} n'existe plus.",
      "chain_empty": "La chaîne de la phase {phase} n'a aucune étape.",
      "chain_unresolvable": "Dans la chaîne de la phase {phase}, personne ne peut décider : le rôle ou la personne choisi n'existe pas ou est vide.",
      "chain_all_of": "La chaîne de la phase {phase} comporte une étape où tout le monde doit décider. Une demande de formation externe ne permet que \"l'un d'entre eux\".",
      "agreement_not_available": "La règle {index} de la phase {phase} choisit une convention. L'émission d'une convention n'est pas encore disponible ; choisissez pour l'instant \"pas de convention\".",
      "rule_step_keys_invalid": "La règle {index} de la phase {phase} a une clé d'étape invalide ou en double.",
      "mail_template_missing": "L'e-mail « {slug} » pour « {event} » n'existe pas."
    }
  },
  "themes": {
    "heading": "Catégories",
    "intro": "Gérez les catégories parmi lesquelles vous choisissez pour une activité et sur lesquelles le catalogue filtre. Une catégorie peut se placer sous une catégorie principale en tant que sous-catégorie ; vous pouvez saisir le nom par langue.",
    "new": "Nouvelle catégorie",
    "editTitle": "Modifier la catégorie",
    "empty": "Il n’y a pas encore de catégories. Ajoutez la première pour pouvoir la choisir sur une activité.",
    "fields": {
      "name": "Nom ({language})",
      "parent": "Se place sous",
      "noParent": "Aucune (catégorie principale)",
      "parentHint": "Choisissez une catégorie principale pour y placer cette catégorie.",
      "parentLocked": "Cette catégorie a elle-même des sous-catégories et reste donc une catégorie principale."
    },
    "cols": {
      "name": "Catégorie",
      "usage": "Activités",
      "actions": "Actions"
    },
    "moveUp": "Monter {name}",
    "moveDown": "Descendre {name}",
    "merge": "Fusionner",
    "mergeTitle": "Fusionner la catégorie",
    "mergeBody": "Les {count} activité(s) de « {name} » passent à la catégorie que vous choisissez. « {name} » est ensuite supprimée.",
    "mergeInto": "Fusionner avec",
    "mergeChoose": "Choisissez une catégorie",
    "deleteBlockedInUse": "Cette catégorie est utilisée. Fusionnez-la avec une autre catégorie.",
    "deleteBlockedChildren": "Cette catégorie a des sous-catégories.",
    "confirmDelete": "Supprimer la catégorie ?",
    "confirmDeleteBody": "« {name} » sera supprimé. Cette action est irréversible."
  },
  "media": {
    "heading": "Médiathèque",
    "intro": "Les images de cet environnement, à utiliser sur les éléments du catalogue. Pour chaque image, vous voyez combien de fois elle est utilisée, s'il manque encore un texte alternatif et si une version plus récente attend à la source. Cliquez sur une image pour accéder à tout ce que vous pouvez en faire. PNG et JPG uniquement ; plusieurs à la fois est possible.",
    "add": "Ajouter des images",
    "addError": "L'ajout a échoué. Veuillez réessayer.",
    "removeError": "La suppression a échoué. Veuillez réessayer.",
    "loadError": "La bibliothèque n'a pas pu être chargée.",
    "usageError": "Impossible de charger les endroits où cette image est utilisée.",
    "empty": "Il n'y a encore aucune image dans la bibliothèque.",
    "inUse": "Utilisée",
    "notInUse": "Non utilisée",
    "altMissing": "Pas de texte alternatif",
    "editAlt": "Texte alternatif",
    "saveAlt": "Enregistrer le texte alternatif",
    "altError": "Le texte alternatif n'a pas pu être enregistré.",
    "altFor": "Texte alternatif ({language})",
    "altHint": "Décrivez ce que montre l'image, pour celles et ceux qui ne peuvent pas la voir. Laissez une langue vide si vous ne l'utilisez pas.",
    "remove": "Supprimer",
    "removeFor": "Supprimer {name}",
    "confirmRemove": "Êtes-vous sûr ? L'image disparaîtra de la bibliothèque.",
    "pagination": "Pagination",
    "prev": "Précédent",
    "next": "Suivant",
    "pageOf": "Page {page} sur {total}",
    "defaultHeading": "Image par défaut",
    "defaultNone": "Aucune image par défaut définie",
    "defaultElsewhere": "Définie — sur une autre page",
    "defaultClear": "Retirer l'image par défaut",
    "defaultBadge": "Par défaut",
    "defaultError": "Impossible de définir l'image par défaut.",
    "setDefaultFor": "Définir {name} comme image par défaut",
    "deliveredHeading": "Fournies par BCS",
    "deliveredIntro": "Ces images proviennent de BCS et sont identiques pour tout le monde. Vous pouvez les retirer de votre bibliothèque et leur donner votre propre texte alternatif ; le fichier reste la propriété de BCS.",
    "removeDelivered": "Retirer de ma bibliothèque",
    "removeDeliveredFor": "Retirer {name} de ma bibliothèque",
    "confirmRemoveDelivered": "Cette image disparaît de votre bibliothèque. Le fichier reste en place et BCS peut la remettre à disposition.",
    "addFromUrl": "Depuis une adresse",
    "addFromPexels": "Chercher sur Pexels",
    "fromUrlTitle": "Ajouter une image depuis une adresse",
    "fromUrlField": "Adresse de l'image",
    "fromUrlHint": "Nous téléchargeons l'image et la conservons ici. Si elle change plus tard à la source, un bouton suffit pour la récupérer de nouveau.",
    "fromUrlSubmit": "Récupérer et ajouter",
    "fromUrlError": "L'image n'a pas pu être récupérée.",
    "creditField": "Crédit (facultatif)",
    "creditHint": "Le nom à afficher avec l'image, si la source le demande.",
    "creditBy": "Photo : {name}",
    "fetching": "Récupération en cours…",
    "sourceChanged": "Source modifiée",
    "sourceCheck": "Vérifier la source",
    "sourceChecking": "Vérification en cours…",
    "pexelsTitle": "Chercher sur Pexels",
    "pexelsField": "Que cherchez-vous ?",
    "pexelsSearch": "Chercher",
    "pexelsHint": "Pexels trouve davantage avec des mots anglais. Le nom du photographe est conservé avec l'image : Pexels l'exige.",
    "pexelsImport": "Ajouter à la bibliothèque",
    "pexelsPartial": "{count} images n'ont pas pu être récupérées :",
    "pexelsImportCount": "Importer ({count})",
    "pexelsEmpty": "Aucun résultat pour ce mot.",
    "pexelsError": "La recherche sur Pexels n'a pas abouti.",
    "pexelsImportError": "L'image n'a pas pu être ajoutée.",
    "pickerTitle": "Choisir une image",
    "pickerSearch": "Rechercher par nom de fichier",
    "pickerConfirm": "Utiliser celle-ci",
    "pickerAdd": "Pas trouvée ?",
    "pickerNoMatch": "Aucune image dont le nom contient ce mot.",
    "pickOrUpload": "Choisir ou téléverser",
    "uploadFromComputer": "Téléverser depuis votre ordinateur",
    "uploadField": "Téléverser une image",
    "uploadError": "L’image n’a pas pu être téléversée.",
    "packagePickerTitle": "Téléverser un fichier e-learning",
    "packageField": "Fichier zip",
    "packageUse": "Utiliser ce fichier",
    "shareWithLibrary": "Conserver aussi dans la médiathèque",
    "shareWithLibraryHint": "Laissez décoché si l'image n'appartient qu'à cet élément : elle disparaîtra avec lui.",
    "detailTitle": "Image",
    "openDetail": "Ouvrir {name}",
    "dimensions": "Dimensions",
    "pixels": "{width} × {height} pixels",
    "fileSize": "Taille du fichier",
    "fileType": "Type",
    "credit": "Crédit",
    "source": "Source",
    "inUseCount": "Utilisée {count}×",
    "setDefault": "Définir comme image par défaut",
    "actionError": "La modification n'a pas abouti. Veuillez réessayer.",
    "dropHere": "Glissez des images ici ou cliquez pour choisir",
    "dropHint": "PNG ou JPG, plusieurs à la fois",
    "uploading": "Téléversement en cours…",
    "uploadingPercent": "Téléversement… {percent} %",
    "sourceUnchanged": "La source est inchangée.",
    "sourceChangedHint": "Voici ce que contient la source actuellement. Si vous la reprenez, ceci devient l'image — partout où elle est utilisée.",
    "sourcePreviewAlt": "L'image telle qu'elle se présente actuellement à la source",
    "sourcePreviewGone": "L'aperçu préparé n'est plus disponible. Vérifiez à nouveau la source pour voir ce qu'elle contient maintenant.",
    "sourceUpdate": "Mettre à jour",
    "sourceCheckAgain": "Vérifier de nouveau",
    "usage": {
      "activity_image": "Image d'une activité d'apprentissage",
      "activity_source": "Source d'une activité d'apprentissage",
      "occurrence_image": "Image d'une session",
      "elearning_package": "Paquet e-learning",
      "external_request_attachment": "Pièce jointe à une demande",
      "message_attachment": "Pièce jointe à un message",
      "tenant_default": "Image par défaut de cet environnement",
      "user_avatar": "Photo de profil d’un utilisateur",
      "certificate": "Certificat délivré",
      "document_template": "Logo d’un modèle de document",
      "document_settings": "Logo de l’environnement sur les certificats"
    }
  },
  "studyLoad": {
    "heading": "Charge d'étude",
    "durationLabel": "Durée de la formation",
    "durationDeviation": "Durée différente",
    "durationChoose": "Choisissez une durée",
    "durationCustom": "Autre…",
    "studyLoadLabel": "Charge d'étude totale",
    "hours": "Heures",
    "minutes": "Minutes",
    "hoursShort": "h",
    "minutesShort": "min",
    "inherited": "Valeur par défaut de l'activité : {value}",
    "useInherited": "Revenir à la valeur par défaut de l'activité ({value})",
    "inheritedFromPlanning": "D’après la planification : {value}",
    "useInheritedFromPlanning": "Revenir à la durée de la planification ({value})",
    "belowDuration": "La charge d'étude totale est plus courte que la durée. Vérifiez que c'est bien correct."
  },
  "catalogs": {
    "references": {
      "deleteTitle": "{name} est encore utilisé",
      "deleteBody": "Si vous supprimez ce catalogue, voici ce qui se passe :",
      "deleteConfirm": "Supprimer quand même",
      "slugTitle": "Des textes renvoient vers l’adresse actuelle",
      "slugBody": "Si vous modifiez l’adresse, ces liens vers /catalog/{slug} ne mèneront plus nulle part :",
      "slugConfirm": "Modifier l’adresse quand même",
      "isStart": "Quiconque ouvre /catalog arrive actuellement ici. Ce sera désormais le catalogue suivant du menu.",
      "inMenu": "Il disparaît du menu.",
      "catalog": {
        "include": "Le catalogue « {name} » l’inclut. Ce catalogue devient vide, avec un avertissement.",
        "exclude": "Le catalogue « {name} » l’exclut. Ce catalogue devient vide, avec un avertissement."
      },
      "activityLink": "La description de la formation « {title} » renvoie vers lui.",
      "catalogText": "La description du catalogue « {name} » renvoie vers lui.",
      "text": "Le texte personnalisé « {key} » ({locale}) renvoie vers lui.",
      "mailTemplate": "E-mail : {name} ({locales}) renvoie vers lui.",
      "outside": "Les liens en dehors du système, comme des favoris ou une page intranet, ne nous sont pas visibles.",
      "unknown": "Nous n’avons pas pu vérifier où ce catalogue est utilisé. Veuillez réessayer."
    },
    "new": "Ajouter un catalogue",
    "newTitle": "Nouveau catalogue",
    "untitled": "Catalogue sans nom",
    "backToList": "Retour à la liste",
    "emptyAll": "Il n’existe aucun catalogue.",
    "emptyAllHint": "Sans catalogue, les apprenants n’ont rien à parcourir — uniquement des liens directs et les formations attribuées.",
    "itemCount_one": "{count} formation",
    "itemCount_other": "{count} formations",
    "notInNav": "pas dans le menu",
    "broken": "Un renvoi n’existe plus ; ce catalogue n’affiche rien.",
    "deleteAnyway": "Supprimer quand même",
    "name": "Nom ({language})",
    "slug": "Adresse",
    "slugHelp": "La partie après /catalog/ dans le lien. Minuscules, chiffres et tirets. Si vous la modifiez, les liens partagés vers cette page cessent de fonctionner.",
    "statusLabel": "Statut",
    "inMainNav": "Afficher dans le menu",
    "inMainNavHelp": "Désactivé signifie : accessible par un lien, mais pas dans la barre latérale.",
    "showWhenEmpty": "Afficher même sans contenu",
    "showWhenEmptyHelp": "Par défaut, un catalogue quitte le menu dès qu’il ne contient rien pour cette personne. Vide est donc propre à chacun : ce que l’un voit, l’autre ne le voit pas forcément.",
    "visibilityMode": "Qui peut ouvrir cette page",
    "accessGroup": "Groupe d’accès",
    "pickAccessGroup": "Choisissez un groupe…",
    "viewMode": "Ce que montre la liste",
    "defaultLayout": "Affichage de départ",
    "imageRatio": "Format d’image",
    "imageRatioHelp": "Détermine le recadrage des images. La vue liste conserve le même format que les cartes.",
    "status": {
      "concept": "Brouillon",
      "published": "Publié",
      "inactive": "Inactif"
    },
    "visibility": {
      "everyone": "Tout le monde",
      "ruleset": "Uniquement un groupe d’accès"
    },
    "view": {
      "activities": "Une entrée par formation",
      "occurrences": "Chaque session planifiée"
    },
    "layout": {
      "cards": "Cartes",
      "list": "Liste"
    },
    "sections": {
      "identity": "Nom et place",
      "identityHelp": "Le nom de la page et sa place dans le menu.",
      "content": "Ce qui y entre",
      "contentHelp": "Inclure fait entrer des formations, exclure les tient dehors. Une exclusion choisie à la main l’emporte sur tout ; une formation choisie à la main survit à une règle qui l’écarterait.",
      "access": "Qui peut ouvrir la page",
      "accessHelp": "Il s’agit de la page, pas des formations qu’elle contient. Qui peut ouvrir une formation par lien direct le peut toujours, même sans pouvoir ouvrir ce catalogue.",
      "presentation": "Présentation",
      "presentationHelp": "L’aspect de la page. Les apprenants peuvent basculer eux-mêmes entre cartes et liste."
    },
    "membership": {
      "field": "Sur quoi",
      "values": "Quelles valeurs",
      "otherCatalog": "Quel catalogue",
      "pickCatalog": "Choisissez un catalogue…",
      "allHint": "Tout ce que contient cet environnement.",
      "addCondition": "Ajouter une condition",
      "removeCondition": "Retirer la condition",
      "removeTerm": "Retirer",
      "kind": {
        "all": "Tout",
        "rule": "Règle",
        "catalog": "Un autre catalogue"
      },
      "branch": {
        "include": "Ici",
        "exclude": "Pas ici"
      },
      "branchHint": {
        "include": "Une formation entre si au moins l’un de ces critères le dit.",
        "exclude": "Et ressort si l’un de ces critères la touche — sauf si vous l’avez ajoutée à la main."
      },
      "add": {
        "rule": "Règle",
        "catalog": "Catalogue",
        "all": "Tout"
      }
    },
    "preview": {
      "title": "Ce qu’il contient",
      "help": "Deux modes. Ce qu’il contient montre la sélection indépendamment de qui regarde et du statut — c’est ce que vous réglez. Comme le voit un apprenant fait passer tout par toutes les portes avec vos droits, et en tant qu’administrateur vous voyez plus qu’un apprenant.",
      "holds": "Ce qu’il contient",
      "asLearner": "Comme le voit un apprenant",
      "hint": {
        "holds": "La sélection, indépendamment du statut et de qui regarde.",
        "learner": "Par toutes les portes, avec vos droits. En tant qu’administrateur vous voyez plus qu’un apprenant."
      },
      "count_one": "{count} formation",
      "count_other": "{count} formations",
      "empty": "Rien pour l’instant. Ajoutez une règle ou une formation.",
      "broken": "Un renvoi de la sélection n’existe plus, donc ce catalogue n’affiche rien.",
      "saveFirst": "Enregistrez d’abord le catalogue ; vous verrez ensuite ce qu’il contient.",
      "term": "critère {n}",
      "rung": {
        "1": "retirée à la main",
        "2": "ajoutée à la main",
        "3": "exclue par une règle",
        "4": "via une règle",
        "5": "aucune règle ne l’inclut"
      }
    },
    "fields": {
      "type": "Type",
      "composition": "Composition",
      "tracking_mode": "Suivi",
      "learning_form_category": "Forme d’apprentissage",
      "language": "Langue",
      "theme": "Catégorie"
    },
    "onActivity": {
      "heading": "Dans quels catalogues cela figure-t-il ?",
      "membershipOnly": "Il s'agit uniquement de la sélection. Qu'un participant voie également la formation dépend en outre de son statut, de son public cible et de la disponibilité du matériel.",
      "noCatalogs": "Cet environnement n'a pas encore de catalogues.",
      "inside": "Présent dans ({count})",
      "insideNone": "Dans aucun catalogue.",
      "outside": "Absent de ({count})",
      "outsideNone": "Dans tous les catalogues.",
      "brokenCatalog": "Ce catalogue renvoie à un élément qui n'existe plus."
    },
    "defaultSort": "Tri par défaut",
    "defaultSortHelp": "Ce par quoi la liste commence. Si un visiteur choisit un autre tri, le sien l'emporte — ce réglage est un point de départ, pas une contrainte.",
    "shownFacets": "Quels filtres apparaissent",
    "shownFacetsHelp": "Ceci détermine quels filtres sont visibles, pas ce que contient le catalogue. Un filtre masqué fonctionne toujours via un lien partagé ; ce qui appartient au catalogue se règle dans son contenu.",
    "shownFacetsEmpty": "Cochez tout pour la valeur par défaut : tous les filtres.",
    "facet": {
      "type": "Type",
      "composition": "Forme",
      "tracking_mode": "Genre",
      "category": "Catégorie (texte libre sur la formation)",
      "theme": "Catégorie (gérée)",
      "language": "Langue"
    }
  },
  "cancellationPolicies": {
    "heading": "Conditions d'annulation",
    "intro": "Des ensembles réutilisables pour les annulations : un délai avant le début et, de chaque côté, qui peut annuler et ce que cela coûte. Une nouvelle activité reçoit l'ensemble par défaut ; une session peut en choisir un autre.",
    "new": "Nouvelles conditions",
    "editTitle": "Modifier les conditions",
    "view": "Consulter",
    "empty": "Pas encore de conditions d'annulation. Les premières que vous créez deviennent celles par défaut.",
    "makeDefault": "Définir par défaut",
    "defaultBadge": "Par défaut",
    "usage_one": "Choisies pour {count} activité ou session",
    "usage_other": "Choisies pour {count} activités et sessions",
    "confirmDelete": "Supprimer les conditions ?",
    "confirmDeleteBody": "« {name} » sera supprimé. Ces conditions ne sont utilisées nulle part.",
    "summary": "{deadline} · avant : {before} · après : {after}",
    "deadlineSameDay": "délai jusqu'au jour du début",
    "deadlineDays_one": "délai {count} jour avant",
    "deadlineDays_other": "délai {count} jours avant",
    "cost": {
      "none": "gratuit"
    },
    "costType": {
      "none": "Gratuit",
      "fixed": "Montant fixe"
    },
    "side": {
      "before": "Avant le délai",
      "after": "Après le délai",
      "beforeHelp": "Ce qui s'applique jusqu'au jour du délai d'annulation inclus.",
      "afterHelp": "Ce qui s'applique après le délai d'annulation, jusqu'au début. Un administrateur peut toujours annuler, même si ce n'est pas autorisé ici."
    },
    "section": {
      "general": "Général",
      "texts": "Texte pour l'apprenant"
    },
    "textsHelp": "L'apprenant lit ce texte avec l'activité, dans sa propre langue. Une langue sans texte se rabat sur la langue de l'environnement.",
    "fields": {
      "name": "Nom",
      "deadlineDays": "Délai d'annulation (jours avant le premier jour)",
      "deadlineDaysHelp": "Le délai d'annulation d'une session est son premier jour moins ce nombre de jours calendaires ; 0 est le jour du début. La date peut être fixée à la main pour chaque session.",
      "isDefault": "Par défaut pour les nouvelles activités",
      "mode": "Qui annule",
      "costType": "Frais",
      "amount": "Montant (€)",
      "textIn": "Texte ({language})"
    }
  },
  "cancellationTerms": {
    "line": {
      "untilStart": {
        "selfFree": "Annulation gratuite jusqu'au début",
        "selfFixed": "L'annulation coûte {amount}",
        "approvalFree": "Annuler jusqu'au début, avec approbation",
        "approvalFixed": "Annuler jusqu'au début pour {amount}, avec approbation",
        "notAllowed": "Vous ne pouvez pas annuler vous-même"
      },
      "before": {
        "selfFree": "Annulation gratuite jusqu'au {date} inclus",
        "selfFixed": "L'annulation jusqu'au {date} inclus coûte {amount}",
        "approvalFree": "Annuler jusqu'au {date} inclus, avec approbation",
        "approvalFixed": "Annuler jusqu'au {date} inclus pour {amount}, avec approbation",
        "notAllowed": "Pas d'annulation jusqu'au {date} inclus"
      },
      "after": {
        "selfFree": "ensuite gratuite",
        "selfFixed": "ensuite {amount}",
        "approvalFree": "ensuite annuler, avec approbation",
        "approvalFixed": "ensuite annuler pour {amount}, avec approbation",
        "notAllowed": "ensuite, plus d'annulation possible"
      },
      "combined": "{before}, {after}"
    },
    "window": {
      "before": "Vous annulez avant la date limite d'annulation ({date}).",
      "after": "La date limite d'annulation ({date}) est dépassée.",
      "costNow": "L'annulation coûte maintenant {amount}.",
      "free": "L'annulation est actuellement gratuite.",
      "followsRequest": "Votre demande doit encore être examinée. Ces frais s'appliquent aussi si la décision est prise plus tard."
    }
  },
  "contentLanguages": {
    "intro": "Les langues dans lesquelles vous pouvez proposer des formations, leur matériel et leurs sessions. Elles sont indépendantes des langues du système lui-même.",
    "legend": "Langues de contenu",
    "legendHelp": "Une formation a ses textes par langue de contenu, une session est donnée dans l’une de ces langues et le matériel peut varier selon la langue. Le filtre de langue du catalogue affiche ces langues.",
    "pick": "Langues",
    "pickPlaceholder": "Rechercher une langue…",
    "default": "Langue de contenu par défaut",
    "defaultHelp": "Vous rédigez d’abord une formation dans cette langue ; les autres langues sont des traductions. Quiconque utilise le système dans une langue qui n’est pas une langue de contenu reçoit celle-ci. Si vous choisissez une autre langue par défaut, les textes existants dans la langue par défaut compteront désormais comme des textes dans la nouvelle.",
    "interface": "Langues du système, définies par BCS : {languages}.",
    "required": "Choisissez au moins une langue de contenu.",
    "saved": "Les langues de contenu ont été enregistrées.",
    "saveFailed": "L’enregistrement a échoué. Veuillez réessayer.",
    "defaultCannotBeRemoved": "Vous ne pouvez pas supprimer la langue de contenu par défaut. Choisissez d’abord une autre langue par défaut et enregistrez-la.",
    "removeConfirm": {
      "title": "Supprimer la langue de contenu ?",
      "body": "Après l’enregistrement, la langue disparaît des onglets de texte et du catalogue.",
      "used": "{language} : {activities}, {occurrences} et {questionnaires}.",
      "unused": "{language} : aucun contenu n’existe encore dans cette langue.",
      "activities_one": "{count} activité",
      "activities_other": "{count} activités",
      "occurrences_one": "{count} session",
      "occurrences_other": "{count} sessions",
      "questionnaires_one": "{count} questionnaire",
      "questionnaires_other": "{count} questionnaires",
      "kept": "Les textes sont conservés : si vous réactivez la langue plus tard, ils réapparaissent.",
      "countFailed": "Le nombre n’a pas pu être chargé. Vous pouvez tout de même continuer ; les textes sont conservés.",
      "confirm": "Supprimer et enregistrer"
    }
  },
  "documentSettings": {
    "heading": "Certificats",
    "intro": "Comment commence le numéro de certificat. Une activité ne reçoit un certificat que lorsque vous lui choisissez un modèle.",
    "saveFailed": "L'enregistrement a échoué.",
    "saved": "Enregistré.",
    "prefix": "Préfixe du numéro de certificat",
    "prefixHelp": "Le début de chaque numéro de certificat, par exemple ACME dans ACME-2026-000123. Vide signifie le nom court de l'environnement. Un nouveau préfixe ne s'applique qu'aux nouveaux certificats.",
    "prefixExample": "Voici à quoi ressemble un numéro : {number}",
    "showPlatformTemplates": "Afficher les modèles BCS",
    "showPlatformTemplatesHelp": "BCS fournit des modèles d'exemple. Si vous les masquez, ils disparaissent des listes ; là où l'un d'eux est déjà choisi, il continue à créer des certificats.",
    "platformTemplatesOff": "BCS a désactivé les modèles BCS pour cet environnement : aucune nouvelle copie BCS ne sera ajoutée.",
    "toLibrary": "Gérer les modèles"
  },
  "certificates": {
    "failed": {
      "title": "Certificats qui n'ont pas pu être créés",
      "intro": "Corrigez les données ou le modèle, puis cliquez sur Réessayer. La réussite elle-même est maintenue ; entre-temps, le participant voit que le certificat est en cours de création.",
      "retry": "Réessayer",
      "retried": "Le certificat est en cours de création.",
      "retryFailed": "La nouvelle tentative a échoué.",
      "emptyTitle": "Tout est fait",
      "emptyText": "Aucun certificat n'a échoué.",
      "fix": {
        "user": "Voir la personne",
        "template": "Voir le modèle",
        "activity": "Voir la formation"
      }
    },
    "failure": {
      "renderer_unavailable": "La création du PDF n'était pas disponible.",
      "timed_out": "La création du PDF a pris trop de temps.",
      "warnings": "Le modèle a donné un avertissement lors de la création.",
      "compile_error": "Le modèle n'a pas pu être traité.",
      "required_token_empty": "Une donnée obligatoire manque, par exemple le nom du participant.",
      "unknown_field": "Le modèle utilise une donnée qui n’existe plus, par exemple un niveau supprimé de l’organisation.",
      "does_not_fit": "Un texte ne tient pas sur le certificat, même dans la plus petite taille de police.",
      "output_invalid": "Le PDF créé n'était pas valide.",
      "source_rejected": "Le modèle contient quelque chose qui n'est pas autorisé.",
      "workspace_unsafe": "Le dossier de travail pour la création n'était pas sûr."
    }
  },
  "documentTemplates": {
    "title": "Modèles de documents",
    "intro": "Les modèles de certificat de cet environnement, y compris les modèles BCS : l’environnement en a reçu sa propre copie. Chaque publication crée une nouvelle version ; les anciennes versions restent consultables et restaurables.",
    "showArchived": "Afficher les archivés",
    "platformOff": "Les modèles BCS sont désactivés dans cet environnement.",
    "toSettings": "Vers les paramètres",
    "copyFailed": "La copie n’a pas pu être créée.",
    "emptyTitle": "Pas encore de modèles",
    "emptyText": "Activez les modèles BCS dans les paramètres, ou demandez un modèle à l’administrateur.",
    "bcs": "BCS",
    "archived": "Archivé",
    "archivedInUse": "Archivé et encore choisi : des certificats sont encore créés avec ce modèle.",
    "view": "Voir",
    "adjust": "Adapter",
    "edit": "Modifier",
    "archive": "Archiver",
    "restore": "Restaurer",
    "archiveTitle": "Archiver {name} ?",
    "archiveInUse": "{usage}. Il continue d’y créer des certificats ; il n’est simplement plus proposé pour un nouveau choix.",
    "archiveUnused": "Le modèle n’est choisi nulle part. Après l’archivage, il n’est plus proposé ; vous pouvez le restaurer.",
    "archiveFailed": "L’archivage a échoué.",
    "copyName": "Copie de {name}",
    "usage": {
      "none": "Choisi nulle part",
      "activities_one": "{count} formation",
      "activities_other": "{count} formations",
      "occurrences_one": "{count} session",
      "occurrences_other": "{count} sessions",
      "line": "Choisi pour {parts}",
      "paths_one": "{count} parcours",
      "paths_other": "{count} parcours"
    },
    "back": "Retour aux modèles",
    "noPresetEditor": "Ce modèle n’a pas de mise en page prête à adapter ici.",
    "platformReadOnly": "Un modèle de BCS. Vous pouvez le consulter ; pour l’adapter, créez votre propre copie.",
    "archivedNotice": "Ce modèle est archivé. Là où il est déjà choisi, il crée encore des certificats.",
    "section": {
      "general": "Général",
      "logo": "Logo",
      "colors": "Couleurs",
      "texts": "Textes"
    },
    "name": "Nom",
    "logo": {
      "label": "Logo",
      "bcs": "Logo de BCS",
      "tenant": "Logo de l’environnement",
      "none": "Pas de logo",
      "noTenantLogo": "Cet environnement n’a pas encore de logo dans son identité visuelle.",
      "upload": "Logo personnalisé",
      "file": "Fichier",
      "fileHint": "PNG ou JPG.",
      "uploaded": "Logo téléversé",
      "uploadFailed": "Le logo n’a pas pu être téléversé."
    },
    "colors": {
      "ink": "Couleur du texte",
      "accent": "Couleur d’accent",
      "hint": "Vide = la couleur du modèle. Le texte doit avoir un contraste suffisant avec le blanc."
    },
    "texts": {
      "hint": "Vide = le texte du modèle (en gris dans le champ).",
      "tabWithErrors_one": "{locale} · {count} erreur",
      "tabWithErrors_other": "{locale} · {count} erreurs"
    },
    "elements": {
      "heading": "Titre",
      "intro": "Introduction",
      "holder": "Nom du participant",
      "between": "Ligne intermédiaire",
      "training": "Formation",
      "date_line": "Date et numéro",
      "issuer": "Émetteur"
    },
    "preview": {
      "title": "Aperçu",
      "long": "Valeurs longues",
      "loading": "Création de l’aperçu…",
      "updated": "L’aperçu a été mis à jour.",
      "invalid": "Corrigez d’abord les erreurs du formulaire.",
      "invalidListed": "L’aperçu apparaît dès que les erreurs listées avec le formulaire sont corrigées.",
      "frameTitle": "Aperçu : {title}",
      "download": "Télécharger l’aperçu (PDF)",
      "fileName": "apercu",
      "busy": "De nombreux aperçus sont en cours de création. Réessayez dans un instant.",
      "concept": "Aperçu du brouillon",
      "version": "Aperçu de la version {version}",
      "notPdf": "L’aperçu n’est pas revenu sous forme de PDF et n’est pas affiché."
    },
    "tags": {
      "title": "Insérer des balises"
    },
    "unpublished": "Non publié",
    "concept": "Brouillon",
    "version": "Version {version}",
    "kind": {
      "label": "Type",
      "general": "Général",
      "classroom": "Présentiel",
      "learning_path": "Parcours",
      "hint": "Fixé à la création. Le présentiel peut nommer le formateur, le lieu et les dates (uniquement pour une formation avec des sessions) ; le parcours, les parties terminées (uniquement pour un parcours).",
      "help": "Le présentiel peut nommer le formateur, le lieu et les dates (uniquement pour une formation avec des sessions) ; le parcours, les parties terminées (uniquement pour un parcours)."
    },
    "orientation": {
      "landscape": "Paysage",
      "portrait": "Portrait"
    },
    "adjustTitle": "Adapter {name}",
    "adjustBody": "Vous créez votre propre copie, sur la version actuelle. Le modèle BCS lui-même ne change pas.",
    "adjustConfirm": "Créer une copie",
    "state": {
      "unpublished": "Pas encore publié : ce modèle ne peut être choisi nulle part.",
      "concept": "Un brouillon est en attente. Les certificats utilisent la version publiée jusqu’à ce que vous publiiez.",
      "live": "Publié. Pour créer une nouvelle version, publiez un brouillon."
    },
    "notice": {
      "saved": "Brouillon enregistré.",
      "published": "Publié. Les nouveaux certificats utilisent cette version.",
      "discarded": "Brouillon supprimé.",
      "renamed": "Le nom a été enregistré.",
      "restored": "La version {version} est dans le brouillon. La version publiée ne change que lorsque vous publiez."
    },
    "failed": {
      "save": "L’enregistrement a échoué.",
      "publish": "La publication a échoué.",
      "upload": "Le logo n’a pas pu être téléversé."
    },
    "publishBlocked": "Ceci ne peut pas encore être publié :",
    "previewBlocked": "L’aperçu ne peut pas encore être créé :",
    "saveConcept": "Enregistrer le brouillon",
    "publish": "Publier",
    "publishTitle": "Publier {name} ?",
    "publishBody": "{usage}. Les nouveaux certificats utilisent désormais cette version ; les certificats déjà délivrés ne changent pas.",
    "discard": "Supprimer le brouillon",
    "discardTitle": "Supprimer le brouillon ?",
    "discardBody": "La page affiche ensuite à nouveau la version publiée. Cette action est irréversible.",
    "update": {
      "noneTitle": "Aucune nouvelle version",
      "noneText": "Aucune nouvelle version n’est en attente pour ce modèle.",
      "templates_one": "{count} modèle personnalisé",
      "templates_other": "{count} modèles personnalisés",
      "title": "Nouvelle version de {name}",
      "intro": "BCS a publié la version {to}. Tant que vous ne l’adoptez pas, les nouveaux certificats restent sur l’ancienne version.",
      "unchanged": "Les certificats déjà délivrés ne changent pas, quel que soit votre choix.",
      "failed": {
        "conflict": "Une version plus récente est apparue entre-temps. La page l’affiche maintenant.",
        "busy": "De nombreux certificats sont en cours de contrôle. Réessayez dans un instant.",
        "other": "Cela n’a pas fonctionné."
      },
      "old": "Actuelle : version {version}",
      "new": "Nouvelle : version {version}",
      "dismiss": "Pas maintenant",
      "accept": "Adopter",
      "appliesTo": "S’applique à {parts}.",
      "partial": "{moved} modèles personnalisés adoptés, {skipped} non : ils ne passent pas les contrôles sur la nouvelle version."
    },
    "logoUpdate": {
      "noneTitle": "Aucun nouveau logo",
      "noneText": "Le logo des certificats est celui de l’identité visuelle.",
      "title": {
        "changed": "Nouveau logo de l’environnement",
        "removed": "Logo de l’environnement supprimé"
      },
      "intro": {
        "changed": "Le logo de l’identité visuelle a été remplacé. Tant que vous ne l’adoptez pas, les nouveaux certificats gardent l’ancien.",
        "removed": "Le logo de l’identité visuelle a été supprimé. Les certificats gardent l’ancien logo jusqu’à ce que vous choisissiez « aucun logo » ; choisissez un autre logo dans le modèle."
      },
      "appliesTo_one": "S’applique à {count} modèle avec le logo de l’environnement.",
      "appliesTo_other": "S’applique à {count} modèles avec le logo de l’environnement.",
      "old": "Actuel",
      "new": "Nouveau",
      "accept": {
        "changed": "Adopter",
        "removed": "Plus de logo"
      }
    },
    "open": "Ouvrir",
    "copy": "Copier",
    "fromBcs": "De BCS",
    "rename": "Enregistrer le nom",
    "copyTitle": "Copier {name}",
    "copyBody": "Un nouveau modèle avec le même contenu. Il n’est pas encore publié ; le type est fixé une fois le modèle créé.",
    "copyConfirm": "Créer la copie",
    "originLine": "Copie de {name}, fournie par BCS.",
    "editorComing": "Vous modifierez le contenu d’un modèle dans le nouvel éditeur. D’ici là, vous pouvez consulter, restaurer, publier et copier des versions ici.",
    "history": {
      "title": "Historique",
      "empty": "Aucune version pour l’instant : ce modèle n’a jamais été publié.",
      "caption": "Les versions de {name}",
      "version": "Version",
      "when": "Publiée",
      "who": "Par",
      "actions": "Actions",
      "live": "Publiée",
      "bcs": "BCS (version {version})",
      "unknown": "Inconnu",
      "view": "Voir",
      "restore": "Restaurer",
      "viewing": "Vous consultez la version {version}.",
      "restoreTitle": "Restaurer la version {version} ?",
      "restoreBody": "Cette version passe dans le brouillon. La version publiée ne change que lorsque vous publiez le brouillon.",
      "restoreOverConcept": "Cette version remplace le brouillon actuel. La version publiée ne change que lorsque vous publiez."
    },
    "bcsUpdate": {
      "acceptNotice": "BCS a publié la version {to} de ce modèle. Vous ne l’avez pas modifié : vous pouvez donc la reprendre telle quelle.",
      "review": "Voir et reprendre",
      "fetchNotice": "BCS a publié la version {to} de ce modèle. Vous l’avez modifié vous-même : Récupérer place la nouvelle version dans le brouillon, et vous décidez de ce qui est publié.",
      "fetch": "Récupérer",
      "fetchTitle": "Récupérer la version {to} de BCS ?",
      "fetchOverConcept": "La nouvelle version de BCS remplace le brouillon actuel. La version publiée ne change que lorsque vous publiez.",
      "fetched": "La nouvelle version de BCS est dans le brouillon. La version publiée ne change que lorsque vous publiez.",
      "dismissed": "Le modèle reste tel quel. Vous verrez de nouveau ceci à la prochaine version de BCS.",
      "conceptFrom": "Le brouillon contient la version {version} de BCS.",
      "intro": "BCS a publié la version {to}. Tant que vous ne la reprenez pas, les nouveaux certificats restent tels qu’ils sont.",
      "old": "Publiée actuellement : version {version}",
      "new": "Nouvelle : version {version} de BCS"
    },
    "types": {
      "certificate": "Certificats",
      "agreement": "Conventions"
    },
    "typeLabel": {
      "agreement": "Convention"
    },
    "agreementsEmptyTitle": "Pas encore de conventions",
    "agreementsEmptyText": "Commencez un modèle de convention en copiant l’exemple de BCS.",
    "regenerate": {
      "count_one": "{count} certificat délivré avec cette version",
      "count_other": "{count} certificats délivrés avec cette version",
      "button": "Régénérer",
      "title": "Régénérer les certificats de la version {version} ?",
      "body": "Chaque certificat garde son numéro et reçoit une nouvelle version avec le modèle et les données actuels. L’ancienne version est conservée.",
      "confirm": "Régénérer",
      "fromTo_one": "De la version {from} à la version {to} : {count} certificat.",
      "fromTo_other": "De la version {from} à la version {to} : {count} certificats.",
      "unchanged": "Rien ne change dans le modèle : c’est la version en ligne. Seules les données modifiées (comme un nom) sont reprises.",
      "sameFields": "Les mêmes champs ; la mise en page ou le texte du modèle peuvent différer.",
      "fieldAdded": "Ajouté : {field}",
      "fieldRemoved": "Retiré : {field}",
      "reason": "Motif",
      "reasonTooShort": "Au moins {min} caractères.",
      "previewFailed": "Impossible de charger ce qui change.",
      "failed": "La régénération n’a pas démarré.",
      "throttled": "Trop de tentatives : réessayez dans une minute.",
      "nothingQueued": "Rien à régénérer : ces certificats sont déjà en file d’attente.",
      "queued_one": "{count} certificat est en attente de régénération.",
      "queued_other": "{count} certificats sont en attente de régénération.",
      "progress": "Régénération, {handled} sur {total} : {counts}.",
      "done": "Terminé : {counts}.",
      "counts": {
        "regenerated_one": "{count} régénéré",
        "regenerated_other": "{count} régénérés",
        "unchanged_one": "{count} inchangé",
        "unchanged_other": "{count} inchangés",
        "failed_one": "{count} échoué",
        "failed_other": "{count} échoués",
        "skipped_one": "{count} ignoré",
        "skipped_other": "{count} ignorés"
      },
      "toFailed": "Vers les certificats échoués"
    }
  },
  "documentEditor": {
    "title": "Modifier le modèle",
    "back": "Retour au modèle",
    "loadError": "Le modèle n’a pas pu être chargé.",
    "name": "Nom",
    "nameTooLong": "{max} caractères au maximum.",
    "neverPublished": "Brouillon, pas encore publié",
    "liveVersion": "En ligne : version {version}",
    "unsavedShort": "modifications non enregistrées",
    "conceptSaved": "brouillon enregistré",
    "saveConcept": "Enregistrer le brouillon",
    "publish": "Publier",
    "saved": "Le brouillon a été enregistré.",
    "published": "Publié comme version {version}.",
    "unsaved": "Certaines modifications ne sont pas encore enregistrées. Quitter quand même ?",
    "busy": "Le serveur est occupé. Veuillez réessayer dans un instant.",
    "throttled_one": "Un instant : il y a eu beaucoup d’enregistrements en peu de temps. L’éditeur réessaiera dans {count} seconde ; vous pouvez continuer à travailler.",
    "throttled_other": "Un instant : il y a eu beaucoup d’enregistrements en peu de temps. L’éditeur réessaiera dans {count} secondes ; vous pouvez continuer à travailler.",
    "throttledFailed": "L’enregistrement est impossible pour le moment : trop d’enregistrements d’affilée. Vos modifications sont toujours là ; réessayez dans une minute.",
    "failed": "Cela n’a pas fonctionné. Veuillez réessayer.",
    "errorsTitle_one": "{count} point à corriger",
    "errorsTitle_other": "{count} points à corriger",
    "publishConfirm": {
      "title": "Publier ce brouillon ?",
      "body": "Le brouillon devient la nouvelle version. Les nouveaux certificats utilisent désormais cette version ; les certificats déjà délivrés ne changent pas."
    },
    "locale": {
      "nl": "Néerlandais",
      "en": "Anglais",
      "de": "Allemand",
      "fr": "Français"
    },
    "page": {
      "landscape": "Page, A4 paysage",
      "portrait": "Page, A4 portrait"
    },
    "flow": {
      "label": "Texte courant ({language})",
      "copyOfDutch": "Cette langue n’a pas encore de texte propre et affiche le néerlandais. Dès que vous modifiez quelque chose, cette langue obtient son propre texte.",
      "rejected": "Le texte courant dans cette langue contient un élément que l’éditeur ne connaît pas ; il n’est donc ni affiché ni modifié. À l’enregistrement, le serveur indique ce qui ne va pas."
    },
    "flowStart": {
      "label": "Début du texte courant (mm)",
      "valueText": "{mm} mm sous la marge supérieure",
      "hint": "Sous la marge supérieure, de 0 à {max}."
    },
    "fields": {
      "heading": "Champs",
      "hint": "Faites glisser un champ dans le texte, ou cliquez pour l’insérer à l’emplacement du curseur.",
      "error": "Les champs n’ont pas pu être chargés.",
      "empty": "Il n’y a pas de champs pour ce type.",
      "kind": {
        "general": "Général",
        "classroom": "Présentiel",
        "learning_path": "Parcours"
      },
      "scope": {
        "org": "Organisation",
        "context": "Achèvement",
        "global": "Général",
        "link": "Liens"
      }
    },
    "grid": {
      "group": "Grille",
      "show": "Grille",
      "snap": "Aligner sur la grille",
      "snapHint": "Le déplacement et le redimensionnement s’alignent sur les lignes de 5 mm, et les bords et le centre sur les lignes médianes. Alt déplace librement."
    },
    "history": {
      "group": "Historique",
      "undo": "Annuler",
      "redo": "Rétablir",
      "undoShortcut": "Annuler (Ctrl+Z)",
      "redoShortcut": "Rétablir (Ctrl+Y)",
      "undone": "Annulé : {action}",
      "redone": "Rétabli : {action}",
      "kind": {
        "move": "déplacement",
        "resize": "taille",
        "add": "ajout de bloc",
        "remove": "suppression de bloc",
        "style": "mise en forme",
        "text": "texte",
        "orientation": "orientation",
        "reading": "ordre de lecture",
        "flowStart": "début du texte courant",
        "background": "arrière-plan",
        "title": "titre du document",
        "image": "image",
        "furniture": "en-tête et pied de page",
        "numbering": "numérotation"
      }
    },
    "toolbar": {
      "label": "Mise en forme",
      "blockType": "Type de texte",
      "paragraph": "Paragraphe",
      "heading": "Titre {level}",
      "bold": "Gras",
      "italic": "Italique",
      "underline": "Souligné",
      "bulletList": "Liste à puces",
      "orderedList": "Liste numérotée",
      "alignLeft": "Aligner à gauche",
      "alignCenter": "Centrer",
      "alignRight": "Aligner à droite",
      "alignment": "Alignement",
      "quick": "Mise en forme rapide"
    },
    "table": {
      "insertTitle": "Insérer un tableau",
      "rows": "Lignes",
      "cols": "Colonnes",
      "headerRow": "Ligne d’en-tête",
      "insert": "Insérer",
      "toolbar": "Tableau",
      "rowBefore": "Ligne au-dessus",
      "rowAfter": "Ligne en dessous",
      "colBefore": "Colonne à gauche",
      "colAfter": "Colonne à droite",
      "toggleHeader": "Ligne d’en-tête oui/non",
      "deleteRow": "Supprimer la ligne",
      "deleteCol": "Supprimer la colonne",
      "delete": "Supprimer le tableau"
    },
    "blocks": {
      "kind": {
        "text": "Bloc de texte {n}",
        "image": "Image {n}",
        "rect": "Rectangle {n}",
        "line": "Ligne {n}"
      },
      "textLabel": "{block}, texte ({language})",
      "movedTo": "{block} : {x} mm depuis la gauche, {y} mm depuis le haut.",
      "frameHint": "Les flèches déplacent le bloc de 1 mm, Maj+flèche de 10 mm. Suppr le retire. Tab permet d’entrer dans le texte pour le modifier.",
      "image": {
        "bcs-logo": "Logo BCS",
        "tenant-logo": "Logo de l’environnement",
        "upload": "Image personnelle",
        "library": "De la médiathèque",
        "platform": "De l’ensemble fourni"
      },
      "removed": "Le bloc a été supprimé.",
      "addLabel": "Ajouter",
      "add_text": "Bloc de texte",
      "add_image": "Image",
      "add_rect": "Rectangle",
      "add_line": "Ligne",
      "add_table": "Tableau",
      "describe": {
        "text": "Un cadre de texte que vous placez librement sur la page, par exemple pour le titre ou le nom. Vous pouvez y faire glisser des champs.",
        "image": "Un logo, une signature ou une autre image de la médiathèque, placé librement sur la page.",
        "rect": "Un rectangle, par exemple comme cadre autour de la page. Uniquement décoratif.",
        "line": "Une ligne, par exemple pour signer ou comme séparateur. Uniquement décorative.",
        "table": "Un tableau dans le texte courant, à l’emplacement du curseur, par exemple pour une rangée de signatures.",
        "pageBreak": "Ce qui suit le curseur commence sur une nouvelle page.",
        "ref": "Un renvoi vers un titre numéroté ; le numéro suit."
      },
      "rejected": "Ce texte contient un élément que l’éditeur ne connaît pas.",
      "add_pageBreak": "Saut de page",
      "add_ref": "Renvoi",
      "skipped_one": "{count} bloc ne peut pas être affiché (il a été enregistré endommagé) et a été omis. Il disparaîtra à l’enregistrement.",
      "skipped_other": "{count} blocs ne peuvent pas être affichés (ils ont été enregistrés endommagés) et ont été omis. Ils disparaîtront à l’enregistrement."
    },
    "inspector": {
      "remove": "Supprimer",
      "position": "Position et taille",
      "x": "Depuis la gauche (mm)",
      "y": "Depuis le haut (mm)",
      "width": "Largeur (mm)",
      "height": "Hauteur (mm)",
      "textStyle": "Texte",
      "role": "Type",
      "size": "Taille (pt)",
      "weight": "Graisse",
      "regular": "Normal",
      "align": "Alignement",
      "color": "Couleur",
      "colorFormat": "Une couleur au format #RRGGBB.",
      "image": "Image",
      "source": "Source",
      "layer": "Plan",
      "layerOnlyDecorative": "Seule une image décorative peut se trouver derrière le texte.",
      "front": "Devant le texte",
      "back": "Derrière le texte",
      "decorative": "Décorative (un lecteur d’écran l’ignore)",
      "alt": "Texte alternatif ({language})",
      "shape": "Forme",
      "direction": "Direction",
      "horizontal": "Horizontale",
      "vertical": "Verticale",
      "stroke": "Épaisseur du trait (mm)",
      "strokeColor": "Couleur du trait",
      "fill": "Remplissage",
      "fillColor": "Couleur de remplissage",
      "problems": "Pour ce bloc",
      "noneHeading": "Aucun bloc sélectionné",
      "none": "Choisissez un bloc sur la page ou dans l’ordre de lecture pour voir sa position, sa taille et son style.",
      "pickImage": "Choisir dans la médiathèque…",
      "valign": "Vertical",
      "valign_top": "Aligner en haut",
      "valign_middle": "Aligner au milieu",
      "valign_bottom": "Aligner en bas"
    },
    "reading": {
      "hint": "Un lecteur d’écran lit la page dans cet ordre.",
      "flow": "Texte courant",
      "up": "Monter {name}",
      "down": "Descendre {name}",
      "reset": "Ordre par défaut",
      "toggle": "Ordre de lecture ({count})",
      "moved": "{name} est maintenant en position {position} sur {count}."
    },
    "checks": {
      "heading": "Contrôles",
      "none": "Aucun problème trouvé. L’aperçu contrôle le reste.",
      "severity": {
        "error": "Erreur",
        "warning": "Attention"
      },
      "outside_margin": "Se trouve hors de la marge de {margin} mm.",
      "text_too_small": "Le texte est plus petit que {min} pt.",
      "text_small": "Le texte est plus petit que {warn} pt et donc difficile à lire.",
      "overlap": "Chevauche {other}.",
      "low_contrast": "La couleur du texte n’a pas assez de contraste sur blanc ({ratio}:1, au moins 4,5:1).",
      "heading_first": "Le premier titre doit être un titre 1, pas un titre {level}.",
      "heading_skip": "Le titre {level} saute un niveau ; titre {expected} attendu.",
      "alt_missing": "Il n’y a pas de texte alternatif en néerlandais.",
      "background_readability": "Vérifiez dans l’aperçu que tout le texte est bien lisible sur l’arrière-plan.",
      "server": "Lors du dernier enregistrement",
      "ref_missing": "Un renvoi pointe vers un titre qui n’existe pas ou n’est pas numéroté.",
      "image_low_resolution": "Cette image est trop petite pour cette taille : {dpi} dpi sur papier, au moins {min}. Utilisez une image d’au moins {min_width} × {min_height} pixels.",
      "many_pages": "L’aperçu compte {pages} pages ; plus de 20, c’est long pour une convention."
    },
    "background": {
      "label": "Arrière-plan",
      "placeholder": "Arrière-plan",
      "none": "Aucun arrière-plan.",
      "current": "Actuellement : {source}.",
      "pick": "Choisir dans la médiathèque…",
      "remove": "Aucun arrière-plan"
    },
    "preview": {
      "heading": "Aperçu",
      "long": "Nom long",
      "loading": "L’aperçu est en cours de création…",
      "updated": "L’aperçu a été mis à jour.",
      "updatedLong": "L’aperçu a été mis à jour, avec un nom long.",
      "failedStatus": "L’aperçu n’a pas pu être créé.",
      "invalid": "L’aperçu attend les points de la liste en haut.",
      "failed": "L’aperçu n’a pas pu être créé.",
      "frameTitle": "Aperçu de {title} ({language})",
      "download": "Télécharger l’aperçu (PDF)",
      "fileName": "apercu",
      "notPdf": "L’aperçu n’est pas revenu sous forme de PDF et n’est pas affiché."
    },
    "pdfTitle": {
      "label": "Titre du document ({language})",
      "hint": "Figure dans les propriétés du PDF ; un lecteur d’écran le lit à voix haute."
    },
    "edit": "Modifier",
    "orientation": {
      "label": "Orientation",
      "landscape": "Paysage",
      "portrait": "Portrait",
      "moved": "Vérifiez les blocs ; ils ont été déplacés.",
      "undo": "Annuler (Ctrl+Z) le rétablit. Cela ne modifie que le brouillon."
    },
    "text": {
      "heading": "Texte"
    },
    "pages": {
      "estimate": "{count} page(s). Les sauts de page sont une estimation ; l’aperçu ci-dessous est le vrai.",
      "real": "L’aperçu en a {count}."
    },
    "furniture": {
      "heading": "En-tête et pied de page",
      "header": "En-tête",
      "footer": "Pied de page",
      "logo": "Logo",
      "logoNone": "Pas de logo",
      "logoPosition": "Position du logo",
      "logoHeight": "Hauteur maximale (mm)",
      "logoHeightRange": "Entre {min} et {max} mm.",
      "headerText": "Texte de l’en-tête ({language})",
      "footerText": "Texte du pied de page ({language})",
      "firstPageDifferent": "Première page différente (l’en-tête commence à la page 2)",
      "pageNumbers": "Page x sur y figure toujours à côté.",
      "pageOf": "Page {page} sur {pages}",
      "position": {
        "left": "À gauche",
        "center": "Au centre",
        "right": "À droite"
      }
    },
    "pageBreaks": {
      "legend": "Page",
      "breakBefore": "Commencer sur une nouvelle page",
      "keepTogether": "Garder ensemble",
      "node": "Saut de page",
      "nested": "Impossible dans une liste ou un tableau ; seulement sur un bloc du texte courant lui-même."
    },
    "numbering": {
      "heading": "Numérotation",
      "style": "Style des titres numérotés",
      "none": "Pas de numérotation",
      "artikel": "Article 1, Article 1.1",
      "decimal": "1., 1.1",
      "hint": "Choisissez les titres qui comptent avec Numéroté dans le panneau Texte.",
      "article": "Article",
      "articleInText": "article",
      "numbered": "Numéroté",
      "refTitle": "Renvoyer à",
      "refNone": "Il n’y a pas encore de titre numéroté. Choisissez une numérotation et activez Numéroté pour un titre."
    }
  }
}
